if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.uploadBlock = this.querySelector('.custom-upload-block');
        this.uploadInput = this.querySelector('[id^="artwork-upload-"]');
        this.uploadTokenInput = this.querySelector('[id^="upload-token-"]');
        this.uploadFilenameInput = this.querySelector('[id^="upload-filename-"]');
        this.uploadObjectKeyInput = this.querySelector('[id^="upload-object-key-"]');
        this.uploadSessionIdInput = this.querySelector('[id^="upload-session-id-"]');
        this.uploadZipUrlInput = this.querySelector('[id^="upload-zip-url-"]');
        this.uploadPreviewUrlInput = this.querySelector('[id^="upload-preview-url-"]');
        this.uploadStatus = this.querySelector('[id^="upload-status-"]');
        this.uploadFileList = this.querySelector('[id^="upload-file-list-"]');
        this.artworkBuilderAfterUpload = this.querySelector('.artwork-builder__after-upload');
        this.clearArtworkButton = this.querySelector('.artwork-clear-button');
        this.artworkNotes = this.querySelector('.custom-upload-notes');
        this.artworkPreview = this.querySelector('[id^="artwork-preview-"]');
        this.artworkPreviewGrid = this.artworkPreview?.querySelector('.artwork-preview__grid');
        this.borderOptions = Array.from(this.querySelectorAll('input[name="properties[Border]"]'));
        this.borderColourContainer = this.querySelector('.artwork-border-colour');
        this.borderColourPicker = this.querySelector('.artwork-border-colour__picker');
        this.borderColourHex = this.querySelector('.artwork-border-colour__hex');
        this.borderColourProperty = this.querySelector('.artwork-border-colour__property');
        this.previewType = this.uploadBlock?.dataset.previewType || 'generic';
        this.swingTagBackUploadInput = this.querySelector('.stg-reverse-upload-input');
        this.swingTagFileInputs = Array.from(this.querySelectorAll('input[data-stg-side]'));
        this.swingTagBackPanel = this.querySelector('[data-stg-back-panel]');
        this.swingTagFiles = { front: null, back: null };
        this.swingTagPreviewUrls = { front: '', back: '' };
        this.swingTagPreviews = {
          front: {
            container: this.querySelector('[data-stg-preview-container="front"]'),
            image: this.querySelector('[data-stg-preview-image="front"]'),
            fallback: this.querySelector('[data-stg-preview-placeholder="front"]'),
            type: this.querySelector('[data-stg-preview-type="front"]'),
          },
          back: {
            container: this.querySelector('[data-stg-preview-container="back"]'),
            image: this.querySelector('[data-stg-preview-image="back"]'),
            fallback: this.querySelector('[data-stg-preview-placeholder="back"]'),
            type: this.querySelector('[data-stg-preview-type="back"]'),
          },
        };
        this.swingTagArtworkIds = { front: '', back: '' };
        this.swingTagFileNames = {
          front: this.querySelector('[data-stg-file-name="front"]'),
          back: this.querySelector('[data-stg-file-name="back"]'),
        };
        this.swingTagClearButtons = Array.from(this.querySelectorAll('[data-stg-clear-side]'));
        this.swingTagMyArtworkButtons = Array.from(this.querySelectorAll('[data-stg-my-artwork]'));
        this.swingTagProperties = {
          file: {
            front: this.querySelector('[data-stg-property-file="front"]'),
            back: this.querySelector('[data-stg-property-file="back"]'),
          },
          token: {
            front: this.querySelector('[data-stg-property-token="front"]'),
            back: this.querySelector('[data-stg-property-token="back"]'),
          },
          key: {
            front: this.querySelector('[data-stg-property-key="front"]'),
            back: this.querySelector('[data-stg-property-key="back"]'),
          },
        };
        this.swingTagSidesProperty = Array.from(document.querySelectorAll('input[name="properties[Print sides]"]')).find((input) => input.form === this.form) || null;
        this.swingTagUploadSignature = '';
        this.flagProfile = this.uploadBlock?.dataset.flagProfile || this.uploadBlock?.dataset.productHandle || '';
        this.flagFixedSize = this.uploadBlock?.dataset.flagFixedSize || '';
        this.flagPackageEnabled = this.uploadBlock?.dataset.flagPackageEnabled === 'true';
        this.segPreviewEnabled = this.uploadBlock?.dataset.segPreviewEnabled === 'true';

        this.flagMaker = this.querySelector('.flag-maker');
        this.flagCanvas = this.querySelector('.flag-preview__canvas');
        this.flagFileSummary = this.querySelector('.flag-preview__file');
        this.flagFit = this.querySelector('.flag-maker__fit');
        this.flagZoom = this.querySelector('.flag-maker__zoom');
        this.flagZoomValue = this.querySelector('.flag-maker__zoom-value');
        this.flagReset = this.querySelector('.flag-maker__reset');
        this.flagGuide = this.querySelector('.flag-maker__guide');
        this.flagShapeValue = this.querySelector('.flag-maker__shape-value');
        this.flagDimensionsValue = this.querySelector('.flag-maker__dimensions-value');
        this.flagPpiValue = this.querySelector('.flag-maker__ppi-value');
        this.flagQualityValue = this.querySelector('.flag-maker__quality-value');
        this.flagAlert = this.querySelector('.flag-maker__alert');
        this.flagHint = this.querySelector('.flag-maker__hint');
        this.segLights = this.querySelector('.seg-maker__lights');
        this.segGlowColour = this.querySelector('.seg-maker__colour');
        this.segGlowIntensity = this.querySelector('.seg-maker__glow');
        this.segGlowValue = this.querySelector('.seg-maker__glow-value');
        this.flagProperties = {
          fit: this.querySelector('.flag-property--fit'),
          scale: this.querySelector('.flag-property--scale'),
          position: this.querySelector('.flag-property--position'),
          shape: this.querySelector('.flag-property--shape'),
          quality: this.querySelector('.flag-property--quality'),
          sides: this.querySelector('.flag-property--sides'),
          package: this.querySelector('.flag-property--package'),
          base: this.querySelector('.flag-property--base'),
          lighting: this.querySelector('.flag-property--lighting'),
        };
        this.flagImage = null;
        this.flagFile = null;
        this.flagZoomPercent = 100;
        this.flagOffsetX = 0;
        this.flagOffsetY = 0;
        this.flagDragState = null;
        this.flagImageLoadId = 0;
        this.flagLastRect = null;
        this.flagLastBox = null;
        this.flagReverseUploadInput = this.querySelector('.flag-reverse-upload-input');
        this.flagUseSameArtwork = this.querySelector('.flag-maker__same-artwork-input');
        this.flagSideControls = this.querySelector('.flag-maker__side-controls');
        this.flagSideTabs = Array.from(this.querySelectorAll('.flag-maker__side-tab'));
        this.flagReverseUpload = this.querySelector('.flag-maker__reverse-upload');
        this.flagReverseFileLabel = this.querySelector('.flag-maker__reverse-file');
        this.flagVariantSelects = Array.from(this.querySelectorAll('.flag-maker__variant-select'));
        this.flagQuantity = this.querySelector('.flag-maker__quantity');
        this.flagSelectionSummary = this.querySelector('.flag-maker__selection-summary');
        this.flagPrice = this.querySelector('.flag-maker__price');
        this.flagPackageOptions = Array.from(this.querySelectorAll('input[name^="flag-package-"]'));
        this.flagBasesPanel = this.querySelector('.flag-package__bases');
        this.flagBaseOptions = Array.from(this.querySelectorAll('input[name^="flag-base-"]'));
        this.flagXlBaseNote = this.querySelector('.flag-package__xl-base-note');
        this.flagPackageData = this.parseFlagPackageData();
        this.flagFiles = { front: null, reverse: null };
        this.flagImages = { front: null, reverse: null };
        this.flagSideStates = {
          front: { fit: 'cover', zoom: 100, x: 0, y: 0 },
          reverse: { fit: 'cover', zoom: 100, x: 0, y: 0 },
        };
        this.flagActiveSide = 'front';
        this.flagWasDoubleSided = false;

        this.arrangeFlagMakerLayout();

        this.productSectionRoot =
          document.getElementById(`MainProduct-${this.dataset.sectionId}`) || this.closest('product-info') || document;
        this.variantSelects = this.productSectionRoot.querySelector(
          `#variant-selects-${this.dataset.sectionId}, variant-selects`
        );
        this.numberStickerBox = this.querySelector('[data-number-sticker-box]');
        this.numberStickerBox?.addEventListener('change', (event) => {
          if (!event.target.matches?.('[data-number-sticker-select]')) return;
          event.target.setCustomValidity('');
          event.target.setAttribute('aria-invalid', 'false');
          this.syncNumberStickerValue();
        });
        this.updateNumberStickerField();

        this.greetingCardOptions = this.querySelector('[data-greeting-card-options]');
        this.updateGreetingCardFields();

        this.stickerSheetMaker = this.querySelector('.sticker-sheet-maker');
        this.stickerSheetModeOptions = Array.from(
          this.querySelectorAll('input[name^="sticker-sheet-mode-"]')
        );
        this.stickerSheetRepeatControls = this.querySelector('.sticker-sheet-maker__repeat-controls');
        this.stickerSheetCompleteControls = this.querySelector('.sticker-sheet-maker__complete-controls');
        this.stickerSheetSizeRange = this.querySelector('.sticker-sheet-maker__range');
        this.stickerSheetSizeNumber = this.querySelector('.sticker-sheet-maker__number');
        this.stickerSheetPanelOptions = Array.from(
          this.querySelectorAll('input[name^="sticker-sheet-panels-"]')
        );
        this.stickerSheetFit = this.querySelector('.sticker-sheet-maker__fit');
        this.stickerSheetZoom = this.querySelector('.sticker-sheet-maker__zoom');
        this.stickerSheetZoomValue = this.querySelector('.sticker-sheet-maker__zoom-value');
        this.stickerSheetResetPosition = this.querySelector('.sticker-sheet-maker__reset-position');
        this.stickerSheetGuideMode = this.querySelector('.sticker-sheet-maker__guide-mode');
        this.stickerSheetRemoveBackground = this.querySelector('.sticker-sheet-maker__remove-background');
        this.stickerSheetTolerance = this.querySelector('.sticker-sheet-maker__tolerance');
        this.stickerSheetToleranceRange = this.querySelector('.sticker-sheet-maker__tolerance-range');
        this.stickerSheetToleranceValue = this.querySelector('.sticker-sheet-maker__tolerance-value');
        this.stickerSheetBackgroundModes = Array.from(this.querySelectorAll('.sticker-sheet-maker__background-mode'));
        this.stickerSheetBackgroundColourRow = this.querySelector('[data-sticker-sheet-background-colour-row]');
        this.stickerSheetBackgroundColour = this.querySelector('.sticker-sheet-maker__background-colour');
        this.stickerSheetPickBackground = this.querySelector('.sticker-sheet-maker__pick-background');
        this.stickerSheetBackgroundStatus = this.querySelector('.sticker-sheet-maker__background-status');
        this.stickerSheetCanvas = this.querySelector('.sticker-sheet-preview__canvas');
        this.stickerSheetStats = this.querySelector('.sticker-sheet-preview__stats');
        this.stickerSheetBuilderStats = this.querySelector('.sticker-sheet-maker__stats');
        this.stickerSheetLayoutValue = this.querySelector('.sticker-sheet-maker__layout-value');
        this.stickerSheetCountValue = this.querySelector('.sticker-sheet-maker__count-value');
        this.stickerSheetDpiValue = this.querySelector('.sticker-sheet-maker__dpi-value');
        this.stickerSheetQualityValue = this.querySelector('.sticker-sheet-maker__quality-value');
        this.stickerSheetDpiAlert = this.querySelector('.sticker-sheet-maker__dpi-alert');
        this.stickerSheetDpiMessage = this.querySelector('.sticker-sheet-maker__dpi-message');
        this.stickerSheetDpiAction = this.querySelector('.sticker-sheet-maker__dpi-action');
        this.stickerSheetProperties = {
          mode: this.querySelector('.sticker-sheet-property--mode'),
          size: this.querySelector('.sticker-sheet-property--size'),
          arrangement: this.querySelector('.sticker-sheet-property--arrangement'),
          quantity: this.querySelector('.sticker-sheet-property--quantity'),
          panels: this.querySelector('.sticker-sheet-property--panels'),
          guides: this.querySelector('.sticker-sheet-property--guides'),
          fit: this.querySelector('.sticker-sheet-property--fit'),
          zoom: this.querySelector('.sticker-sheet-property--zoom'),
          position: this.querySelector('.sticker-sheet-property--position'),
          quality: this.querySelector('.sticker-sheet-property--quality'),
          backgroundRemoval: this.querySelector('.sticker-sheet-property--background-removal'),
          backgroundTolerance: this.querySelector('.sticker-sheet-property--background-tolerance'),
          backgroundMode: this.querySelector('.sticker-sheet-property--background-mode'),
          backgroundColour: this.querySelector('.sticker-sheet-property--background-colour'),
        };
        this.stickerSheetImages = [];
        this.stickerSheetOriginalImages = [];
        this.stickerSheetImageLoadId = 0;
        this.stickerSheetOffsetX = 0;
        this.stickerSheetOffsetY = 0;
        this.stickerSheetDragState = null;

        this.dieCutMaker = this.querySelector('.die-cut-maker');
        this.dieCutSizeRange = this.querySelector('.die-cut-maker__range');
        this.dieCutSizeNumber = this.querySelector('.die-cut-maker__number');
        this.dieCutBands = Array.from(this.querySelectorAll('.die-cut-maker__band'));
        this.dieCutStats = this.querySelector('.die-cut-maker__stats');
        this.dieCutFinishedValue = this.querySelector('.die-cut-maker__finished-value');
        this.dieCutBandValue = this.querySelector('.die-cut-maker__band-value');
        this.dieCutDpiValue = this.querySelector('.die-cut-maker__dpi-value');
        this.dieCutQualityValue = this.querySelector('.die-cut-maker__quality-value');
        this.dieCutDpiAlert = this.querySelector('.die-cut-maker__dpi-alert');
        this.dieCutDpiMessage = this.querySelector('.die-cut-maker__dpi-message');
        this.dieCutDpiAction = this.querySelector('.die-cut-maker__dpi-action');
        this.dieCutRemoveBackground = this.querySelector('.die-cut-maker__remove-background');
        this.dieCutToleranceContainer = this.querySelector('.die-cut-maker__tolerance');
        this.dieCutToleranceRange = this.querySelector('.die-cut-maker__tolerance-range');
        this.dieCutToleranceValue = this.querySelector('.die-cut-maker__tolerance-value');
        this.dieCutBackgroundModes = Array.from(this.querySelectorAll('.die-cut-maker__background-mode'));
        this.dieCutBackgroundColourRow = this.querySelector('[data-die-cut-background-colour-row]');
        this.dieCutBackgroundColour = this.querySelector('.die-cut-maker__background-colour');
        this.dieCutPickBackground = this.querySelector('.die-cut-maker__pick-background');
        this.dieCutBackgroundStatus = this.querySelector('.die-cut-maker__background-status');
        this.dieCutProperties = {
          band: this.querySelector('.die-cut-property--band'),
          longestEdge: this.querySelector('.die-cut-property--longest-edge'),
          finishedSize: this.querySelector('.die-cut-property--finished-size'),
          quality: this.querySelector('.die-cut-property--quality'),
          backgroundRemoval: this.querySelector('.die-cut-property--background-removal'),
          backgroundTolerance: this.querySelector('.die-cut-property--background-tolerance'),
          backgroundMode: this.querySelector('.die-cut-property--background-mode'),
          backgroundColour: this.querySelector('.die-cut-property--background-colour'),
        };
        this.dieCutMetrics = [];
        this.dieCutProcessedFile = null;
        this.dieCutProcessedObjectUrl = '';
        this.dieCutPreparedSignature = '';
        this.dieCutProcessedUploadSignature = '';
        this.dieCutProcessingPromise = null;
        this.dieCutProcessingId = 0;
        this.dieCutProcessingTimer = null;
        this.backgroundColourPickTarget = '';
        this.isAutoSelectingDieCutVariant = false;

        this.previewObjectUrls = [];
        this.selectedArtworkFiles = [];
        this.isArtworkUploading = false;
        this.previewUploadSignature = '';
        this.uploadGeneration = 0;

        if (this.uploadInput && this.uploadTokenInput && this.uploadStatus) {
          this.uploadInput.addEventListener('change', this.onFileChange.bind(this));
        }
        this.flagReverseUploadInput?.addEventListener('change', this.onFileChange.bind(this));
        this.swingTagClearButtons.forEach((button) => {
          button.addEventListener('click', () => this.clearSwingTagArtwork(button.dataset.stgClearSide));
        });
        this.swingTagPrintStateHandler = (event) => {
          if (!this.isSwingTagPreview()) return;
          if (event.detail?.formId && event.detail.formId !== this.form?.id) return;
          this.updateSwingTagArtworkState(event.detail?.sides);
        };
        document.addEventListener('ops:swing-tag:print-state', this.swingTagPrintStateHandler);
        this.updateSwingTagArtworkState();

        this.clearArtworkButton?.addEventListener('click', this.clearSelectedArtwork.bind(this));

        this.borderOptions.forEach((option) => {
          option.addEventListener('change', this.updateArtworkBorderPreview.bind(this));
        });

        this.borderColourPicker?.addEventListener('input', (event) => {
          this.setBorderColour(event.target.value);
        });

        this.borderColourHex?.addEventListener('input', (event) => {
          const normalised = this.normaliseHexColour(event.target.value);
          if (normalised) this.setBorderColour(normalised, 'hex');
        });

        this.borderColourHex?.addEventListener('blur', () => {
          this.setBorderColour(this.normaliseHexColour(this.borderColourHex.value) || '#FFFFFF');
        });

        this.flagFit?.addEventListener('change', () => {
          this.flagOffsetX = 0;
          this.flagOffsetY = 0;
          this.saveFlagSideState();
          this.previewUploadSignature = '';
          this.updateFlagPreview();
        });

        this.flagZoom?.addEventListener('input', () => {
          this.flagZoomPercent = this.flagZoomFromControl(this.flagZoom.value);
          if (this.flagZoomValue) this.flagZoomValue.textContent = `${Math.round(this.flagZoomPercent)}%`;
          this.saveFlagSideState();
          this.previewUploadSignature = '';
          this.updateFlagPreview();
        });

        this.flagReset?.addEventListener('click', () => {
          this.flagOffsetX = 0;
          this.flagOffsetY = 0;
          this.saveFlagSideState();
          this.previewUploadSignature = '';
          this.updateFlagPreview();
        });

        this.flagGuide?.addEventListener('change', () => {
          this.previewUploadSignature = '';
          this.updateFlagPreview();
        });

        this.segLights?.addEventListener('change', () => {
          if (this.isSegPreview() && this.setSegInternalLightingFromToggle()) return;
          this.previewUploadSignature = '';
          this.updateFlagPreview();
        });
        this.segGlowColour?.addEventListener('change', () => {
          this.previewUploadSignature = '';
          this.updateFlagPreview();
        });
        this.segGlowIntensity?.addEventListener('input', () => {
          if (this.segGlowValue) this.segGlowValue.textContent = `${Math.round(Number(this.segGlowIntensity.value) || 0)}%`;
          this.previewUploadSignature = '';
          this.updateFlagPreview();
        });

        this.flagCanvas?.addEventListener('pointerdown', (event) => this.startFlagDrag(event));
        this.flagCanvas?.addEventListener('pointermove', (event) => this.moveFlagDrag(event));
        this.flagCanvas?.addEventListener('pointerup', (event) => this.endFlagDrag(event));
        this.flagCanvas?.addEventListener('pointercancel', (event) => this.endFlagDrag(event));
        this.flagCanvas?.addEventListener('dblclick', () => {
          this.flagOffsetX = 0;
          this.flagOffsetY = 0;
          this.saveFlagSideState();
          this.previewUploadSignature = '';
          this.updateFlagPreview();
        });

        this.flagSideTabs.forEach((tab) => {
          tab.addEventListener('click', () => this.setFlagActiveSide(tab.dataset.flagSide || 'front'));
        });
        this.flagUseSameArtwork?.addEventListener('change', () => {
          if (this.flagUseSameArtwork.checked) this.setFlagActiveSide('front');
          this.updateFlagSideControls();
          this.syncFlagSelectedFiles();
          this.previewUploadSignature = '';
          this.updateFlagPreview();
          if (this.flagFiles.front) this.uploadCurrentFlagFiles().catch(() => {});
        });
        this.flagVariantSelects.forEach((select) => {
          select.addEventListener('change', () => this.setOriginalFlagOption(select.dataset.optionName, select.value));
        });
        this.flagQuantity?.addEventListener('change', () => this.syncFlagQuantityToMain());
        this.flagQuantity?.addEventListener('input', () => this.updateFlagPackageUI());
        this.flagPackageOptions.forEach((option) => option.addEventListener('change', () => this.updateFlagPackageUI()));
        this.flagBaseOptions.forEach((option) => option.addEventListener('change', () => this.updateFlagPackageUI()));

        this.artworkNotes?.addEventListener('input', () => {
          this.previewUploadSignature = '';
        });

        this.productSectionRoot?.addEventListener('change', (event) => {
          this.updateNumberStickerField();
          this.updateGreetingCardFields();
          if (event.target.matches?.('input[name="quantity"]')) {
            if (this.flagQuantity && document.activeElement !== this.flagQuantity) this.flagQuantity.value = event.target.value || '1';
            this.updateFlagPackageUI();
          }
          if (!event.target.closest?.('variant-selects')) return;
          this.previewUploadSignature = '';
          this.updateStickerSheetPreview();
          this.syncFlagMirrorControls();
          const flagIsDoubleSided = this.isFlagDoubleSided();
          const flagSideModeChanged = this.isFlagPreview() && flagIsDoubleSided !== this.flagWasDoubleSided;
          this.flagWasDoubleSided = flagIsDoubleSided;
          this.updateFlagSideControls();
          if (flagSideModeChanged && this.flagFiles.front) {
            this.syncFlagSelectedFiles();
            this.uploadCurrentFlagFiles().catch(() => {});
          }
          this.updateFlagPackageUI();
          this.updateFlagPreview();
          if (this.isDieCutPreview() && !this.isAutoSelectingDieCutVariant) {
            this.syncDieCutSizeFromVariant(event.target);
          }
        });

        this.stickerSheetModeOptions.forEach((option) => {
          option.addEventListener('change', () => this.updateStickerSheetMode());
        });

        this.stickerSheetSizeRange?.addEventListener('input', (event) => {
          this.setStickerSheetSize(event.target.value, 'range');
        });

        this.stickerSheetSizeNumber?.addEventListener('input', (event) => {
          this.setStickerSheetSize(event.target.value, 'number');
        });

        this.stickerSheetSizeNumber?.addEventListener('blur', () => {
          this.setStickerSheetSize(this.stickerSheetSizeNumber.value || 40);
        });

        this.stickerSheetPanelOptions.forEach((option) => {
          option.addEventListener('change', () => {
            this.previewUploadSignature = '';
            this.resetStickerSheetPosition();
            this.updateStickerSheetPreview();
          });
        });

        this.stickerSheetFit?.addEventListener('change', () => {
          this.previewUploadSignature = '';
          this.resetStickerSheetPosition();
          this.updateStickerSheetPreview();
        });

        this.stickerSheetZoom?.addEventListener('input', () => {
          this.previewUploadSignature = '';
          this.updateStickerSheetPreview();
        });

        this.stickerSheetResetPosition?.addEventListener('click', () => {
          this.resetStickerSheetPosition();
          this.updateStickerSheetPreview();
        });

        this.stickerSheetGuideMode?.addEventListener('change', () => {
          this.previewUploadSignature = '';
          this.updateStickerSheetPreview();
        });

        this.stickerSheetRemoveBackground?.addEventListener('change', () => {
          this.previewUploadSignature = '';
          this.dieCutPreparedSignature = '';
          this.updateStickerSheetBackgroundControls();
          this.refreshStickerSheetArtworkProcessing();
        });

        this.stickerSheetBackgroundModes.forEach((option) => {
          option.addEventListener('change', () => {
            this.previewUploadSignature = '';
            this.dieCutPreparedSignature = '';
            this.updateStickerSheetBackgroundControls();
            this.refreshStickerSheetArtworkProcessing();
          });
        });

        this.stickerSheetBackgroundColour?.addEventListener('input', () => {
          if (this.getStickerSheetBackgroundMode() !== 'colour') return;
          this.previewUploadSignature = '';
          this.dieCutPreparedSignature = '';
          clearTimeout(this.dieCutProcessingTimer);
          this.dieCutProcessingTimer = setTimeout(() => this.refreshStickerSheetArtworkProcessing(), 180);
        });

        this.stickerSheetPickBackground?.addEventListener('click', () => {
          this.beginBackgroundColourPick('sticker-sheet');
        });

        this.stickerSheetToleranceRange?.addEventListener('input', () => {
          if (this.stickerSheetToleranceValue) {
            this.stickerSheetToleranceValue.textContent = `${this.getStickerSheetBackgroundTolerance()}`;
          }
          this.previewUploadSignature = '';
          this.dieCutPreparedSignature = '';
          clearTimeout(this.dieCutProcessingTimer);
          this.dieCutProcessingTimer = setTimeout(() => this.refreshStickerSheetArtworkProcessing(), 160);
        });

        this.stickerSheetDpiAction?.addEventListener('click', () => {
          this.setStickerSheetToTargetDpi(300);
        });

        this.stickerSheetCanvas?.addEventListener('pointerdown', (event) => {
          this.startStickerSheetDrag(event);
        });
        this.stickerSheetCanvas?.addEventListener('pointermove', (event) => {
          this.moveStickerSheetDrag(event);
        });
        this.stickerSheetCanvas?.addEventListener('pointerup', (event) => {
          this.endStickerSheetDrag(event);
        });
        this.stickerSheetCanvas?.addEventListener('pointercancel', (event) => {
          this.endStickerSheetDrag(event);
        });
        this.stickerSheetCanvas?.addEventListener('click', (event) => {
          if (this.backgroundColourPickTarget === 'sticker-sheet') this.pickBackgroundColourFromCanvas(event, 'sticker-sheet');
        });

        this.dieCutSizeRange?.addEventListener('input', (event) => {
          this.setDieCutSize(event.target.value, 'range', true);
        });

        this.dieCutSizeNumber?.addEventListener('input', (event) => {
          this.setDieCutSize(event.target.value, 'number', true);
        });

        this.dieCutSizeNumber?.addEventListener('blur', () => {
          this.setDieCutSize(this.dieCutSizeNumber.value || 25, '', true);
        });

        this.dieCutDpiAction?.addEventListener('click', () => {
          this.setDieCutToTargetDpi(300);
        });

        this.dieCutRemoveBackground?.addEventListener('change', () => {
          this.dieCutPreparedSignature = '';
          this.dieCutProcessedUploadSignature = '';
          this.previewUploadSignature = '';
          this.updateDieCutBackgroundControls();
          this.refreshDieCutArtworkProcessing();
        });

        this.dieCutBackgroundModes.forEach((option) => {
          option.addEventListener('change', () => {
            this.dieCutPreparedSignature = '';
            this.dieCutProcessedUploadSignature = '';
            this.previewUploadSignature = '';
            this.updateDieCutBackgroundControls();
            this.refreshDieCutArtworkProcessing();
          });
        });

        this.dieCutBackgroundColour?.addEventListener('input', () => {
          if (this.getDieCutBackgroundMode() !== 'colour') return;
          this.dieCutPreparedSignature = '';
          this.dieCutProcessedUploadSignature = '';
          this.previewUploadSignature = '';
          clearTimeout(this.dieCutProcessingTimer);
          this.dieCutProcessingTimer = setTimeout(() => this.refreshDieCutArtworkProcessing(), 180);
        });

        this.dieCutPickBackground?.addEventListener('click', () => {
          this.beginBackgroundColourPick('die-cut');
        });

        this.artworkPreviewGrid?.addEventListener('click', (event) => {
          if (this.backgroundColourPickTarget === 'die-cut') this.pickBackgroundColourFromImage(event);
        });

        this.dieCutToleranceRange?.addEventListener('input', (event) => {
          const tolerance = Math.round(this.clampNumber(event.target.value, 0, 140, 115));
          if (this.dieCutToleranceValue) this.dieCutToleranceValue.textContent = `${tolerance}`;
          this.dieCutPreparedSignature = '';
          this.dieCutProcessedUploadSignature = '';
          this.previewUploadSignature = '';
          clearTimeout(this.dieCutProcessingTimer);
          this.dieCutProcessingTimer = setTimeout(() => this.refreshDieCutArtworkProcessing(), 180);
        });

        this.updateArtworkBorderPreview(false);
        this.updateStickerSheetMode(false);
        this.syncFlagMirrorControls();
        this.flagWasDoubleSided = this.isFlagDoubleSided();
        this.updateFlagSideControls();
        this.updateFlagPackageUI();
        this.updateFlagPreview();
        this.updateDieCutControls(false);
        setTimeout(() => this.syncDieCutSizeFromVariant(), 0);
      }

      arrangeFlagMakerLayout() {
        if (!this.flagMaker || !this.artworkPreview || !this.isFlagPreview()) return;
        if (this.flagMaker.dataset.previewFirstReady === 'true') return;

        this.flagMaker.dataset.previewFirstReady = 'true';

        const intro = this.flagMaker.querySelector('.flag-maker__intro');
        const sideControls = this.flagMaker.querySelector('.flag-maker__side-controls');
        const lightingControls = this.flagMaker.querySelector('.seg-lighting-controls');
        const controls = this.flagMaker.querySelector('.flag-maker__controls');
        const metrics = this.flagMaker.querySelector('.flag-maker__metrics');
        const alert = this.flagMaker.querySelector('.flag-maker__alert');
        const guidance = this.flagMaker.querySelector('.flag-maker__guidance');
        const selection = this.flagMaker.querySelector('.flag-maker__selection');
        const packageOptions = this.flagMaker.querySelector('.flag-package');
        const packageData = this.flagMaker.querySelector('.flag-package-data');
        const zoomField = this.flagZoom?.closest('.flag-maker__field--zoom');
        const selectionSummary = this.flagMaker.querySelector('.flag-maker__selection-summary');

        if (selectionSummary && /^default title$/i.test(selectionSummary.textContent.trim())) {
          selectionSummary.hidden = true;
        }

        const workspace = document.createElement('section');
        workspace.className = 'flag-maker__preview-workspace';
        workspace.setAttribute('aria-label', this.segPreviewEnabled ? 'Illuminated artwork preview' : 'Flag artwork preview and scale');

        const previewStage = document.createElement('div');
        previewStage.className = 'flag-maker__preview-stage';
        previewStage.append(this.artworkPreview);

        // SEG keeps Artwork scale inside the main preview controls.
        // Other flag-style makers retain the historical detached scale overlay.
        if (zoomField && !this.segPreviewEnabled) {
          const scaleOverlay = document.createElement('div');
          scaleOverlay.className = 'flag-maker__scale-overlay';
          scaleOverlay.append(zoomField);
          previewStage.append(scaleOverlay);
        }

        if (this.segPreviewEnabled) {
          this.flagMaker.classList.add('flag-maker--seg-workspace');
          if (lightingControls) {
            lightingControls.classList.add('seg-lighting-controls--overlay');
            previewStage.append(lightingControls);
          }
          if (controls) {
            controls.classList.add('flag-maker__controls--overlay');
            previewStage.append(controls);
          }
          workspace.append(previewStage);
          if (metrics) workspace.append(metrics);
          if (alert) workspace.append(alert);

          const orderedNodes = [
            selection,
            sideControls,
            workspace,
            packageOptions,
            packageData,
          ].filter(Boolean);
          orderedNodes.forEach((node) => this.flagMaker.append(node));
          return;
        }

        workspace.append(previewStage);
        const orderedNodes = [
          intro,
          sideControls,
          workspace,
          controls,
          lightingControls,
          metrics,
          alert,
          guidance,
          selection,
          packageOptions,
          packageData,
        ].filter(Boolean);
        orderedNodes.forEach((node) => this.flagMaker.append(node));
      }

      generateSessionId() {
        if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
        return `session_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      }

      normaliseHexColour(value) {
        const cleaned = String(value || '').trim().replace(/^#/, '').replace(/[^0-9a-fA-F]/g, '').slice(0, 6);
        if (cleaned.length === 3) {
          return `#${cleaned
            .split('')
            .map((character) => character + character)
            .join('')}`.toUpperCase();
        }
        if (cleaned.length === 6) return `#${cleaned}`.toUpperCase();
        return null;
      }

      getDieCutBackgroundMode() {
        return 'auto';
      }

      getStickerSheetBackgroundMode() {
        return 'auto';
      }

      getDieCutBackgroundColour() {
        return this.normaliseHexColour(this.dieCutBackgroundColour?.value) || '#FFFFFF';
      }

      getStickerSheetBackgroundColour() {
        return this.normaliseHexColour(this.stickerSheetBackgroundColour?.value) || '#FFFFFF';
      }

      setBackgroundRemovalMode(type, mode) {
        const options = type === 'sticker-sheet' ? this.stickerSheetBackgroundModes : this.dieCutBackgroundModes;
        options.forEach((option) => { option.checked = option.value === mode; });
      }

      beginBackgroundColourPick(type) {
        const canPick = type === 'sticker-sheet'
          ? Boolean(this.stickerSheetCanvas && this.selectedArtworkFiles.length)
          : Boolean(this.artworkPreviewGrid?.querySelector('.artwork-preview__image'));
        if (!canPick) return;
        this.backgroundColourPickTarget = type;
        this.classList.add('is-picking-background-colour');
        const message = 'Tap or click the background colour in the artwork preview.';
        if (type === 'sticker-sheet' && this.stickerSheetBackgroundStatus) this.stickerSheetBackgroundStatus.textContent = message;
        if (type === 'die-cut' && this.dieCutBackgroundStatus) this.dieCutBackgroundStatus.textContent = message;
      }

      finishBackgroundColourPick(type, red, green, blue) {
        const colour = this.rgbToHex(red, green, blue);
        this.backgroundColourPickTarget = '';
        this.classList.remove('is-picking-background-colour');
        this.setBackgroundRemovalMode(type, 'colour');
        if (type === 'sticker-sheet') {
          if (this.stickerSheetBackgroundColour) this.stickerSheetBackgroundColour.value = colour.toLowerCase();
          this.previewUploadSignature = '';
          this.dieCutPreparedSignature = '';
          this.updateStickerSheetBackgroundControls();
          this.refreshStickerSheetArtworkProcessing();
        } else {
          if (this.dieCutBackgroundColour) this.dieCutBackgroundColour.value = colour.toLowerCase();
          this.previewUploadSignature = '';
          this.dieCutPreparedSignature = '';
          this.dieCutProcessedUploadSignature = '';
          this.updateDieCutBackgroundControls();
          this.refreshDieCutArtworkProcessing();
        }
      }

      pickBackgroundColourFromImage(event) {
        const image = event.target.closest?.('.artwork-preview__image');
        if (!image?.naturalWidth || !image?.naturalHeight) return;
        const rect = image.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const x = Math.max(0, Math.min(image.naturalWidth - 1, Math.floor((event.clientX - rect.left) / rect.width * image.naturalWidth)));
        const y = Math.max(0, Math.min(image.naturalHeight - 1, Math.floor((event.clientY - rect.top) / rect.height * image.naturalHeight)));
        const canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) return;
        context.drawImage(image, 0, 0);
        const pixel = context.getImageData(x, y, 1, 1).data;
        this.finishBackgroundColourPick('die-cut', pixel[0], pixel[1], pixel[2]);
      }

      pickBackgroundColourFromCanvas(event, type = 'sticker-sheet') {
        const canvas = event.currentTarget;
        const rect = canvas?.getBoundingClientRect();
        if (!canvas || !rect?.width || !rect?.height) return;
        const x = Math.max(0, Math.min(canvas.width - 1, Math.floor((event.clientX - rect.left) / rect.width * canvas.width)));
        const y = Math.max(0, Math.min(canvas.height - 1, Math.floor((event.clientY - rect.top) / rect.height * canvas.height)));
        const pixel = canvas.getContext('2d', { willReadFrequently: true })?.getImageData(x, y, 1, 1).data;
        if (!pixel) return;
        this.finishBackgroundColourPick(type, pixel[0], pixel[1], pixel[2]);
      }

      rgbToHex(red, green, blue) {
        const component = (value) => Math.max(0, Math.min(255, Math.round(value))).toString(16).padStart(2, '0');
        return `#${component(red)}${component(green)}${component(blue)}`.toUpperCase();
      }

      hexToRgb(value) {
        const colour = this.normaliseHexColour(value) || '#FFFFFF';
        return [parseInt(colour.slice(1, 3), 16), parseInt(colour.slice(3, 5), 16), parseInt(colour.slice(5, 7), 16)];
      }

      detectDominantEdgeColour(imageData, width, height) {
        const data = imageData.data;
        const buckets = new Map();
        const addPixel = (x, y) => {
          const offset = (y * width + x) * 4;
          if (data[offset + 3] < 24) return;
          const r = Math.round(data[offset] / 16) * 16;
          const g = Math.round(data[offset + 1] / 16) * 16;
          const b = Math.round(data[offset + 2] / 16) * 16;
          const key = `${Math.min(255, r)},${Math.min(255, g)},${Math.min(255, b)}`;
          const record = buckets.get(key) || { count: 0, red: 0, green: 0, blue: 0 };
          record.count += 1;
          record.red += data[offset];
          record.green += data[offset + 1];
          record.blue += data[offset + 2];
          buckets.set(key, record);
        };
        const stepX = Math.max(1, Math.floor(width / 240));
        const stepY = Math.max(1, Math.floor(height / 240));
        for (let x = 0; x < width; x += stepX) {
          addPixel(x, 0);
          if (height > 1) addPixel(x, height - 1);
        }
        for (let y = stepY; y < height - 1; y += stepY) {
          addPixel(0, y);
          if (width > 1) addPixel(width - 1, y);
        }
        let best = null;
        buckets.forEach((record) => {
          if (!best || record.count > best.count) best = record;
        });
        if (!best?.count) return [255, 255, 255];
        return [best.red / best.count, best.green / best.count, best.blue / best.count];
      }

      isNearColourPixel(data, offset, targetRgb, maximumDistance) {
        if (data[offset + 3] === 0) return false;
        return Math.hypot(
          data[offset] - targetRgb[0],
          data[offset + 1] - targetRgb[1],
          data[offset + 2] - targetRgb[2]
        ) <= maximumDistance;
      }

      removeEdgeConnectedColourPixels(imageData, width, height, targetRgb, tolerance) {
        const data = imageData.data;
        const maximumDistance = 8 + Math.max(0, Math.min(140, Number(tolerance) || 0)) * 1.55;
        const visited = new Uint8Array(width * height);
        const stack = [];
        let removed = 0;
        const enqueue = (x, y) => {
          if (x < 0 || x >= width || y < 0 || y >= height) return;
          const pixelIndex = y * width + x;
          if (visited[pixelIndex]) return;
          const offset = pixelIndex * 4;
          if (!this.isNearColourPixel(data, offset, targetRgb, maximumDistance)) return;
          visited[pixelIndex] = 1;
          stack.push(pixelIndex);
        };
        for (let x = 0; x < width; x += 1) {
          enqueue(x, 0);
          enqueue(x, height - 1);
        }
        for (let y = 1; y < height - 1; y += 1) {
          enqueue(0, y);
          enqueue(width - 1, y);
        }
        while (stack.length) {
          const pixelIndex = stack.pop();
          const x = pixelIndex % width;
          const y = Math.floor(pixelIndex / width);
          const offset = pixelIndex * 4;
          if (data[offset + 3] > 0) removed += 1;
          data[offset + 3] = 0;
          enqueue(x - 1, y);
          enqueue(x + 1, y);
          enqueue(x, y - 1);
          enqueue(x, y + 1);
        }
        return removed;
      }

      setBorderColour(value, source = 'picker') {
        const colour = this.normaliseHexColour(value) || '#FFFFFF';
        if (this.borderColourPicker && source !== 'picker') this.borderColourPicker.value = colour.toLowerCase();
        if (this.borderColourHex && source !== 'hex') this.borderColourHex.value = colour;
        if (this.borderColourProperty) this.borderColourProperty.value = colour;
        this.previewUploadSignature = '';
        this.updateArtworkBorderPreview(false);
      }

      getBorderSettings() {
        const selectedOption = this.borderOptions.find((option) => option.checked);
        const enabled = selectedOption?.value === 'Add border';
        const colour =
          this.normaliseHexColour(this.borderColourProperty?.value || this.borderColourHex?.value) || '#FFFFFF';
        return { enabled, colour };
      }

      updateArtworkBorderPreview(invalidate = true) {
        const { enabled, colour } = this.getBorderSettings();
        const images = this.artworkPreviewGrid?.querySelectorAll('.artwork-preview__image') || [];

        if (this.borderColourContainer) this.borderColourContainer.hidden = !enabled;
        if (this.borderColourProperty) this.borderColourProperty.disabled = !enabled;

        images.forEach((image) => {
          image.classList.toggle('artwork-preview__image--with-border', enabled);
          image.style.setProperty('--artwork-border-color', colour);
        });

        if (invalidate) this.previewUploadSignature = '';
      }

      isStickerSheetPreview() {
        return this.previewType === 'sticker-sheet';
      }

      isDieCutPreview() {
        return this.previewType === 'die-cut';
      }

      isSwingTagPreview() {
        return this.previewType === 'swing-tag';
      }

      isFlagPreview() {
        return this.previewType === 'flag';
      }

      isSegPreview() {
        return this.isFlagPreview() && this.segPreviewEnabled;
      }

      clampNumber(value, minimum, maximum, fallback) {
        const number = Number(value);
        if (!Number.isFinite(number)) return fallback;
        return Math.min(maximum, Math.max(minimum, number));
      }

      flagZoomFromControl(value) {
        const control = this.clampNumber(value, 0, 100, 50);
        // Keep 100% at the visual midpoint while preserving the useful 50–250% range.
        return control <= 50 ? 50 + control : 100 + ((control - 50) * 3);
      }

      flagZoomToControl(value) {
        const zoom = this.clampNumber(value, 50, 250, 100);
        return zoom <= 100 ? zoom - 50 : 50 + ((zoom - 100) / 3);
      }

      normaliseDieCutSizeBand(value) {
        const text = String(value || '')
          .trim()
          .toLowerCase()
          .replace(/[_-]+/g, ' ')
          .replace(/\s+/g, ' ');

        if (!text) return '';
        if (/\b(x\s*large|xlarge|extra\s*large|xl)\b/.test(text)) return 'X Large';
        if (/\bsmall\b/.test(text) || text === 's') return 'Small';
        if (/\bmedium\b/.test(text) || text === 'm') return 'Medium';
        if (/\blarge\b/.test(text) || text === 'l') return 'Large';
        return '';
      }

      getDieCutBandForSize(value) {
        const size = Math.round(this.clampNumber(value, 20, 200, 25));
        if (size <= 25) return 'Small';
        if (size <= 50) return 'Medium';
        if (size <= 100) return 'Large';
        return 'X Large';
      }

      getDieCutBandDefaultSize(band) {
        if (band === 'Small') return 25;
        if (band === 'Medium') return 50;
        if (band === 'Large') return 100;
        if (band === 'X Large') return 200;
        return 25;
      }

      getDieCutSize() {
        return Math.round(
          this.clampNumber(this.dieCutSizeRange?.value || this.dieCutSizeNumber?.value, 20, 200, 25)
        );
      }

      calculateDieCutSizeForDpi(targetDpi = 300) {
        if (!this.dieCutMetrics.length) return null;

        const rasterMetrics = this.dieCutMetrics.filter(
          (metric) => metric && !metric.vector && metric.widthPx && metric.heightPx
        );

        if (!rasterMetrics.length) {
          return this.dieCutMetrics.every((metric) => metric?.vector) ? 200 : null;
        }

        const supportedLongestEdges = rasterMetrics
          .map((metric) => (Math.max(metric.widthPx, metric.heightPx) / targetDpi) * 25.4)
          .filter(Number.isFinite);

        if (!supportedLongestEdges.length) return null;
        return Math.floor(Math.min(...supportedLongestEdges));
      }

      setDieCutToTargetDpi(targetDpi = 300) {
        if (!this.isDieCutPreview()) return;

        const calculatedSize = this.calculateDieCutSizeForDpi(targetDpi);
        if (!Number.isFinite(calculatedSize)) return;

        const size = Math.round(this.clampNumber(calculatedSize, 20, 200, 25));
        this.setDieCutSize(size, 'dpi', true);
      }

      setDieCutSize(value, source = '', updateVariant = true) {
        if (!this.isDieCutPreview()) return;
        const size = Math.round(this.clampNumber(value, 20, 200, 25));
        if (this.dieCutSizeRange && source !== 'range') this.dieCutSizeRange.value = String(size);
        if (this.dieCutSizeNumber && source !== 'number') this.dieCutSizeNumber.value = String(size);
        this.previewUploadSignature = '';
        this.updateDieCutControls(false);
        if (updateVariant) this.autoSelectDieCutSizeVariant(this.getDieCutBandForSize(size));
      }

      getCurrentVariantSelects() {
        return this.productSectionRoot?.querySelector(
          `#variant-selects-${this.dataset.sectionId}, variant-selects`
        ) || null;
      }

      getSelectedDieCutSizeBand() {
        const selectedSize = this.getSelectedOptions().find((option) => /size/i.test(option.name));
        return this.normaliseDieCutSizeBand(selectedSize?.value);
      }

      syncDieCutSizeFromVariant(target = null) {
        if (!this.isDieCutPreview()) return;

        if (target) {
          const optionName =
            target.dataset?.optionName ||
            (target.name?.match(/^options\[(.+)\]$/)?.[1] || '') ||
            target.closest?.('.product-form__input')?.querySelector?.('.form__label, legend')?.textContent ||
            '';
          if (optionName && !/size/i.test(optionName)) return;
        }

        const band = this.getSelectedDieCutSizeBand();
        if (!band) {
          this.updateDieCutControls(false);
          return;
        }

        const currentBand = this.getDieCutBandForSize(this.getDieCutSize());
        if (currentBand !== band) {
          this.setDieCutSize(this.getDieCutBandDefaultSize(band), '', false);
        } else {
          this.updateDieCutControls(false);
        }
      }

      autoSelectDieCutSizeVariant(band) {
        const variantSelects = this.getCurrentVariantSelects();
        if (!variantSelects || !band) return;
        const controls = Array.from(variantSelects.querySelectorAll('[data-option-name]'));
        const matchingControl = controls.find((control) => {
          return /size/i.test(control.dataset.optionName || '') && this.normaliseDieCutSizeBand(control.value) === band;
        });
        if (!matchingControl) return;

        let changed = false;
        let eventTarget = matchingControl;
        this.isAutoSelectingDieCutVariant = true;

        if (matchingControl.tagName === 'OPTION') {
          const select = matchingControl.closest('select');
          if (select && select.value !== matchingControl.value) {
            select.value = matchingControl.value;
            eventTarget = select;
            changed = true;
          }
        } else if (matchingControl.matches('input[type="radio"]') && !matchingControl.checked) {
          matchingControl.checked = true;
          changed = true;
        }

        if (changed) {
          eventTarget.dispatchEvent(new Event('change', { bubbles: true }));
        }

        queueMicrotask(() => {
          this.isAutoSelectingDieCutVariant = false;
        });
      }

      formatDieCutMillimetres(value) {
        const number = Number(value);
        if (!Number.isFinite(number)) return '';
        return Number.isInteger(number) ? String(number) : number.toFixed(1).replace(/\.0$/, '');
      }

      getDieCutBackgroundTolerance() {
        return Math.round(this.clampNumber(this.dieCutToleranceRange?.value, 0, 140, 115));
      }

      canRemoveDieCutBackground() {
        if (this.selectedArtworkFiles.length !== 1) return false;
        return ['image/jpeg', 'image/png', 'image/webp'].includes(this.selectedArtworkFiles[0]?.type);
      }

      isDieCutBackgroundRemovalEnabled() {
        return Boolean(this.canRemoveDieCutBackground() && this.dieCutRemoveBackground?.checked);
      }

      updateDieCutBackgroundControls() {
        if (!this.isDieCutPreview()) return;
        const canRemove = this.canRemoveDieCutBackground();
        if (this.dieCutRemoveBackground) {
          this.dieCutRemoveBackground.disabled = !canRemove;
          if (!canRemove) this.dieCutRemoveBackground.checked = false;
        }

        const enabled = this.isDieCutBackgroundRemovalEnabled();
        const mode = this.getDieCutBackgroundMode();
        if (this.dieCutToleranceContainer) this.dieCutToleranceContainer.hidden = !enabled;
        if (this.dieCutBackgroundColourRow) this.dieCutBackgroundColourRow.hidden = !enabled || mode !== 'colour';
        if (this.dieCutToleranceValue) {
          this.dieCutToleranceValue.textContent = `${this.getDieCutBackgroundTolerance()}`;
        }

        if (!this.dieCutBackgroundStatus) return;
        if (!this.selectedArtworkFiles.length) {
          this.dieCutBackgroundStatus.textContent = 'Upload one JPG, PNG or WebP file to use background removal.';
        } else if (this.selectedArtworkFiles.length > 1) {
          this.dieCutBackgroundStatus.textContent = 'Background removal is available when one artwork file is uploaded.';
        } else if (!canRemove) {
          this.dieCutBackgroundStatus.textContent = 'Background removal is available for JPG, PNG and WebP artwork.';
        } else if (enabled && this.dieCutProcessedFile) {
          this.dieCutBackgroundStatus.textContent = 'Transparent PNG created. Check the preview carefully before ordering.';
        } else if (enabled) {
          this.dieCutBackgroundStatus.textContent = 'Auto-detecting and removing the edge background…';
        } else {
          this.dieCutBackgroundStatus.textContent = 'Optional: remove a flat background of any colour.';
        }
      }

      setDieCutProperty(property, value, enabled) {
        if (!property) return;
        property.value = value || '';
        property.disabled = !enabled || !value;
      }

      getDieCutQualityLabel(dpi, vector = false) {
        if (vector) return { label: 'Vector artwork — suitable at any selected size', level: 'excellent' };
        if (!Number.isFinite(dpi)) return { label: 'Print resolution will be checked manually', level: 'manual' };
        if (dpi >= 300) return { label: `Excellent — approximately ${Math.round(dpi)} DPI`, level: 'excellent' };
        if (dpi >= 200) return { label: `Good — approximately ${Math.round(dpi)} DPI`, level: 'good' };
        if (dpi >= 150) return { label: `Fair — approximately ${Math.round(dpi)} DPI`, level: 'fair' };
        return { label: `Low resolution — approximately ${Math.round(dpi)} DPI`, level: 'low' };
      }

      getDieCutDetails() {
        const longestEdgeMm = this.getDieCutSize();
        const sizeBand = this.getDieCutBandForSize(longestEdgeMm);
        const firstMetric = this.dieCutMetrics.find((metric) => metric?.widthPx && metric?.heightPx) || null;
        let finishedWidthMm = null;
        let finishedHeightMm = null;

        if (firstMetric) {
          const aspect = firstMetric.widthPx / firstMetric.heightPx;
          if (aspect >= 1) {
            finishedWidthMm = longestEdgeMm;
            finishedHeightMm = longestEdgeMm / aspect;
          } else {
            finishedHeightMm = longestEdgeMm;
            finishedWidthMm = longestEdgeMm * aspect;
          }
        }

        const dpiValues = this.dieCutMetrics
          .filter((metric) => metric && !metric.vector && metric.widthPx && metric.heightPx)
          .map((metric) => Math.max(metric.widthPx, metric.heightPx) / (longestEdgeMm / 25.4))
          .filter(Number.isFinite);
        const estimatedDpi = dpiValues.length ? Math.min(...dpiValues) : null;
        const vector = Boolean(this.dieCutMetrics.length && this.dieCutMetrics.every((metric) => metric?.vector));
        const quality = this.getDieCutQualityLabel(estimatedDpi, vector);
        const backgroundRemoval = this.isDieCutBackgroundRemovalEnabled() ? 'Yes' : 'No';

        return {
          sizeBand,
          longestEdgeMm,
          finishedWidthMm: finishedWidthMm === null ? null : Math.round(finishedWidthMm * 10) / 10,
          finishedHeightMm: finishedHeightMm === null ? null : Math.round(finishedHeightMm * 10) / 10,
          estimatedDpi: estimatedDpi === null ? null : Math.round(estimatedDpi * 10) / 10,
          qualityLabel: quality.label,
          qualityLevel: quality.level,
          backgroundRemoval,
          backgroundTolerance: backgroundRemoval === 'Yes' ? this.getDieCutBackgroundTolerance() : null,
          backgroundMode: backgroundRemoval === 'Yes' ? this.getDieCutBackgroundMode() : '',
          backgroundColour: backgroundRemoval === 'Yes' && this.getDieCutBackgroundMode() === 'colour' ? this.getDieCutBackgroundColour() : '',
          designCount: this.selectedArtworkFiles.length,
        };
      }

      updateDieCutProperties(details = this.getDieCutDetails()) {
        if (!this.isDieCutPreview()) return;
        const active = this.selectedArtworkFiles.length > 0;
        const width = this.formatDieCutMillimetres(details.finishedWidthMm);
        const height = this.formatDieCutMillimetres(details.finishedHeightMm);
        this.setDieCutProperty(this.dieCutProperties.band, details.sizeBand, active);
        this.setDieCutProperty(
          this.dieCutProperties.longestEdge,
          `${this.formatDieCutMillimetres(details.longestEdgeMm)} mm`,
          active
        );
        this.setDieCutProperty(
          this.dieCutProperties.finishedSize,
          width && height ? `${width} × ${height} mm` : '',
          active && Boolean(width && height)
        );
        this.setDieCutProperty(this.dieCutProperties.quality, details.qualityLabel, active);
        this.setDieCutProperty(this.dieCutProperties.backgroundRemoval, details.backgroundRemoval, active);
        this.setDieCutProperty(
          this.dieCutProperties.backgroundTolerance,
          details.backgroundRemoval === 'Yes' ? `Strength ${details.backgroundTolerance}` : '',
          active && details.backgroundRemoval === 'Yes'
        );
        this.setDieCutProperty(
          this.dieCutProperties.backgroundMode,
          details.backgroundRemoval === 'Yes' ? (details.backgroundMode === 'colour' ? 'Chosen colour' : 'Auto edge') : '',
          active && details.backgroundRemoval === 'Yes'
        );
        this.setDieCutProperty(
          this.dieCutProperties.backgroundColour,
          details.backgroundColour || '',
          active && details.backgroundRemoval === 'Yes' && details.backgroundMode === 'colour'
        );
      }

      updateDieCutControls(updateVariant = false) {
        if (!this.isDieCutPreview()) return;
        const details = this.getDieCutDetails();
        if (this.dieCutMaker) this.dieCutMaker.dataset.activeBand = details.sizeBand;
        this.dieCutBands.forEach((band) => {
          band.classList.toggle('is-active', band.dataset.sizeBand === details.sizeBand);
        });
        this.updateDieCutBackgroundControls();
        this.updateDieCutProperties(details);

        if (this.dieCutStats) {
          const hasArtwork = this.selectedArtworkFiles.length > 0;
          const width = this.formatDieCutMillimetres(details.finishedWidthMm);
          const height = this.formatDieCutMillimetres(details.finishedHeightMm);
          const targetSize = this.calculateDieCutSizeForDpi(300);
          const roundedDpi = Number.isFinite(details.estimatedDpi)
            ? Math.round(details.estimatedDpi)
            : null;

          if (this.dieCutFinishedValue) {
            this.dieCutFinishedValue.textContent =
              hasArtwork && width && height
                ? `${width} × ${height} mm`
                : `${details.longestEdgeMm} mm`;
          }

          if (this.dieCutBandValue) {
            this.dieCutBandValue.textContent = `${details.sizeBand} · ${details.longestEdgeMm} mm longest edge`;
          }

          if (this.dieCutDpiValue) {
            this.dieCutDpiValue.textContent = details.qualityLevel === 'excellent' && !roundedDpi
              ? 'Vector'
              : roundedDpi
                ? `${roundedDpi} DPI`
                : '—';
          }

          if (this.dieCutQualityValue) {
            if (!hasArtwork) {
              this.dieCutQualityValue.textContent = 'Upload artwork';
            } else if (details.qualityLevel === 'excellent') {
              this.dieCutQualityValue.textContent = roundedDpi ? 'Excellent' : 'Scales cleanly';
            } else if (details.qualityLevel === 'good') {
              this.dieCutQualityValue.textContent = 'Below recommended';
            } else if (details.qualityLevel === 'fair') {
              this.dieCutQualityValue.textContent = 'Low resolution';
            } else if (details.qualityLevel === 'low') {
              this.dieCutQualityValue.textContent = 'Very low resolution';
            } else {
              this.dieCutQualityValue.textContent = 'Manual check';
            }
          }

          this.dieCutStats.dataset.quality = hasArtwork ? details.qualityLevel : 'empty';

          if (this.dieCutDpiAlert && this.dieCutDpiMessage && this.dieCutDpiAction) {
            this.dieCutDpiAlert.hidden = !hasArtwork;
            this.dieCutDpiAction.hidden = true;

            if (!hasArtwork) {
              this.dieCutDpiMessage.textContent = '';
            } else if (details.qualityLevel === 'excellent') {
              this.dieCutDpiMessage.textContent = roundedDpi
                ? 'Ready at this size.'
                : 'Vector artwork is suitable at this size.';
            } else if (Number.isFinite(targetSize) && targetSize >= 20 && targetSize < details.longestEdgeMm) {
              this.dieCutDpiMessage.textContent = 'Below 300 DPI at this size.';
              this.dieCutDpiAction.textContent = 'Set to 300 DPI';
              this.dieCutDpiAction.hidden = false;
            } else if (Number.isFinite(targetSize) && targetSize < 20) {
              this.dieCutDpiMessage.textContent = 'This artwork is below 300 DPI even at 20 mm. Upload a larger image.';
            } else {
              this.dieCutDpiMessage.textContent = 'Print resolution will be checked before production.';
            }
          }
        }
        if (updateVariant) this.autoSelectDieCutSizeVariant(details.sizeBand);
      }

      getDieCutProcessingSignature() {
        return JSON.stringify({
          files: this.selectedArtworkFiles.map((file) => [file.name, file.size, file.lastModified, file.type]),
          removeBackground: this.isDieCutBackgroundRemovalEnabled(),
          tolerance: this.getDieCutBackgroundTolerance(),
          backgroundMode: this.getDieCutBackgroundMode(),
          backgroundColour: this.getDieCutBackgroundColour(),
        });
      }

      revokeDieCutProcessedObjectUrl() {
        if (this.dieCutProcessedObjectUrl) URL.revokeObjectURL(this.dieCutProcessedObjectUrl);
        this.dieCutProcessedObjectUrl = '';
      }

      restoreDieCutPreviewSources() {
        this.artworkPreviewGrid?.querySelectorAll('.artwork-preview__image').forEach((image) => {
          if (image.dataset.originalSrc) image.src = image.dataset.originalSrc;
          image.closest('.artwork-preview__item')?.classList.remove('artwork-preview__item--processed');
        });
      }

      applyDieCutProcessedPreview() {
        const image = this.artworkPreviewGrid?.querySelector('.artwork-preview__image');
        if (!image || !this.dieCutProcessedFile) return;
        this.revokeDieCutProcessedObjectUrl();
        this.dieCutProcessedObjectUrl = URL.createObjectURL(this.dieCutProcessedFile);
        image.src = this.dieCutProcessedObjectUrl;
        image.closest('.artwork-preview__item')?.classList.add('artwork-preview__item--processed');
      }

      async analyseDieCutFile(file) {
        if (file.type === 'image/svg+xml') {
          const image = await this.loadArtworkImage(file);
          if (!image) return null;
          return {
            fileName: file.name,
            widthPx: image.naturalWidth || 1,
            heightPx: image.naturalHeight || 1,
            vector: true,
          };
        }

        if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) return null;
        const image = await this.loadArtworkImage(file);
        if (!image?.naturalWidth || !image?.naturalHeight) return null;

        if (file.type === 'image/jpeg') {
          return {
            fileName: file.name,
            widthPx: image.naturalWidth,
            heightPx: image.naturalHeight,
            vector: false,
          };
        }

        const maximumAnalysisEdge = 1600;
        const analysisScale = Math.min(1, maximumAnalysisEdge / Math.max(image.naturalWidth, image.naturalHeight));
        const width = Math.max(1, Math.round(image.naturalWidth * analysisScale));
        const height = Math.max(1, Math.round(image.naturalHeight * analysisScale));
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) return null;
        context.drawImage(image, 0, 0, width, height);

        let imageData;
        try {
          imageData = context.getImageData(0, 0, width, height).data;
        } catch {
          return {
            fileName: file.name,
            widthPx: image.naturalWidth,
            heightPx: image.naturalHeight,
            vector: false,
          };
        }

        let minX = width;
        let minY = height;
        let maxX = -1;
        let maxY = -1;
        for (let y = 0; y < height; y += 1) {
          for (let x = 0; x < width; x += 1) {
            const alpha = imageData[(y * width + x) * 4 + 3];
            if (alpha <= 12) continue;
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }

        if (maxX < minX || maxY < minY) return null;
        return {
          fileName: file.name,
          widthPx: Math.max(1, Math.round((maxX - minX + 1) / analysisScale)),
          heightPx: Math.max(1, Math.round((maxY - minY + 1) / analysisScale)),
          vector: false,
        };
      }

      async createBackgroundRemovedArtwork(file, tolerance, options = {}) {
        const image = await this.loadArtworkImage(file);
        if (!image?.naturalWidth || !image?.naturalHeight) {
          throw new Error('This artwork could not be opened for background removal.');
        }

        const pixelCount = image.naturalWidth * image.naturalHeight;
        if (pixelCount > 12000000) {
          throw new Error('This image is too large for safe browser background removal. Please use a transparent PNG or switch the option off.');
        }

        const canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        if (!context) throw new Error('Your browser could not process this artwork.');
        context.drawImage(image, 0, 0);

        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const targetRgb = this.detectDominantEdgeColour(imageData, canvas.width, canvas.height);
        const removed = this.removeEdgeConnectedColourPixels(
          imageData,
          canvas.width,
          canvas.height,
          targetRgb,
          tolerance
        );
        if (!removed) {
          throw new Error('No matching edge-connected background was found. The artwork may already be transparent; adjust the strength if needed.');
        }
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.putImageData(imageData, 0, 0);

        const data = imageData.data;
        let minX = canvas.width;
        let minY = canvas.height;
        let maxX = -1;
        let maxY = -1;
        for (let y = 0; y < canvas.height; y += 1) {
          for (let x = 0; x < canvas.width; x += 1) {
            const alpha = data[(y * canvas.width + x) * 4 + 3];
            if (alpha <= 8) continue;
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }

        if (maxX < minX || maxY < minY) {
          throw new Error('The selected tolerance removed the entire image. Lower the tolerance and try again.');
        }

        const padding = 2;
        minX = Math.max(0, minX - padding);
        minY = Math.max(0, minY - padding);
        maxX = Math.min(canvas.width - 1, maxX + padding);
        maxY = Math.min(canvas.height - 1, maxY + padding);
        const cropWidth = maxX - minX + 1;
        const cropHeight = maxY - minY + 1;
        const croppedCanvas = document.createElement('canvas');
        croppedCanvas.width = cropWidth;
        croppedCanvas.height = cropHeight;
        const croppedContext = croppedCanvas.getContext('2d');
        if (!croppedContext) throw new Error('Your browser could not create the transparent PNG.');
        croppedContext.drawImage(canvas, minX, minY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

        const blob = await this.canvasToBlob(croppedCanvas);
        const baseName = file.name.replace(/\.[^.]+$/, '').replace(/[^a-zA-Z0-9._-]+/g, '_').slice(0, 120) || 'artwork';
        const processedFile = new File([blob], `${baseName}-background-removed.png`, {
          type: 'image/png',
          lastModified: Date.now(),
        });

        return {
          file: processedFile,
          metric: {
            fileName: processedFile.name,
            widthPx: cropWidth,
            heightPx: cropHeight,
            vector: false,
          },
        };
      }

      refreshDieCutArtworkProcessing() {
        if (!this.isDieCutPreview()) return Promise.resolve();
        const signature = this.getDieCutProcessingSignature();
        if (signature === this.dieCutPreparedSignature && (this.dieCutMetrics.length || !this.selectedArtworkFiles.length)) {
          this.updateDieCutControls(false);
          return Promise.resolve();
        }

        const processingId = ++this.dieCutProcessingId;
        this.dieCutProcessingPromise = (async () => {
          this.dieCutProcessedFile = null;
          this.revokeDieCutProcessedObjectUrl();
          this.restoreDieCutPreviewSources();
          this.updateDieCutBackgroundControls();

          if (!this.selectedArtworkFiles.length) {
            this.dieCutMetrics = [];
            this.dieCutPreparedSignature = signature;
            this.updateDieCutControls(false);
            return;
          }

          try {
            if (this.isDieCutBackgroundRemovalEnabled()) {
              const result = await this.createBackgroundRemovedArtwork(
                this.selectedArtworkFiles[0],
                this.getDieCutBackgroundTolerance(),
                { mode: this.getDieCutBackgroundMode(), colour: this.getDieCutBackgroundColour() }
              );
              if (processingId !== this.dieCutProcessingId) return;
              this.dieCutProcessedFile = result.file;
              this.dieCutMetrics = [result.metric];
              this.applyDieCutProcessedPreview();
            } else {
              const metrics = await Promise.all(this.selectedArtworkFiles.map((file) => this.analyseDieCutFile(file)));
              if (processingId !== this.dieCutProcessingId) return;
              this.dieCutMetrics = metrics.filter(Boolean);
            }

            this.dieCutPreparedSignature = signature;
            this.updateDieCutControls(false);
            this.updateArtworkBorderPreview(false);
          } catch (error) {
            if (processingId !== this.dieCutProcessingId) return;
            console.error(error);
            if (this.dieCutRemoveBackground) this.dieCutRemoveBackground.checked = false;
            this.dieCutProcessedFile = null;
            this.dieCutPreparedSignature = '';
            this.restoreDieCutPreviewSources();
            const metrics = await Promise.all(this.selectedArtworkFiles.map((file) => this.analyseDieCutFile(file)));
            if (processingId !== this.dieCutProcessingId) return;
            this.dieCutMetrics = metrics.filter(Boolean);
            this.updateDieCutControls(false);
            if (this.dieCutBackgroundStatus) {
              this.dieCutBackgroundStatus.textContent = error?.message || 'The background could not be removed.';
            }
          }
        })();

        return this.dieCutProcessingPromise;
      }

      async ensureDieCutArtworkPrepared() {
        if (!this.isDieCutPreview()) return;
        if (this.dieCutProcessingPromise) await this.dieCutProcessingPromise;
        const signature = this.getDieCutProcessingSignature();
        if (signature !== this.dieCutPreparedSignature) await this.refreshDieCutArtworkProcessing();
      }

      getDieCutProcessedUploadSignature() {
        if (!this.dieCutProcessedFile) return '';
        return JSON.stringify({
          file: [
            this.selectedArtworkFiles[0]?.name,
            this.selectedArtworkFiles[0]?.size,
            this.selectedArtworkFiles[0]?.lastModified,
          ],
          tolerance: this.getDieCutBackgroundTolerance(),
        });
      }

      async ensureDieCutProcessedArtworkUploaded(sessionId) {
        if (!this.isDieCutBackgroundRemovalEnabled()) return;
        await this.ensureDieCutArtworkPrepared();
        if (!this.dieCutProcessedFile) throw new Error('The transparent PNG is not ready yet.');
        const signature = this.getDieCutProcessedUploadSignature();
        if (signature && signature === this.dieCutProcessedUploadSignature) return;
        if (this.uploadStatus) this.uploadStatus.textContent = 'Saving the transparent PNG…';
        const result = await this.uploadSingleFile(this.dieCutProcessedFile, sessionId, 'background-removed');
        if (this.uploadZipUrlInput && result.zipUrl) this.uploadZipUrlInput.value = result.zipUrl;
        this.dieCutProcessedUploadSignature = signature;
      }

      getPreviewArtworkFiles() {
        const files = this.selectedArtworkFiles.slice();
        const useProcessed =
          (this.isDieCutBackgroundRemovalEnabled() || this.isStickerSheetBackgroundRemovalEnabled()) &&
          this.dieCutProcessedFile &&
          files.length;
        if (useProcessed) files[0] = this.dieCutProcessedFile;
        return files;
      }

      getStickerSheetMode() {
        return this.stickerSheetModeOptions.find((option) => option.checked)?.value || 'repeat';
      }

      getStickerSheetPanelCount() {
        const value = Number(this.stickerSheetPanelOptions.find((option) => option.checked)?.value || 1);
        return [1, 2, 4].includes(value) ? value : 1;
      }

      getStickerSheetBackgroundTolerance() {
        return Math.round(this.clampNumber(this.stickerSheetToleranceRange?.value, 0, 140, 115));
      }

      isStickerSheetBackgroundRemovalEnabled() {
        if (!this.isStickerSheetPreview() || !this.stickerSheetRemoveBackground?.checked) return false;
        if (this.selectedArtworkFiles.length !== 1) return false;
        return ['image/png', 'image/jpeg', 'image/webp'].includes(this.selectedArtworkFiles[0]?.type);
      }

      updateStickerSheetBackgroundControls() {
        const eligible =
          this.selectedArtworkFiles.length === 1 &&
          ['image/png', 'image/jpeg', 'image/webp'].includes(this.selectedArtworkFiles[0]?.type);

        if (this.stickerSheetRemoveBackground) {
          this.stickerSheetRemoveBackground.disabled = !eligible;
          if (!eligible) this.stickerSheetRemoveBackground.checked = false;
        }

        const enabled = this.isStickerSheetBackgroundRemovalEnabled();
        const mode = this.getStickerSheetBackgroundMode();
        if (this.stickerSheetTolerance) this.stickerSheetTolerance.hidden = !enabled;
        if (this.stickerSheetBackgroundColourRow) this.stickerSheetBackgroundColourRow.hidden = !enabled || mode !== 'colour';

        if (this.stickerSheetToleranceValue) {
          this.stickerSheetToleranceValue.textContent = `${this.getStickerSheetBackgroundTolerance()}`;
        }

        if (this.stickerSheetBackgroundStatus) {
          if (!this.selectedArtworkFiles.length) {
            this.stickerSheetBackgroundStatus.textContent = 'Optional for one JPG, PNG or WebP file.';
          } else if (!eligible) {
            this.stickerSheetBackgroundStatus.textContent =
              'Background removal is available when one JPG, PNG or WebP file is uploaded.';
          } else if (this.isStickerSheetBackgroundRemovalEnabled() && this.dieCutProcessedFile) {
            this.stickerSheetBackgroundStatus.textContent = 'Transparent PNG preview created.';
          } else if (this.isStickerSheetBackgroundRemovalEnabled()) {
            this.stickerSheetBackgroundStatus.textContent = 'Creating transparent PNG…';
          } else {
            this.stickerSheetBackgroundStatus.textContent = 'Original artwork will be used unchanged.';
          }
        }
      }

      async refreshStickerSheetArtworkProcessing() {
        if (!this.isStickerSheetPreview()) return;
        const signature = JSON.stringify({
          files: this.selectedArtworkFiles.map((file) => [file.name, file.size, file.lastModified, file.type]),
          removeBackground: this.isStickerSheetBackgroundRemovalEnabled(),
          tolerance: this.getStickerSheetBackgroundTolerance(),
          backgroundMode: this.getStickerSheetBackgroundMode(),
          backgroundColour: this.getStickerSheetBackgroundColour(),
        });

        if (
          signature === this.dieCutPreparedSignature &&
          (this.stickerSheetImages.length || !this.selectedArtworkFiles.length)
        ) {
          this.updateStickerSheetBackgroundControls();
          this.updateStickerSheetPreview();
          return;
        }

        const processingId = ++this.dieCutProcessingId;
        this.dieCutProcessingPromise = (async () => {
          this.dieCutProcessedFile = null;
          this.dieCutProcessedUploadSignature = '';
          this.stickerSheetImages = this.stickerSheetOriginalImages.slice();
          this.updateStickerSheetBackgroundControls();

          if (!this.selectedArtworkFiles.length) {
            this.dieCutPreparedSignature = signature;
            this.updateStickerSheetPreview();
            return;
          }

          try {
            if (this.isStickerSheetBackgroundRemovalEnabled()) {
              const result = await this.createBackgroundRemovedArtwork(
                this.selectedArtworkFiles[0],
                this.getStickerSheetBackgroundTolerance(),
                { mode: this.getStickerSheetBackgroundMode(), colour: this.getStickerSheetBackgroundColour() }
              );
              if (processingId !== this.dieCutProcessingId) return;
              this.dieCutProcessedFile = result.file;
              const processedImage = await this.loadArtworkImage(result.file);
              if (processingId !== this.dieCutProcessingId) return;
              this.stickerSheetImages = [
                processedImage,
                ...this.stickerSheetOriginalImages.slice(1),
              ];
            } else {
              this.stickerSheetImages = this.stickerSheetOriginalImages.slice();
            }

            this.dieCutPreparedSignature = signature;
            this.updateStickerSheetBackgroundControls();
            this.updateStickerSheetPreview();
          } catch (error) {
            if (processingId !== this.dieCutProcessingId) return;
            console.error(error);
            if (this.stickerSheetRemoveBackground) this.stickerSheetRemoveBackground.checked = false;
            this.dieCutProcessedFile = null;
            this.dieCutPreparedSignature = '';
            this.stickerSheetImages = this.stickerSheetOriginalImages.slice();
            this.updateStickerSheetBackgroundControls();
            this.updateStickerSheetPreview();
            if (this.stickerSheetBackgroundStatus) {
              this.stickerSheetBackgroundStatus.textContent =
                error?.message || 'The background could not be removed.';
            }
          }
        })();

        return this.dieCutProcessingPromise;
      }

      async ensureStickerSheetArtworkPrepared() {
        if (!this.isStickerSheetPreview()) return;
        if (this.dieCutProcessingPromise) await this.dieCutProcessingPromise;
        const signature = JSON.stringify({
          files: this.selectedArtworkFiles.map((file) => [file.name, file.size, file.lastModified, file.type]),
          removeBackground: this.isStickerSheetBackgroundRemovalEnabled(),
          tolerance: this.getStickerSheetBackgroundTolerance(),
          backgroundMode: this.getStickerSheetBackgroundMode(),
          backgroundColour: this.getStickerSheetBackgroundColour(),
        });
        if (signature !== this.dieCutPreparedSignature) {
          await this.refreshStickerSheetArtworkProcessing();
        }
      }

      async ensureStickerSheetProcessedArtworkUploaded(sessionId) {
        if (!this.isStickerSheetBackgroundRemovalEnabled()) return;
        await this.ensureStickerSheetArtworkPrepared();
        if (!this.dieCutProcessedFile) throw new Error('The transparent PNG is not ready yet.');

        const signature = JSON.stringify({
          file: [
            this.selectedArtworkFiles[0]?.name,
            this.selectedArtworkFiles[0]?.size,
            this.selectedArtworkFiles[0]?.lastModified,
          ],
          tolerance: this.getStickerSheetBackgroundTolerance(),
          backgroundMode: this.getStickerSheetBackgroundMode(),
          backgroundColour: this.getStickerSheetBackgroundColour(),
        });

        if (signature === this.dieCutProcessedUploadSignature) return;
        if (this.uploadStatus) this.uploadStatus.textContent = 'Saving the transparent PNG…';
        const result = await this.uploadSingleFile(this.dieCutProcessedFile, sessionId, 'background-removed');
        if (this.uploadZipUrlInput && result.zipUrl) this.uploadZipUrlInput.value = result.zipUrl;
        this.dieCutProcessedUploadSignature = signature;
      }

      setStickerSheetSize(value, source = '') {
        const size = Math.round(this.clampNumber(value, 20, 199, 40));
        if (this.stickerSheetSizeRange && source !== 'range') this.stickerSheetSizeRange.value = String(size);
        if (this.stickerSheetSizeNumber && source !== 'number') this.stickerSheetSizeNumber.value = String(size);
        this.previewUploadSignature = '';
        this.updateStickerSheetPreview();
      }

      resetStickerSheetPosition() {
        this.stickerSheetOffsetX = 0;
        this.stickerSheetOffsetY = 0;
        if (this.stickerSheetZoom) this.stickerSheetZoom.value = '100';
        if (this.stickerSheetZoomValue) this.stickerSheetZoomValue.textContent = '100%';
        this.previewUploadSignature = '';
      }

      startStickerSheetDrag(event) {
        if (
          !this.isStickerSheetPreview() ||
          this.getStickerSheetMode() !== 'complete-sheet' ||
          !this.selectedArtworkFiles.length
        ) return;

        event.preventDefault();
        this.stickerSheetCanvas?.setPointerCapture?.(event.pointerId);
        this.stickerSheetDragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          offsetX: this.stickerSheetOffsetX,
          offsetY: this.stickerSheetOffsetY,
        };
        if (this.stickerSheetCanvas) this.stickerSheetCanvas.classList.add('is-dragging');
      }

      moveStickerSheetDrag(event) {
        if (!this.stickerSheetDragState || this.stickerSheetDragState.pointerId !== event.pointerId) return;
        const rect = this.stickerSheetCanvas?.getBoundingClientRect();
        if (!rect?.width || !rect?.height) return;

        const deltaX = ((event.clientX - this.stickerSheetDragState.startX) / rect.width) * 200;
        const deltaY = ((event.clientY - this.stickerSheetDragState.startY) / rect.height) * 200;
        this.stickerSheetOffsetX = this.clampNumber(
          this.stickerSheetDragState.offsetX + deltaX,
          -100,
          100,
          0
        );
        this.stickerSheetOffsetY = this.clampNumber(
          this.stickerSheetDragState.offsetY + deltaY,
          -100,
          100,
          0
        );
        this.previewUploadSignature = '';
        this.updateStickerSheetPreview();
      }

      endStickerSheetDrag(event) {
        if (!this.stickerSheetDragState || this.stickerSheetDragState.pointerId !== event.pointerId) return;
        this.stickerSheetCanvas?.releasePointerCapture?.(event.pointerId);
        this.stickerSheetDragState = null;
        if (this.stickerSheetCanvas) this.stickerSheetCanvas.classList.remove('is-dragging');
      }

      getStickerSheetLayoutBase() {
        const mode = this.getStickerSheetMode();
        const sheetWidthMm = 210;
        const sheetHeightMm = 297;
        const safeMarginMm = 5.5;
        const spacingMm = 2;
        const stickerSizeMm = Math.round(
          this.clampNumber(this.stickerSheetSizeRange?.value || this.stickerSheetSizeNumber?.value, 20, 199, 40)
        );
        const usableWidthMm = sheetWidthMm - safeMarginMm * 2;
        const usableHeightMm = sheetHeightMm - safeMarginMm * 2;
        const panelCount = mode === 'complete-sheet' ? this.getStickerSheetPanelCount() : 1;
        const panelColumns = panelCount === 4 ? 2 : 1;
        const panelRows = panelCount === 1 ? 1 : 2;
        const panelGapMm = panelCount > 1 ? 2 : 0;
        const panelWidthMm =
          (usableWidthMm - Math.max(0, panelColumns - 1) * panelGapMm) / panelColumns;
        const panelHeightMm =
          (usableHeightMm - Math.max(0, panelRows - 1) * panelGapMm) / panelRows;
        const columns =
          mode === 'repeat'
            ? Math.max(1, Math.floor((usableWidthMm + spacingMm) / (stickerSizeMm + spacingMm)))
            : panelColumns;
        const rows =
          mode === 'repeat'
            ? Math.max(1, Math.floor((usableHeightMm + spacingMm) / (stickerSizeMm + spacingMm)))
            : panelRows;
        const estimatedQuantity = mode === 'repeat' ? columns * rows : panelCount;
        const fitValue = this.stickerSheetFit?.value || 'contain';
        const zoomPercent = Math.round(this.clampNumber(this.stickerSheetZoom?.value, 25, 250, 100));
        const guideMode = this.stickerSheetGuideMode?.value || 'boxes';

        return {
          mode,
          stickerSizeMm: mode === 'repeat' ? stickerSizeMm : null,
          sheetWidthMm,
          sheetHeightMm,
          safeMarginMm,
          spacingMm: mode === 'repeat' ? spacingMm : null,
          columns,
          rows,
          estimatedQuantity,
          designCount: this.selectedArtworkFiles.length,
          repeatMode: mode === 'repeat' ? 'Uploaded designs in sequence' : '',
          fitMode:
            mode === 'complete-sheet'
              ? fitValue === 'cover'
                ? 'Fill panel'
                : 'Fit whole design'
              : '',
          cutGuides: guideMode === 'none' ? 'No' : 'Yes',
          cutGuideMode:
            guideMode === 'shape'
              ? 'Artwork edge'
              : guideMode === 'boxes'
                ? 'Simple boxes'
                : 'None',
          panelCount,
          panelFormat: panelCount === 1 ? 'A4' : panelCount === 2 ? 'A5' : 'A6',
          panelColumns,
          panelRows,
          panelGapMm,
          panelWidthMm: Math.round(panelWidthMm * 10) / 10,
          panelHeightMm: Math.round(panelHeightMm * 10) / 10,
          zoomPercent: mode === 'complete-sheet' ? zoomPercent : 100,
          offsetXPercent: mode === 'complete-sheet' ? Math.round(this.stickerSheetOffsetX * 10) / 10 : 0,
          offsetYPercent: mode === 'complete-sheet' ? Math.round(this.stickerSheetOffsetY * 10) / 10 : 0,
          backgroundRemoval: this.isStickerSheetBackgroundRemovalEnabled() ? 'Yes' : 'No',
          backgroundTolerance:
            this.isStickerSheetBackgroundRemovalEnabled()
              ? this.getStickerSheetBackgroundTolerance()
              : null,
          backgroundMode: this.isStickerSheetBackgroundRemovalEnabled() ? this.getStickerSheetBackgroundMode() : '',
          backgroundColour: this.isStickerSheetBackgroundRemovalEnabled() && this.getStickerSheetBackgroundMode() === 'colour'
            ? this.getStickerSheetBackgroundColour()
            : '',
        };
      }

      calculateStickerSheetDpi(layout = this.getStickerSheetLayoutBase()) {
        const usableImages = this.stickerSheetImages.filter(
          (image) => image?.naturalWidth && image?.naturalHeight
        );
        if (!usableImages.length) return null;

        const sourceFiles = this.getPreviewArtworkFiles();
        const allVector =
          sourceFiles.length > 0 && sourceFiles.every((file) => file?.type === 'image/svg+xml');
        if (allVector) return null;

        if (layout.mode === 'repeat') {
          const values = usableImages.map((image) => {
            return Math.max(image.naturalWidth, image.naturalHeight) / (layout.stickerSizeMm / 25.4);
          });
          return values.length ? Math.min(...values.filter(Number.isFinite)) : null;
        }

        const image = usableImages[0];
        if (!image) return null;
        const containScale = Math.min(
          layout.panelWidthMm / image.naturalWidth,
          layout.panelHeightMm / image.naturalHeight
        );
        const coverScale = Math.max(
          layout.panelWidthMm / image.naturalWidth,
          layout.panelHeightMm / image.naturalHeight
        );
        const fitScale = (this.stickerSheetFit?.value || 'contain') === 'cover' ? coverScale : containScale;
        const scaledMmPerPixel = fitScale * (layout.zoomPercent / 100);
        if (!Number.isFinite(scaledMmPerPixel) || scaledMmPerPixel <= 0) return null;
        return 25.4 / scaledMmPerPixel;
      }

      getStickerSheetLayout() {
        const layout = this.getStickerSheetLayoutBase();
        const estimatedDpi = this.calculateStickerSheetDpi(layout);
        const sourceFiles = this.getPreviewArtworkFiles();
        const vector =
          sourceFiles.length > 0 && sourceFiles.every((file) => file?.type === 'image/svg+xml');
        const quality = this.getDieCutQualityLabel(estimatedDpi, vector);
        return {
          ...layout,
          estimatedDpi:
            estimatedDpi === null ? null : Math.round(estimatedDpi * 10) / 10,
          qualityLabel: quality.label,
          qualityLevel: quality.level,
        };
      }

      calculateStickerSheetTargetSize(targetDpi = 300) {
        const usableImages = this.stickerSheetImages.filter(
          (image) => image?.naturalWidth && image?.naturalHeight
        );
        if (!usableImages.length) return null;
        const sizes = usableImages
          .map((image) => (Math.max(image.naturalWidth, image.naturalHeight) / targetDpi) * 25.4)
          .filter(Number.isFinite);
        return sizes.length ? Math.floor(Math.min(...sizes)) : null;
      }

      setStickerSheetToTargetDpi(targetDpi = 300) {
        const layout = this.getStickerSheetLayout();
        if (layout.mode === 'repeat') {
          const targetSize = this.calculateStickerSheetTargetSize(targetDpi);
          if (!Number.isFinite(targetSize)) return;
          this.setStickerSheetSize(this.clampNumber(targetSize, 20, 199, 40));
          return;
        }

        if (!Number.isFinite(layout.estimatedDpi) || !this.stickerSheetZoom) return;
        const currentZoom = this.clampNumber(this.stickerSheetZoom.value, 25, 250, 100);
        const targetZoom = Math.floor(currentZoom * (layout.estimatedDpi / targetDpi));
        this.stickerSheetZoom.value = String(Math.round(this.clampNumber(targetZoom, 25, 250, 100)));
        this.previewUploadSignature = '';
        this.updateStickerSheetPreview();
      }

      setStickerSheetProperty(property, value, enabled) {
        if (!property) return;
        property.value = value || '';
        property.disabled = !enabled || !value;
      }

      updateStickerSheetProperties(layout) {
        if (!this.isStickerSheetPreview()) return;
        const active = this.selectedArtworkFiles.length > 0;
        const repeat = layout.mode === 'repeat';

        this.setStickerSheetProperty(
          this.stickerSheetProperties.mode,
          repeat ? 'Repeated artwork' : 'Complete sheet design',
          active
        );
        this.setStickerSheetProperty(
          this.stickerSheetProperties.size,
          repeat ? `${layout.stickerSizeMm} mm` : '',
          active && repeat
        );
        this.setStickerSheetProperty(
          this.stickerSheetProperties.arrangement,
          repeat ? `${layout.columns} columns × ${layout.rows} rows` : '',
          active && repeat
        );
        this.setStickerSheetProperty(
          this.stickerSheetProperties.quantity,
          repeat ? String(layout.estimatedQuantity) : '',
          active && repeat
        );
        this.setStickerSheetProperty(
          this.stickerSheetProperties.panels,
          !repeat ? `${layout.panelCount} × ${layout.panelFormat}` : '',
          active && !repeat
        );
        this.setStickerSheetProperty(
          this.stickerSheetProperties.guides,
          layout.cutGuideMode,
          active
        );
        this.setStickerSheetProperty(
          this.stickerSheetProperties.fit,
          !repeat ? layout.fitMode : '',
          active && !repeat
        );
        this.setStickerSheetProperty(
          this.stickerSheetProperties.zoom,
          !repeat ? `${layout.zoomPercent}%` : '',
          active && !repeat
        );
        this.setStickerSheetProperty(
          this.stickerSheetProperties.position,
          !repeat ? `${layout.offsetXPercent}% horizontal, ${layout.offsetYPercent}% vertical` : '',
          active && !repeat
        );
        this.setStickerSheetProperty(
          this.stickerSheetProperties.quality,
          Number.isFinite(layout.estimatedDpi)
            ? `${layout.qualityLevel === 'low' ? 'Low resolution' : `${layout.qualityLevel.charAt(0).toUpperCase()}${layout.qualityLevel.slice(1)}`} (${Math.round(layout.estimatedDpi)} DPI)`
            : layout.qualityLevel === 'excellent'
              ? 'Excellent (vector artwork)'
              : 'Manual artwork check',
          active
        );
        this.setStickerSheetProperty(
          this.stickerSheetProperties.backgroundRemoval,
          layout.backgroundRemoval,
          active
        );
        this.setStickerSheetProperty(
          this.stickerSheetProperties.backgroundTolerance,
          layout.backgroundRemoval === 'Yes' ? `Strength ${layout.backgroundTolerance}` : '',
          active && layout.backgroundRemoval === 'Yes'
        );
        this.setStickerSheetProperty(
          this.stickerSheetProperties.backgroundMode,
          layout.backgroundRemoval === 'Yes' ? (layout.backgroundMode === 'colour' ? 'Chosen colour' : 'Auto edge') : '',
          active && layout.backgroundRemoval === 'Yes'
        );
        this.setStickerSheetProperty(
          this.stickerSheetProperties.backgroundColour,
          layout.backgroundColour || '',
          active && layout.backgroundRemoval === 'Yes' && layout.backgroundMode === 'colour'
        );
      }

      updateStickerSheetMode(invalidate = true) {
        if (!this.isStickerSheetPreview()) return;
        const mode = this.getStickerSheetMode();
        if (this.stickerSheetRepeatControls) this.stickerSheetRepeatControls.hidden = mode !== 'repeat';
        if (this.stickerSheetCompleteControls) this.stickerSheetCompleteControls.hidden = mode !== 'complete-sheet';
        if (this.stickerSheetCanvas) {
          this.stickerSheetCanvas.classList.toggle(
            'is-positionable',
            mode === 'complete-sheet' && this.selectedArtworkFiles.length > 0
          );
        }
        if (invalidate) this.previewUploadSignature = '';
        this.updateStickerSheetPreview();
      }

      parseFlagPackageData() {
        const node = this.querySelector('.flag-package-data');
        if (!node) return null;
        try {
          const data = JSON.parse(node.textContent || '{}');
          return {
            currency: data.currency || 'GBP',
            packageEnabled: data.packageEnabled === true,
            mainVariants: Array.isArray(data.mainVariants) ? data.mainVariants : [],
            graphicVariants: Array.isArray(data.graphicVariants) ? data.graphicVariants : [],
            bases: Array.isArray(data.bases) ? data.bases : [],
          };
        } catch (error) {
          console.error('Could not read the Full Fibre package data.', error);
          return null;
        }
      }

      normaliseFlagShape(value) {
        const text = String(value || '').trim().toLowerCase();
        if (text.includes('teardrop')) return 'Teardrop';
        if (text.includes('blade')) return 'Blade';
        if (text.includes('crest')) return 'Crest';
        if (text.includes('rectangle') || text.includes('banner')) return 'Rectangle';
        if (text.includes('triangle') || text.includes('bunting')) return 'Triangle';
        if (text.includes('feather')) return 'Feather';
        return 'Rectangle';
      }

      normaliseFlagSize(value) {
        const text = String(value || '')
          .trim()
          .toLowerCase()
          .replace(/[_-]+/g, ' ')
          .replace(/\s+/g, ' ');
        if (text.includes('extra large') || /\bxl\b/.test(text)) return 'Extra Large';
        if (text.includes('medium plus') || /\bmedium\s*\+\b/.test(text) || /\bm\s*\+\b/.test(text) || /\bm\+\b/.test(text)) return 'Medium Plus';
        if (text.includes('large')) return 'Large';
        if (text.includes('medium')) return 'Medium';
        return 'Small';
      }

      parseFlagDimensions(value) {
        const text = String(value || '').replace(/,/g, '').trim();
        const patterns = [
          { expression: /(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)\s*cm\b/i, factor: 10 },
          { expression: /(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)\s*mm\b/i, factor: 1 },
          { expression: /(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)\s*(?:ft|feet|foot)\b/i, factor: 304.8 },
          { expression: /(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)\s*m\b/i, factor: 1000 },
        ];
        for (const { expression, factor } of patterns) {
          const match = text.match(expression);
          if (!match) continue;
          return {
            widthMm: Math.round(Number(match[1]) * factor),
            heightMm: Math.round(Number(match[2]) * factor),
          };
        }
        return null;
      }

      getFlagSpec() {
        const options = this.getSelectedOptions();
        const shapeOption = options.find((option) => /shape|style/i.test(option.name));
        const sizeOption = options.find((option) => /size|dimension|width|height/i.test(option.name));
        const rawShape = shapeOption?.value || '';
        const rawSize = sizeOption?.value || this.flagFixedSize || '';
        const profile = String(this.flagProfile || '').toLowerCase();

        if (this.isSegPreview()) {
          const combined = options.map((option) => `${option.name}: ${option.value}`).join(' · ');
          const values = options.map((option) => String(option.value || '').toLowerCase());
          const has = (pattern) => values.some((value) => pattern.test(value)) || pattern.test(combined.toLowerCase());
          let spec = {
            widthMm: 935,
            heightMm: 2185,
            safeWidthMm: 850,
            safeHeightMm: 2100,
            bleedWidthMm: 970,
            bleedHeightMm: 2220,
            size: '1 metre LUMI-EDGE lightbox',
          };

          if (profile.includes('lumi-edge-rgb-display-counter')) {
            spec = { widthMm: 935, heightMm: 935, safeWidthMm: 850, safeHeightMm: 850, bleedWidthMm: 970, bleedHeightMm: 970, size: 'LUMI-EDGE counter' };
          } else if (profile.includes('replacement-lumi-edge')) {
            if (has(/3m|3 metre/)) spec = { widthMm: 2935, heightMm: 2185, safeWidthMm: 2850, safeHeightMm: 2100, bleedWidthMm: 2970, bleedHeightMm: 2220, size: '3 metre LUMI-EDGE lightbox' };
            else if (has(/2m|2 metre/)) spec = { widthMm: 1935, heightMm: 2185, safeWidthMm: 1850, safeHeightMm: 2100, bleedWidthMm: 1970, bleedHeightMm: 2220, size: '2 metre LUMI-EDGE lightbox' };
            else if (has(/counter/)) spec = { widthMm: 935, heightMm: 935, safeWidthMm: 850, safeHeightMm: 850, bleedWidthMm: 970, bleedHeightMm: 970, size: 'LUMI-EDGE counter' };
          } else if (profile.includes('lumi-edge-rgb-seg-lightbox')) {
            if (has(/3m|3 metre/)) spec = { widthMm: 2935, heightMm: 2185, safeWidthMm: 2850, safeHeightMm: 2100, bleedWidthMm: 2970, bleedHeightMm: 2220, size: '3 metre LUMI-EDGE lightbox' };
            else if (has(/2m|2 metre/)) spec = { widthMm: 1935, heightMm: 2185, safeWidthMm: 1850, safeHeightMm: 2100, bleedWidthMm: 1970, bleedHeightMm: 2220, size: '2 metre LUMI-EDGE lightbox' };
          } else if (profile.includes('fast-fold-led-display-counter')) {
            spec = { widthMm: 1020, heightMm: 1020, safeWidthMm: 980, safeHeightMm: 980, bleedWidthMm: 1060, bleedHeightMm: 1060, size: 'FAST-FOLD counter' };
          } else if (profile.includes('replacement-fast-fold')) {
            if (has(/counter/)) spec = { widthMm: 1020, heightMm: 1020, safeWidthMm: 980, safeHeightMm: 980, bleedWidthMm: 1060, bleedHeightMm: 1060, size: 'FAST-FOLD counter' };
            else if (has(/85/)) spec = { widthMm: 870, heightMm: 2010, safeWidthMm: 810, safeHeightMm: 1950, bleedWidthMm: 930, bleedHeightMm: 2070, size: '85 cm FAST-FOLD lightbox' };
            else spec = { widthMm: 1020, heightMm: 2010, safeWidthMm: 960, safeHeightMm: 1950, bleedWidthMm: 1080, bleedHeightMm: 2070, size: '100 cm FAST-FOLD lightbox' };
          } else if (profile.includes('fast-fold-led-fabric-lightbox')) {
            if (has(/85/)) spec = { widthMm: 870, heightMm: 2010, safeWidthMm: 810, safeHeightMm: 1950, bleedWidthMm: 930, bleedHeightMm: 2070, size: '85 cm FAST-FOLD lightbox' };
            else spec = { widthMm: 1020, heightMm: 2010, safeWidthMm: 960, safeHeightMm: 1950, bleedWidthMm: 1080, bleedHeightMm: 2070, size: '100 cm FAST-FOLD lightbox' };
          }

          return {
            shape: 'Rectangle',
            size: spec.size,
            widthMm: spec.widthMm,
            heightMm: spec.heightMm,
            safeWidthMm: spec.safeWidthMm,
            safeHeightMm: spec.safeHeightMm,
            bleedWidthMm: spec.bleedWidthMm,
            bleedHeightMm: spec.bleedHeightMm,
            dimensionLabel: `${spec.widthMm} × ${spec.heightMm} mm finished panel`,
            targetPpi: 75,
            excellentPpi: 100,
            qualityCheck: true,
            available: true,
            isSeg: true,
            precision: 'exact',
            lightingStyle: profile.includes('lumi-edge') ? 'rgb-edge' : 'white-led',
          };
        }

        if (profile === 'full-fibre') {
          const shape = this.normaliseFlagShape(rawShape || 'Feather');
          const size = this.normaliseFlagSize(rawSize);
          // Verified 2026 Full Fibre finished-graphic dimensions. Medium Plus is a distinct size.
          const dimensions = {
            Feather: {
              Small: [690, 1860], Medium: [605, 2620], 'Medium Plus': [690, 2860], Large: [690, 3860], 'Extra Large': [690, 4860],
            },
            Teardrop: {
              Small: [687, 1517], Medium: [698, 2067], 'Medium Plus': [862, 2218], Large: [862, 3818],
            },
            Blade: {
              Small: [690, 1929], Medium: [605, 2666], 'Medium Plus': [690, 2929], Large: [690, 3929], 'Extra Large': [690, 4929],
            },
            Crest: {
              Small: [795, 1164], Medium: [795, 1841], 'Medium Plus': [795, 2442], Large: [795, 3695],
            },
            Rectangle: {
              Small: [690, 1860], Medium: [584, 2608], 'Medium Plus': [690, 2860], Large: [690, 3860],
            },
          };
          const doubleSided = this.isFlagDoubleSided();
          const xlSupportedShape = ['Feather', 'Blade', 'Crest'].includes(shape);
          const supported = size !== 'Extra Large' || (xlSupportedShape && !doubleSided);
          const selected = dimensions[shape]?.[size] || null;
          // The verified source confirms XL Crest exists but does not state a finished-graphic measurement.
          // Reuse the same Crest silhouette ratio for the visual canvas and require a manual production-size check.
          const previewDimensions = selected || dimensions[shape]?.Large || dimensions.Feather.Small;
          const exactDimensionsKnown = Boolean(selected);
          let unavailableMessage = '';
          if (!supported && size === 'Extra Large' && doubleSided) unavailableMessage = 'Extra Large Full Fibre flags are Single Sided only.';
          else if (!supported && size === 'Extra Large') unavailableMessage = 'Extra Large Full Fibre flags are available in Feather, Blade and Crest only.';
          return {
            shape,
            size,
            widthMm: previewDimensions[0],
            heightMm: previewDimensions[1],
            dimensionLabel: !supported
              ? unavailableMessage
              : exactDimensionsKnown
                ? `${previewDimensions[0]} × ${previewDimensions[1]} mm finished graphic`
                : `${size} ${shape} · exact finished dimensions checked professionally`,
            targetPpi: 75,
            qualityCheck: supported && exactDimensionsKnown,
            available: supported,
            precision: exactDimensionsKnown ? 'exact' : 'professional-check',
            unavailableMessage,
          };
        }

        const combinedValues = options.map((option) => option.value).join(' · ');
        const parsed = this.parseFlagDimensions(combinedValues);
        const shape = profile === 'custom-rectangle' ? 'Rectangle' : this.normaliseFlagShape(rawShape);
        const singleMeasure = String(rawSize || combinedValues).match(/(\d+(?:\.\d+)?)\s*(mm|cm|m)\b/i);
        let widthMm = parsed?.widthMm || 600;
        let heightMm = parsed?.heightMm || 2400;
        if (!parsed && singleMeasure) {
          const factor = singleMeasure[2].toLowerCase() === 'm' ? 1000 : singleMeasure[2].toLowerCase() === 'cm' ? 10 : 1;
          heightMm = Math.round(Number(singleMeasure[1]) * factor);
          widthMm = Math.max(250, Math.round(heightMm * (shape === 'Rectangle' ? 0.55 : 0.25)));
        }
        const selectedLabel = rawSize || rawShape || 'Selected product size';
        return {
          shape,
          size: selectedLabel,
          widthMm,
          heightMm,
          dimensionLabel: parsed
            ? `${widthMm} × ${heightMm} mm selected product size`
            : `${selectedLabel} · product-specific dimensions checked professionally`,
          targetPpi: 75,
          qualityCheck: Boolean(parsed),
          available: true,
        };
      }

      getFlagShapePoints(shape) {
        const shapes = {
          Feather: [[997,0],[840.7,3.6],[696.5,13.5],[559.9,29.6],[415.8,55.5],[280.7,91.3],[179.1,129.7],[103.2,169.7],[44,215.4],[12.1,256.4],[0,291.1],[0,999.5],[998.5,999.5]],
          Blade: [[998.5,0],[842.2,3.7],[681.3,15.2],[540.2,33.1],[414.3,56.8],[291.4,89.3],[182.1,130.3],[106.2,170.3],[44,218.6],[12.1,260.6],[0,298.5],[1.5,999.5],[85,968.5],[198.8,936.4],[311.1,911.7],[446.1,888.6],[587.3,870.7],[702.6,860.2],[855.8,851.3],[998.5,847.6]],
          Crest: [[998.5,0],[852.8,3.1],[692,14],[543.2,32.2],[418.8,55],[291.4,88.2],[182.1,128.7],[104.7,169.2],[42.5,217.4],[13.7,254.8],[0,295.8],[1.5,999.5],[148.7,996.4],[308,985.5],[449.2,968.3],[582.7,944],[701.1,913.3],[801.2,877.5],[889.2,833.4],[949.9,788.3],[981.8,750.4],[998.5,705.8]],
          Teardrop: [[417.4,3.3],[321.2,15.2],[201.5,41.7],[119.8,70.2],[58.1,106],[18.1,150.4],[0,194.8],[3.6,233.3],[27.2,295.6],[85.3,361.8],[167,427.4],[998.2,999.3],[987.3,70.9],[816.7,29.2],[678.8,6.6],[569.9,0],[484.6,0]],
          Rectangle: [[0,0],[1000,0],[1000,1000],[0,1000]],
          Triangle: [[500,0],[1000,1000],[0,1000]],
        };
        return (shapes[shape] || shapes.Feather).map(([x, y]) => [1000 - x, y]);
      }

      traceFlagPath(context, rectangle, shape, inset = 0) {
        const points = this.getFlagShapePoints(shape);
        const scale = Math.max(0.1, 1 - inset * 2);
        context.beginPath();
        points.forEach(([px, py], index) => {
          const x = rectangle.x + rectangle.width * (inset + (px / 1000) * scale);
          const y = rectangle.y + rectangle.height * (inset + (py / 1000) * scale);
          if (index === 0) context.moveTo(x, y);
          else context.lineTo(x, y);
        });
        context.closePath();
      }

      getFlagCanvasRectangle(spec = this.getFlagSpec()) {
        if (!this.flagCanvas) return null;
        const width = this.flagCanvas.width;
        const height = this.flagCanvas.height;
        const isWideShape = spec.shape === 'Rectangle' || spec.shape === 'Triangle';
        const maximumWidth = width * (isWideShape ? 0.9 : 0.74);
        const maximumHeight = height * (isWideShape ? 0.82 : 0.92);
        const physicalRatio = Math.max(0.05, spec.widthMm / spec.heightMm);
        const minimumVisualRatio = spec.shape === 'Crest' ? 0.25 : isWideShape ? 0.35 : 0.235;
        const maximumVisualRatio = isWideShape ? 1.8 : 0.43;
        const ratio = Math.min(maximumVisualRatio, Math.max(minimumVisualRatio, physicalRatio));
        let drawHeight = maximumHeight;
        let drawWidth = drawHeight * ratio;
        if (drawWidth > maximumWidth) {
          drawWidth = maximumWidth;
          drawHeight = drawWidth / ratio;
        }
        return {
          x: (width - drawWidth) / 2,
          y: (height - drawHeight) / 2,
          width: drawWidth,
          height: drawHeight,
        };
      }

      getFlagImageBox(image, rectangle) {
        if (!image?.naturalWidth || !image?.naturalHeight || !rectangle) return null;
        const fitMode = this.flagFit?.value === 'contain' ? 'contain' : 'cover';
        const containScale = Math.min(rectangle.width / image.naturalWidth, rectangle.height / image.naturalHeight);
        const coverScale = Math.max(rectangle.width / image.naturalWidth, rectangle.height / image.naturalHeight);
        const zoom = this.clampNumber(this.flagZoomPercent, 50, 250, 100) / 100;
        const baseScale = fitMode === 'contain' ? containScale : coverScale;
        const width = image.naturalWidth * baseScale * zoom;
        const height = image.naturalHeight * baseScale * zoom;
        return {
          x: rectangle.x + (rectangle.width - width) / 2 + (this.flagOffsetX / 100) * (rectangle.width / 2),
          y: rectangle.y + (rectangle.height - height) / 2 + (this.flagOffsetY / 100) * (rectangle.height / 2),
          width,
          height,
        };
      }

      drawFlagPreviewBackground(context, width, height) {
        if (this.isSegPreview()) {
          const gradient = context.createRadialGradient(width * 0.5, height * 0.42, 0, width * 0.5, height * 0.5, Math.max(width, height) * 0.72);
          gradient.addColorStop(0, '#171717');
          gradient.addColorStop(0.55, '#080808');
          gradient.addColorStop(1, '#020202');
          context.fillStyle = gradient;
          context.fillRect(0, 0, width, height);
          context.strokeStyle = 'rgba(255,255,255,0.035)';
          context.lineWidth = 1;
          const step = Math.max(34, Math.round(width * 0.06));
          for (let x = 0; x <= width; x += step) { context.beginPath(); context.moveTo(x, 0); context.lineTo(x, height); context.stroke(); }
          for (let y = 0; y <= height; y += step) { context.beginPath(); context.moveTo(0, y); context.lineTo(width, y); context.stroke(); }
          return;
        }
        context.fillStyle = '#E9EAEC';
        context.fillRect(0, 0, width, height);
        const tile = Math.max(16, Math.round(Math.min(width, height) * 0.025));
        context.fillStyle = '#F5F5F5';
        for (let y = 0; y < height; y += tile) {
          for (let x = 0; x < width; x += tile) {
            if ((x / tile + y / tile) % 2 === 0) context.fillRect(x, y, tile, tile);
          }
        }
      }

      getSegGlowColour() {
        return this.segGlowColour?.value || (this.getFlagSpec().lightingStyle === 'rgb-edge' ? '#ff2438' : '#ffffff');
      }

      getSegGlowIntensity() {
        return this.clampNumber(this.segGlowIntensity?.value, 0, 100, 65);
      }

      areSegLightsOn() {
        return this.segLights?.checked !== false;
      }

      getSegInternalLightingMirrorSelect() {
        return this.flagVariantSelects.find((select) => /internal lighting|lighting kit/i.test(String(select.dataset.optionName || ''))) || null;
      }

      getSegInternalLightingValue(isOn) {
        const select = this.getSegInternalLightingMirrorSelect();
        if (!select) return null;
        const patterns = isOn
          ? [/^yes$/i, /^on$/i, /included/i, /^with/i]
          : [/^no$/i, /^off$/i, /without/i, /not included/i];
        const options = Array.from(select.options || []);
        const enabled = options.filter((option) => !option.disabled);
        return [...enabled, ...options].find((option) => patterns.some((pattern) => pattern.test(String(option.value || option.textContent || '').trim())))?.value || null;
      }

      setSegInternalLightingFromToggle() {
        if (!this.segLights || !this.isSegPreview()) return false;
        const select = this.getSegInternalLightingMirrorSelect();
        if (!select) return false;
        const desiredValue = this.getSegInternalLightingValue(this.segLights.checked);
        if (!desiredValue) {
          this.syncSegLightsToVariant();
          return true;
        }
        if (String(select.value) === String(desiredValue)) {
          this.previewUploadSignature = '';
          this.updateFlagPreview();
          return true;
        }
        this.setOriginalFlagOption(select.dataset.optionName, desiredValue);
        return true;
      }

      syncSegLightsToVariant() {
        if (!this.segLights || !this.isSegPreview()) return;
        const internalOption = this.getSelectedOptions().find((option) => /internal lighting|lighting kit/i.test(option.name));
        if (!internalOption) return;
        const value = String(internalOption.value || '').trim();
        const off = /^(no|off)$/i.test(value) || /without|not included/i.test(value);
        const on = /^(yes|on)$/i.test(value) || /included|^with/i.test(value);
        if (on || off) this.segLights.checked = on;
      }

      hasSegInternalLighting() {
        if (!this.isSegPreview()) return false;
        const profile = String(this.flagProfile || '').toLowerCase();
        if (!profile.includes('lumi-edge')) return true;
        const internalOption = this.getSelectedOptions().find((option) => /internal lighting|lighting kit/i.test(option.name));
        if (!internalOption) return true;
        return /yes|included|with/i.test(String(internalOption.value || ''));
      }

      drawSegDisplayPreview(context, spec, rectangle, box) {
        // SEG lighting has two independent systems:
        // - Backlight: simulated illumination through the printed graphic.
        // - RGB edge: the permanent LUMI-EDGE frame lighting, controlled only by Edge colour.
        // Do not let the Backlight preview toggle switch the LUMI-EDGE perimeter LEDs off.
        const backlightOn = this.areSegLightsOn();
        const rgbEdge = spec.lightingStyle === 'rgb-edge';
        const frameLightingOn = rgbEdge || backlightOn;
        const glow = this.getSegGlowColour();
        const intensity = this.getSegGlowIntensity() / 100;
        const internalLighting = this.hasSegInternalLighting();
        const frame = Math.max(12, Math.min(rectangle.width, rectangle.height) * 0.035);

        context.save();
        context.shadowColor = frameLightingOn ? glow : 'rgba(0,0,0,0.8)';
        context.shadowBlur = frameLightingOn ? 26 + 70 * intensity : 18;
        context.shadowOffsetY = 8;
        context.fillStyle = '#050505';
        context.fillRect(rectangle.x - frame, rectangle.y - frame, rectangle.width + frame * 2, rectangle.height + frame * 2);
        context.restore();

        context.save();
        context.beginPath();
        context.rect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
        context.clip();
        context.fillStyle = backlightOn ? '#f8f8f8' : '#202020';
        context.fillRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
        if (this.flagImage && box) {
          context.filter = backlightOn
            ? (internalLighting ? 'brightness(1.12) contrast(1.08) saturate(1.18)' : 'brightness(0.78) contrast(1.04) saturate(1.08)')
            : 'brightness(0.55) contrast(0.96) saturate(0.72)';
          context.drawImage(this.flagImage, box.x, box.y, box.width, box.height);
          context.filter = 'none';
          if (backlightOn && internalLighting) {
            context.globalCompositeOperation = 'screen';
            context.fillStyle = `rgba(255,255,255,${0.05 + intensity * 0.12})`;
            context.fillRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
          }
        } else if (this.flagFile) {
          context.fillStyle = backlightOn ? '#f7f7f7' : '#252525';
          context.fillRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
          context.fillStyle = backlightOn ? '#111111' : '#ffffff';
          context.textAlign = 'center';
          context.font = '700 48px sans-serif';
          context.fillText('PDF', rectangle.x + rectangle.width / 2, rectangle.y + rectangle.height / 2 - 8);
          context.font = '400 22px sans-serif';
          context.fillText('Professional artwork check', rectangle.x + rectangle.width / 2, rectangle.y + rectangle.height / 2 + 34);
        }
        context.restore();

        context.save();
        context.strokeStyle = '#050505';
        context.lineWidth = frame * 1.9;
        context.strokeRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);

        // LUMI-EDGE RGB perimeter lighting is part of the frame itself and remains
        // illuminated regardless of the separate Backlight preview state.
        if (rgbEdge) {
          context.shadowColor = glow;
          context.shadowBlur = 18 + 44 * intensity;
          context.strokeStyle = glow;
          context.lineWidth = Math.max(5, frame * 0.38);
          context.strokeRect(rectangle.x - frame * 0.52, rectangle.y - frame * 0.52, rectangle.width + frame * 1.04, rectangle.height + frame * 1.04);
        } else if (backlightOn) {
          context.shadowColor = glow;
          context.shadowBlur = 18 + 44 * intensity;
          context.strokeStyle = 'rgba(255,255,255,0.96)';
          context.lineWidth = Math.max(5, frame * 0.38);
          context.strokeRect(rectangle.x - frame * 0.52, rectangle.y - frame * 0.52, rectangle.width + frame * 1.04, rectangle.height + frame * 1.04);
          context.strokeStyle = `rgba(255,255,255,${0.35 + intensity * 0.5})`;
          context.lineWidth = Math.max(3, frame * 0.22);
          context.strokeRect(rectangle.x + frame * 0.35, rectangle.y + frame * 0.35, rectangle.width - frame * 0.7, rectangle.height - frame * 0.7);
        }
        context.restore();

        if (this.flagGuide?.checked) {
          context.save();
          const insetX = spec.safeWidthMm
            ? Math.max(8, ((spec.widthMm - spec.safeWidthMm) / 2 / spec.widthMm) * rectangle.width)
            : Math.max(14, rectangle.width * 0.06);
          const insetY = spec.safeHeightMm
            ? Math.max(8, ((spec.heightMm - spec.safeHeightMm) / 2 / spec.heightMm) * rectangle.height)
            : Math.max(14, rectangle.height * 0.06);
          context.setLineDash([12, 10]);
          context.strokeStyle = backlightOn ? 'rgba(255,255,255,0.82)' : 'rgba(255,36,56,0.9)';
          context.lineWidth = 2.5;
          context.strokeRect(rectangle.x + insetX, rectangle.y + insetY, rectangle.width - insetX * 2, rectangle.height - insetY * 2);
          context.restore();
        }

      }

      updateFlagProperty(input, value, enabled = true) {
        if (!input) return;
        input.value = value || '';
        input.disabled = !enabled;
      }

      isFlagDoubleSided() {
        if (this.isSegPreview()) {
          const profile = String(this.flagProfile || '').toLowerCase();
          if (profile.startsWith('custom-')) return true;
          return this.getSelectedOptions().some((option) => /double|pair/i.test(String(option.value || '')));
        }
        return /double/i.test(this.getSelectedOptions().find((option) => /print|side|finish/i.test(option.name))?.value || '');
      }

      isFlagExtraLarge() {
        return this.getFlagSpec().size === 'Extra Large';
      }

      getFlagFileForSide(side = this.flagActiveSide) {
        if (side === 'reverse' && this.flagUseSameArtwork?.checked) return this.flagFiles.front;
        return this.flagFiles[side] || null;
      }

      getFlagImageForSide(side = this.flagActiveSide) {
        if (side === 'reverse' && this.flagUseSameArtwork?.checked) return this.flagImages.front;
        return this.flagImages[side] || null;
      }

      getFlagStateSide(side = this.flagActiveSide) {
        return side === 'reverse' && this.flagUseSameArtwork?.checked ? 'front' : side;
      }

      saveFlagSideState(side = this.flagActiveSide) {
        const stateSide = this.getFlagStateSide(side);
        if (!this.flagSideStates?.[stateSide]) return;
        this.flagSideStates[stateSide] = {
          fit: this.flagFit?.value === 'contain' ? 'contain' : 'cover',
          zoom: this.clampNumber(this.flagZoomPercent, 50, 250, 100),
          x: this.clampNumber(this.flagOffsetX, -150, 150, 0),
          y: this.clampNumber(this.flagOffsetY, -150, 150, 0),
        };
      }

      loadFlagSideState(side = this.flagActiveSide) {
        const stateSide = this.getFlagStateSide(side);
        const state = this.flagSideStates?.[stateSide] || { fit: 'cover', zoom: 100, x: 0, y: 0 };
        this.flagZoomPercent = state.zoom;
        this.flagOffsetX = state.x;
        this.flagOffsetY = state.y;
        if (this.flagFit) this.flagFit.value = state.fit;
        if (this.flagZoom) this.flagZoom.value = String(Math.round(this.flagZoomToControl(state.zoom)));
        if (this.flagZoomValue) this.flagZoomValue.textContent = `${Math.round(state.zoom)}%`;
      }

      setFlagActiveSide(side = 'front') {
        const requested = side === 'reverse' && this.isFlagDoubleSided() ? 'reverse' : 'front';
        this.saveFlagSideState();
        this.flagActiveSide = requested;
        this.loadFlagSideState(requested);
        this.flagSideTabs.forEach((tab) => {
          const active = tab.dataset.flagSide === requested;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.previewUploadSignature = '';
        this.updateFlagPreview();
      }

      updateFlagSideControls() {
        if (!this.isFlagPreview()) return;
        const doubleSided = this.isFlagDoubleSided();
        if (this.flagSideControls) this.flagSideControls.hidden = !doubleSided;
        if (!doubleSided && this.flagActiveSide === 'reverse') this.setFlagActiveSide('front');
        const useSame = this.flagUseSameArtwork?.checked !== false;
        if (this.flagReverseUpload) this.flagReverseUpload.hidden = !doubleSided || useSame;
        this.flagSideTabs.forEach((tab) => {
          if (tab.dataset.flagSide === 'reverse') tab.disabled = !doubleSided;
        });
        if (this.flagReverseFileLabel) {
          const reverseFile = this.flagFiles.reverse;
          this.flagReverseFileLabel.textContent = useSame
            ? 'Using the front artwork'
            : reverseFile
              ? `${reverseFile.name} · ${this.formatFileSize(reverseFile.size)}`
              : 'No reverse artwork selected';
        }
        this.updateFlagProperty(
          this.flagProperties.sides,
          doubleSided ? (useSame ? 'Same artwork on both sides' : 'Different front and reverse artwork') : 'Single sided',
          Boolean(this.flagFiles.front)
        );
      }

      syncFlagSelectedFiles() {
        const files = [];
        if (this.flagFiles.front) files.push(this.flagFiles.front);
        if (this.isFlagDoubleSided() && !this.flagUseSameArtwork?.checked && this.flagFiles.reverse) files.push(this.flagFiles.reverse);
        this.selectedArtworkFiles = files;
        if (this.uploadFileList) {
          this.uploadFileList.innerHTML = '';
          if (this.flagFiles.front) {
            const front = document.createElement('div');
            front.textContent = `Front: ${this.flagFiles.front.name} · ${this.formatFileSize(this.flagFiles.front.size)}`;
            this.uploadFileList.appendChild(front);
          }
          if (this.isFlagDoubleSided()) {
            const reverse = document.createElement('div');
            reverse.textContent = this.flagUseSameArtwork?.checked
              ? 'Reverse: same as front'
              : this.flagFiles.reverse
                ? `Reverse: ${this.flagFiles.reverse.name} · ${this.formatFileSize(this.flagFiles.reverse.size)}`
                : 'Reverse: not uploaded yet';
            this.uploadFileList.appendChild(reverse);
          }
        }
        if (this.artworkBuilderAfterUpload) this.artworkBuilderAfterUpload.hidden = !this.flagFiles.front;
        if (this.clearArtworkButton) this.clearArtworkButton.hidden = !this.flagFiles.front;
        this.updateFlagSideControls();
      }

      async loadFlagFileForSide(side, file) {
        this.flagImages[side] = null;
        if (!file || !['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'].includes(file.type)) return;
        this.flagImageLoadId += 1;
        this.flagImages[side] = await this.loadArtworkImage(file);
      }

      async uploadCurrentFlagFiles() {
        if (!this.flagFiles.front) return;
        const uploadGeneration = ++this.uploadGeneration;
        const files = this.selectedArtworkFiles.slice();
        const validationError = this.validateArtworkFiles(files);
        if (validationError) throw new Error(validationError);
        this.handleErrorMessage();
        this.resetUploadedReferences();
        this.isArtworkUploading = true;
        if (this.uploadStatus) this.uploadStatus.textContent = files.length > 1 ? 'Uploading front and reverse artwork...' : 'Uploading artwork...';
        const sessionId = this.generateSessionId();
        try {
          const results = [];
          for (const [index, file] of files.entries()) {
            const role = index === 0 ? 'front-original' : 'reverse-original';
            results.push(await this.uploadSingleFile(file, sessionId, role));
          }
          if (uploadGeneration !== this.uploadGeneration) return;
          const tokens = results.map((result) => result.token || '').filter(Boolean);
          const filenames = results.map((result) => result.filename || '').filter(Boolean);
          const objectKeys = results.map((result) => result.objectKey || '').filter(Boolean);
          if (this.uploadTokenInput) this.uploadTokenInput.value = tokens.join(', ');
          if (this.uploadFilenameInput) this.uploadFilenameInput.value = filenames.join(', ');
          if (this.uploadObjectKeyInput) this.uploadObjectKeyInput.value = objectKeys.join(', ');
          if (this.uploadSessionIdInput) this.uploadSessionIdInput.value = sessionId;
          if (this.uploadZipUrlInput) this.uploadZipUrlInput.value = results[0]?.zipUrl || '';
          if (this.uploadStatus) this.uploadStatus.textContent = files.length > 1 ? 'Front and reverse artwork ready' : `Artwork ready: ${filenames[0] || files[0].name}`;
        } catch (error) {
          if (uploadGeneration !== this.uploadGeneration) return;
          this.resetUploadedReferences();
          if (this.uploadStatus) this.uploadStatus.textContent = error.message || 'Upload failed. Please try again.';
          this.handleErrorMessage(this.uploadStatus?.textContent || error.message);
          throw error;
        } finally {
          if (uploadGeneration === this.uploadGeneration) this.isArtworkUploading = false;
        }
      }

      async onFlagFileChange(evt) {
        const side = evt.target.dataset.flagSide === 'reverse' ? 'reverse' : 'front';
        const file = evt.target.files?.[0] || null;
        if (!file) return;
        const validationError = this.validateArtworkFiles([file]);
        if (validationError) {
          evt.target.value = '';
          this.handleErrorMessage(validationError);
          if (this.uploadStatus) this.uploadStatus.textContent = validationError;
          return;
        }
        if (side === 'reverse' && !this.flagFiles.front) {
          evt.target.value = '';
          this.handleErrorMessage('Please upload the front artwork first.');
          return;
        }
        this.flagFiles[side] = file;
        this.flagSideStates[side] = { fit: 'cover', zoom: 100, x: 0, y: 0 };
        await this.loadFlagFileForSide(side, file);
        this.syncFlagSelectedFiles();
        if (this.flagMaker) this.flagMaker.hidden = false;
        if (this.artworkPreview) this.artworkPreview.hidden = false;
        this.setFlagActiveSide(side);
        try {
          await this.uploadCurrentFlagFiles();
        } catch {
          // The upload helper has already shown the customer-facing error.
        }
      }

      getFlagQualityFor(image, file, spec, box) {
        if (!spec?.qualityCheck || !image || !box || !spec || !this.flagLastRect || file?.type === 'image/svg+xml') {
          return { ppi: null, label: 'Professional review', status: 'manual' };
        }
        const printedWidthMm = spec.widthMm * (box.width / this.flagLastRect.width);
        const printedHeightMm = spec.heightMm * (box.height / this.flagLastRect.height);
        const horizontalPpi = image.naturalWidth / Math.max(0.01, printedWidthMm / 25.4);
        const verticalPpi = image.naturalHeight / Math.max(0.01, printedHeightMm / 25.4);
        const ppi = Math.round(Math.min(horizontalPpi, verticalPpi));
        const target = Number(spec.targetPpi) || 75;
        if (spec.isSeg) {
          const excellent = Number(spec.excellentPpi) || 100;
          if (ppi >= excellent) return { ppi, label: 'Excellent', status: 'good' };
          if (ppi >= target) return { ppi, label: 'Meets specification', status: 'good' };
          if (ppi >= 60) return { ppi, label: 'Professional review', status: 'review' };
          return { ppi, label: 'Low resolution', status: 'poor' };
        }
        if (ppi >= target) return { ppi, label: 'Meets recommended resolution', status: 'good' };
        if (ppi >= target * 0.8) return { ppi, label: 'Slightly below recommendation', status: 'review' };
        if (ppi >= target * 0.55) return { ppi, label: 'Low resolution at this size', status: 'low' };
        return { ppi, label: 'Very low resolution at this size', status: 'poor' };
      }

      getFlagQuality(spec, box) {
        return this.getFlagQualityFor(this.flagImage, this.flagFile, spec, box);
      }

      updateFlagDetails(spec, box) {
        if (!this.isFlagPreview()) return;
        const active = Boolean(this.flagFiles.front);
        const file = this.flagFile || null;
        const quality = spec.available
          ? this.getFlagQuality(spec, box)
          : { ppi: null, label: 'This size and shape combination is unavailable', status: 'poor' };
        if (this.flagShapeValue) this.flagShapeValue.textContent = spec.isSeg ? spec.size : `${spec.size} ${spec.shape}`;
        if (this.flagDimensionsValue) {
          this.flagDimensionsValue.textContent = spec.dimensionLabel || (spec.available
            ? `${spec.widthMm} × ${spec.heightMm} mm approx. finished graphic`
            : (spec.unavailableMessage || 'This Full Fibre size and shape combination is unavailable.'));
        }
        if (this.flagHint) {
          this.flagHint.textContent = spec.isSeg
            ? `The checker estimates effective resolution at the selected ${spec.precision === 'exact' ? 'visible graphic size' : 'approximate display size'}. We recommend at least ${spec.targetPpi} PPI at finished size for close-viewed illuminated fabric displays. PDF and SVG files still receive a professional artwork check.`
            : spec.qualityCheck
              ? 'Recommended raster resolution is 75 PPI at finished size, equivalent to the supplier specification of 300 DPI at 25% scale. PDF and SVG files still receive a professional artwork check.'
              : 'This flag uses its own product-specific artwork dimensions. The preview shows the selected format, and the production size and resolution will be checked professionally before printing.';
        }
        if (this.flagPpiValue) {
          this.flagPpiValue.textContent = quality.ppi === null ? (file ? 'Manual check' : '—') : `${quality.ppi} PPI`;
          this.flagPpiValue.dataset.quality = quality.status;
        }
        if (this.flagQualityValue) this.flagQualityValue.textContent = file ? quality.label : 'Upload artwork';
        if (this.flagAlert) {
          const unavailable = !spec.available;
          const show = unavailable || Boolean(file && quality.ppi !== null && quality.ppi < 75);
          this.flagAlert.hidden = !show;
          this.flagAlert.textContent = unavailable
            ? (spec.unavailableMessage || 'This Full Fibre size and shape combination is unavailable.')
            : show
              ? (spec.isSeg ? `${quality.ppi} PPI · larger artwork recommended` : `${quality.label}. Try a larger file, reduce the artwork scale, use less cropping or select a smaller flag.`)
              : '';
          this.flagAlert.dataset.quality = quality.status;
        }
        if (this.flagFileSummary) {
          const sideLabel = this.isFlagDoubleSided() ? `${this.flagActiveSide === 'reverse' ? 'Reverse' : 'Front'} · ` : '';
          if (!file) this.flagFileSummary.textContent = '';
          else if (this.flagImage) this.flagFileSummary.textContent = `${sideLabel}${file.name} · ${this.flagImage.naturalWidth} × ${this.flagImage.naturalHeight} px · ${this.formatFileSize(file.size)}`;
          else this.flagFileSummary.textContent = `${sideLabel}${file.name} · ${this.formatFileSize(file.size)} · PDF/vector structure checked professionally`;
        }
        const fitLabel = this.flagFit?.value === 'contain' ? 'Fit whole artwork' : (spec.isSeg ? 'Fill display' : 'Fill flag');
        const qualityLabel = !spec.available
          ? 'Unavailable combination'
          : quality.ppi === null
            ? 'Professional review required'
            : `${quality.ppi} PPI — ${quality.label}`;
        this.updateFlagProperty(this.flagProperties.fit, fitLabel, active);
        this.updateFlagProperty(this.flagProperties.scale, `${Math.round(this.flagZoomPercent)}%`, active);
        this.updateFlagProperty(this.flagProperties.position, `X ${Math.round(this.flagOffsetX)}% · Y ${Math.round(this.flagOffsetY)}%`, active);
        this.updateFlagProperty(
          this.flagProperties.shape,
          spec.available ? `${spec.size} ${spec.shape} · ${spec.dimensionLabel || `${spec.widthMm} × ${spec.heightMm} mm`}` : `${spec.size} ${spec.shape} · unavailable`,
          active
        );
        this.updateFlagProperty(this.flagProperties.quality, qualityLabel, active);
        if (spec.isSeg) {
          this.updateFlagProperty(
            this.flagProperties.lighting,
            `${this.areSegLightsOn() ? 'Backlight on' : 'Backlight off'}${spec.lightingStyle === 'rgb-edge' ? ` · RGB edge ${this.getSegGlowColour()}` : ''} · ${Math.round(this.getSegGlowIntensity())}% preview glow`,
            active
          );
        }
        this.updateFlagSideControls();
      }

      updateFlagPreview() {
        if (!this.isFlagPreview() || !this.flagCanvas) return;
        this.flagFile = this.getFlagFileForSide();
        this.flagImage = this.getFlagImageForSide();
        const context = this.flagCanvas.getContext('2d');
        if (!context) return;
        const spec = this.getFlagSpec();
        const rectangle = this.getFlagCanvasRectangle(spec);
        this.flagLastRect = rectangle;
        this.drawFlagPreviewBackground(context, this.flagCanvas.width, this.flagCanvas.height);
        const box = this.getFlagImageBox(this.flagImage, rectangle);
        this.flagLastBox = box;

        if (spec.isSeg) {
          this.drawSegDisplayPreview(context, spec, rectangle, box);
        } else {
          context.save();
          context.shadowColor = 'rgba(0,0,0,0.20)';
          context.shadowBlur = 18;
          context.shadowOffsetY = 8;
          this.traceFlagPath(context, rectangle, spec.shape);
          context.fillStyle = '#FFFFFF';
          context.fill();
          context.restore();

          if (this.flagImage && box) {
            context.save();
            this.traceFlagPath(context, rectangle, spec.shape);
            context.clip();
            context.drawImage(this.flagImage, box.x, box.y, box.width, box.height);
            context.restore();
          } else if (this.flagFile) {
            context.save();
            this.traceFlagPath(context, rectangle, spec.shape);
            context.clip();
            context.fillStyle = '#FFFFFF';
            context.fillRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
            context.fillStyle = '#111111';
            context.textAlign = 'center';
            context.font = '700 48px sans-serif';
            context.fillText('PDF', rectangle.x + rectangle.width / 2, rectangle.y + rectangle.height / 2 - 8);
            context.font = '400 24px sans-serif';
            context.fillText('Professional artwork check', rectangle.x + rectangle.width / 2, rectangle.y + rectangle.height / 2 + 38);
            context.restore();
          }

          context.save();
          this.traceFlagPath(context, rectangle, spec.shape);
          context.strokeStyle = '#111111';
          context.lineWidth = Math.max(4, this.flagCanvas.width * 0.006);
          context.stroke();
          context.restore();

          if (this.flagGuide?.checked) {
            context.save();
            this.traceFlagPath(context, rectangle, spec.shape, 0.075);
            context.setLineDash([14, 12]);
            context.strokeStyle = 'rgba(165,42,49,0.92)';
            context.lineWidth = 4;
            context.stroke();
            context.restore();
          }
        }

        this.flagCanvas.classList.toggle('is-positionable', Boolean(this.flagImage));
        if (this.flagMaker) this.flagMaker.hidden = !this.flagFiles.front;
        this.updateFlagDetails(spec, box);
        this.updateFlagPackageUI();
      }

      renderFlagPreview(files) {
        if (!this.isFlagPreview()) return;
        if (!this.flagFiles.front && files?.[0]) this.flagFiles.front = files[0];
        if (!this.flagFiles.reverse && files?.[1]) this.flagFiles.reverse = files[1];
        this.syncFlagSelectedFiles();
        if (this.flagMaker) this.flagMaker.hidden = !this.flagFiles.front;
        if (this.artworkPreview) this.artworkPreview.hidden = !this.flagFiles.front;
        Promise.all([
          this.loadFlagFileForSide('front', this.flagFiles.front),
          this.loadFlagFileForSide('reverse', this.flagFiles.reverse),
        ]).then(() => this.updateFlagPreview());
      }

      flagCanvasPoint(event) {
        if (!this.flagCanvas) return { x: 0, y: 0 };
        const bounds = this.flagCanvas.getBoundingClientRect();
        return {
          x: (event.clientX - bounds.left) * (this.flagCanvas.width / Math.max(1, bounds.width)),
          y: (event.clientY - bounds.top) * (this.flagCanvas.height / Math.max(1, bounds.height)),
        };
      }

      startFlagDrag(event) {
        if (!this.isFlagPreview() || !this.flagImage || !this.flagLastRect) return;
        const point = this.flagCanvasPoint(event);
        this.flagDragState = { point, x: this.flagOffsetX, y: this.flagOffsetY, pointerId: event.pointerId };
        this.flagCanvas.setPointerCapture?.(event.pointerId);
      }

      moveFlagDrag(event) {
        if (!this.flagDragState || !this.flagLastRect) return;
        const point = this.flagCanvasPoint(event);
        const deltaX = point.x - this.flagDragState.point.x;
        const deltaY = point.y - this.flagDragState.point.y;
        this.flagOffsetX = this.clampNumber(this.flagDragState.x + (deltaX / Math.max(1, this.flagLastRect.width / 2)) * 100, -150, 150, 0);
        this.flagOffsetY = this.clampNumber(this.flagDragState.y + (deltaY / Math.max(1, this.flagLastRect.height / 2)) * 100, -150, 150, 0);
        this.saveFlagSideState();
        this.previewUploadSignature = '';
        this.updateFlagPreview();
      }

      endFlagDrag(event) {
        if (!this.flagDragState) return;
        this.flagCanvas?.releasePointerCapture?.(event.pointerId);
        this.flagDragState = null;
      }

      getFlagDetails() {
        const spec = this.getFlagSpec();
        const quality = this.getFlagQuality(spec, this.flagLastBox);
        const doubleSided = this.isFlagDoubleSided();
        return {
          shape: spec.shape,
          size: spec.size,
          finishedWidthMm: spec.widthMm,
          finishedHeightMm: spec.heightMm,
          activeSide: this.flagActiveSide,
          sides: doubleSided ? (this.flagUseSameArtwork?.checked ? 'same-artwork' : 'different-artwork') : 'single-sided',
          frontFile: this.flagFiles.front?.name || '',
          reverseFile: doubleSided && !this.flagUseSameArtwork?.checked ? this.flagFiles.reverse?.name || '' : '',
          fitMode: this.flagFit?.value === 'contain' ? 'contain' : 'cover',
          zoomPercent: Math.round(this.flagZoomPercent),
          offsetXPercent: Math.round(this.flagOffsetX),
          offsetYPercent: Math.round(this.flagOffsetY),
          sideStates: this.flagSideStates,
          estimatedPpi: quality.ppi,
          quality: quality.label,
          targetPpi: spec.targetPpi,
          guideShown: Boolean(this.flagGuide?.checked),
          previewKind: spec.isSeg ? 'seg-lightbox' : 'flag',
          lightsOn: spec.isSeg ? this.areSegLightsOn() : null,
          internalLighting: spec.isSeg ? this.hasSegInternalLighting() : null,
          glowColour: spec.isSeg ? this.getSegGlowColour() : '',
          glowIntensity: spec.isSeg ? Math.round(this.getSegGlowIntensity()) : null,
          dimensionPrecision: spec.precision || 'exact',
          package: this.flagPackageData?.packageEnabled ? this.getFlagPackageMode() : 'standard-product',
          base: this.flagPackageData?.packageEnabled ? this.getFlagSelectedBaseData()?.title || '' : '',
        };
      }

      formatFlagMoney(cents) {
        const amount = (Number(cents) || 0) / 100;
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.flagPackageData?.currency || 'GBP',
          }).format(amount);
        } catch {
          return `£${amount.toFixed(2)}`;
        }
      }

      getFlagSelectedOptionValues() {
        if (this.flagVariantSelects.length) return this.flagVariantSelects.map((select) => select.value);
        return this.getSelectedOptions().map((option) => option.value);
      }

      findFlagVariant(variants, optionValues = this.getFlagSelectedOptionValues()) {
        const wanted = optionValues.map((value) => String(value || '').trim().toLowerCase());
        return (variants || []).find((variant) => {
          const options = (variant.options || []).map((value) => String(value || '').trim().toLowerCase());
          return options.length === wanted.length && options.every((value, index) => value === wanted[index]);
        }) || null;
      }

      getFlagPackageMode() {
        return this.flagPackageOptions.find((option) => option.checked)?.value || 'pole';
      }

      getFlagSelectedBaseData() {
        const selected = this.flagBaseOptions.find((option) => option.checked);
        if (!selected) return null;
        return this.flagPackageData?.bases?.find((base) => String(base.id) === String(selected.value)) || {
          id: Number(selected.value),
          title: selected.dataset.title || '',
          price: Number(selected.dataset.price) || 0,
          available: !selected.disabled,
          sku: selected.dataset.sku || '',
        };
      }

      setOriginalFlagOption(optionName, value) {
        if (!this.isFlagPreview()) return;
        const variantSelects = this.getCurrentVariantSelects();
        if (!variantSelects) return;
        const normalise = (text) => String(text || '').replace(/:\s*$/, '').trim().toLowerCase();
        const wantedName = normalise(optionName);
        const select = Array.from(variantSelects.querySelectorAll('select[name^="options["]')).find((candidate) => {
          const match = candidate.name.match(/^options\[(.+)\]$/);
          return normalise(match?.[1]) === wantedName;
        });
        if (select) {
          if (select.value === value) return;
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        const radio = Array.from(variantSelects.querySelectorAll('input[data-option-name]')).find(
          (candidate) => normalise(candidate.dataset.optionName) === wantedName && candidate.value === value
        );
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      syncFlagMirrorControls() {
        if (!this.isFlagPreview()) return;
        const selectedMap = new Map(this.getSelectedOptions().map((option) => [option.name.toLowerCase(), option.value]));
        this.flagVariantSelects.forEach((select) => {
          const value = selectedMap.get(String(select.dataset.optionName || '').toLowerCase());
          if (value && Array.from(select.options).some((option) => option.value === value)) select.value = value;
        });
        const values = this.getFlagSelectedOptionValues();
        if (this.flagPackageData?.mainVariants?.length) {
          this.flagVariantSelects.forEach((select, optionIndex) => {
            Array.from(select.options).forEach((option) => {
              const candidate = values.slice();
              candidate[optionIndex] = option.value;
              option.disabled = !this.flagPackageData.mainVariants.some((variant) => {
                if (!variant.available) return false;
                return (variant.options || []).every((value, index) => String(value).toLowerCase() === String(candidate[index]).toLowerCase());
              });
            });
          });
        }
        const mainQuantity = this.productSectionRoot?.querySelector('input[name="quantity"]');
        if (this.flagQuantity && mainQuantity && document.activeElement !== this.flagQuantity) this.flagQuantity.value = mainQuantity.value || '1';
        this.syncSegLightsToVariant();
        this.updateFlagPackageUI();
      }

      syncFlagQuantityToMain() {
        const quantity = Math.max(1, Math.round(Number(this.flagQuantity?.value) || 1));
        if (this.flagQuantity) this.flagQuantity.value = String(quantity);
        const mainQuantity = this.productSectionRoot?.querySelector('input[name="quantity"]');
        if (mainQuantity && mainQuantity.value !== String(quantity)) {
          mainQuantity.value = String(quantity);
          mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.updateFlagPackageUI();
      }

      updateFlagPackageUI() {
        if (!this.isFlagPreview() || !this.flagPackageData) return;
        const optionValues = this.getFlagSelectedOptionValues();
        const quantity = Math.max(1, Math.round(Number(this.flagQuantity?.value) || 1));
        if (!this.flagPackageData.packageEnabled) {
          const selectedVariant = this.findFlagVariant(this.flagPackageData.mainVariants, optionValues);
          if (this.flagSelectionSummary) this.flagSelectionSummary.textContent = optionValues.join(' · ');
          if (this.flagPrice) this.flagPrice.textContent = selectedVariant ? this.formatFlagMoney(selectedVariant.price * quantity) : 'Unavailable';
          return;
        }
        const mode = this.getFlagPackageMode();
        const extraLarge = this.isFlagExtraLarge();
        if (this.flagBasesPanel) this.flagBasesPanel.hidden = mode !== 'complete';
        this.flagBaseOptions.forEach((option) => {
          const base = this.flagPackageData.bases.find((item) => String(item.id) === String(option.value));
          const isWater = /square water/i.test(option.dataset.title || base?.title || '');
          option.disabled = !(base?.available !== false) || (extraLarge && !isWater);
          option.closest('.flag-package__base-option')?.classList.toggle('is-unavailable', option.disabled);
        });
        if (mode === 'complete') {
          let selectedBase = this.flagBaseOptions.find((option) => option.checked && !option.disabled);
          if (!selectedBase) {
            selectedBase = this.flagBaseOptions.find((option) => !option.disabled && /square water/i.test(option.dataset.title || '')) || this.flagBaseOptions.find((option) => !option.disabled);
            if (selectedBase) selectedBase.checked = true;
          }
        }
        if (this.flagXlBaseNote) this.flagXlBaseNote.hidden = !(mode === 'complete' && extraLarge);
        const mainVariant = this.findFlagVariant(this.flagPackageData.mainVariants, optionValues);
        const graphicVariant = this.findFlagVariant(this.flagPackageData.graphicVariants, optionValues);
        const selectedVariant = mode === 'graphic' ? graphicVariant : mainVariant;
        const base = mode === 'complete' ? this.getFlagSelectedBaseData() : null;
        const total = ((selectedVariant?.price || 0) + (base?.price || 0)) * quantity;
        const packageLabels = {
          graphic: 'Printed flag only',
          pole: extraLarge ? 'Flag + pole + XL extender' : 'Flag + Full Fibre pole',
          complete: extraLarge ? 'Complete XL kit · Square Water Base' : `Complete kit${base?.title ? ` · ${base.title}` : ''}`,
        };
        if (this.flagSelectionSummary) this.flagSelectionSummary.textContent = `${optionValues.join(' · ')} · ${packageLabels[mode]}`;
        if (this.flagPrice) this.flagPrice.textContent = selectedVariant ? this.formatFlagMoney(total) : 'Unavailable';
        this.updateFlagProperty(this.flagProperties.package, packageLabels[mode], true);
        this.updateFlagProperty(this.flagProperties.base, base?.title || '', Boolean(base));
      }

      extractFlagLineProperties(formData) {
        const properties = {};
        for (const [key, value] of formData.entries()) {
          const match = String(key).match(/^properties\[(.+)\]$/);
          if (!match || value instanceof File) continue;
          const clean = String(value || '').trim();
          if (clean) properties[match[1]] = clean;
        }
        return properties;
      }

      getFlagCartItems(formData) {
        const mode = this.getFlagPackageMode();
        const optionValues = this.getFlagSelectedOptionValues();
        const mainVariant = this.findFlagVariant(this.flagPackageData?.mainVariants, optionValues);
        const graphicVariant = this.findFlagVariant(this.flagPackageData?.graphicVariants, optionValues);
        const selectedVariant = mode === 'graphic' ? graphicVariant : mainVariant;
        if (!selectedVariant?.id || !selectedVariant.available) throw new Error('The selected flag package is currently unavailable.');
        const quantity = Math.max(1, Math.round(Number(this.flagQuantity?.value || formData.get('quantity')) || 1));
        const base = mode === 'complete' ? this.getFlagSelectedBaseData() : null;
        if (mode === 'complete' && (!base?.id || base.available === false)) throw new Error('Please choose an available flag base.');
        if (mode === 'complete' && this.isFlagExtraLarge() && !/square water/i.test(base.title || '')) {
          throw new Error('Extra Large complete kits require the Square Water Base.');
        }
        if (this.isFlagDoubleSided() && !this.flagUseSameArtwork?.checked && !this.flagFiles.reverse) {
          throw new Error('Please upload the reverse artwork or choose to use the front artwork on both sides.');
        }
        const packageId = `OPS-FLAG-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2, 7).toUpperCase()}`;
        const properties = this.extractFlagLineProperties(formData);
        properties.Package = mode === 'graphic' ? 'Printed flag only' : mode === 'complete' ? 'Complete flag kit' : 'Flag + Full Fibre pole';
        if (base) properties.Base = base.title;
        else delete properties.Base;
        if (this.isFlagExtraLarge() && mode !== 'graphic') properties['XL hardware'] = 'Pole extender included';
        properties['_package_id'] = packageId;
        properties['_package_role'] = mode === 'graphic' ? 'printed-flag' : 'flag-and-pole';
        const items = [{ id: Number(selectedVariant.id), quantity, properties }];
        if (base) {
          items.push({
            id: Number(base.id),
            quantity,
            properties: {
              '_package_id': packageId,
              '_package_role': 'base',
              '_package_for': optionValues.join(' / '),
            },
          });
        }
        return items;
      }

      async addFlagPackageToCart(evt) {
        let linesUpdateDeferred = null;
        this.error = false;
        try {
          const formData = new FormData(this.form);
          const items = this.getFlagCartItems(formData);
          const variantId = items[0].id;
          const quantity = items[0].quantity;
          linesUpdateDeferred = this.createCartLinesUpdateEventForItems(items);
          const payload = { items };
          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }
          const response = await fetch(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || 'The flag package could not be added.');
          result.id = result.id || result.items?.[0]?.id || variantId;
          result.key = result.key || result.items?.[0]?.key || '';
          this.resolveCartLinesUpdate(linesUpdateDeferred);
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: result,
          });
          this.error = false;
          this.clearSelectedArtwork();
          this.cart.renderContents(result);
        } catch (error) {
          console.error(error);
          this.error = true;
          this.handleErrorMessage(error.message || 'The flag package could not be added.');
          this.dispatchCartErrorEvent(error.message || 'The flag package could not be added.', 'INVALID');
          linesUpdateDeferred?.reject(error);
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          CartPerformance.measureFromEvent('add:user-action', evt);
        }
      }

      renderNumberStickerSelectors(count) {
        const box = this.numberStickerBox;
        const container = box?.querySelector('[data-number-sticker-selectors]');
        if (!container) return;

        const targetCount = Math.max(0, Number(count) || 0);
        const currentSelects = Array.from(container.querySelectorAll('[data-number-sticker-select]'));
        const existingValues = currentSelects.map((select) => select.value);

        if (currentSelects.length === targetCount && Number(container.dataset.count || 0) === targetCount) {
          this.syncNumberStickerValue();
          return;
        }

        container.replaceChildren();

        for (let index = 0; index < targetCount; index += 1) {
          const label = document.createElement('label');
          label.className = 'ops-number-picker__choice';

          const caption = document.createElement('span');
          caption.textContent = `Digit ${index + 1}`;

          const select = document.createElement('select');
          select.dataset.numberStickerSelect = '';
          select.setAttribute('aria-label', `Digit ${index + 1}`);
          select.setAttribute('aria-invalid', 'false');
          select.required = true;

          const blankOption = document.createElement('option');
          blankOption.value = '';
          blankOption.textContent = '—';
          select.appendChild(blankOption);

          for (let digit = 0; digit <= 9; digit += 1) {
            const option = document.createElement('option');
            option.value = String(digit);
            option.textContent = String(digit);
            select.appendChild(option);
          }

          if (/^\d$/.test(existingValues[index] || '')) {
            select.value = existingValues[index];
          }

          label.append(caption, select);
          container.appendChild(label);
        }

        container.dataset.count = String(targetCount);
        this.syncNumberStickerValue();
      }

      syncNumberStickerValue() {
        const box = this.numberStickerBox;
        if (!box) return [];

        const input = box.querySelector('[data-number-sticker-value]');
        const selects = Array.from(box.querySelectorAll('[data-number-sticker-select]'));
        const values = selects.map((select) => select.value);
        const complete = selects.length > 0 && values.every((value) => /^\d$/.test(value));

        if (input) input.value = complete ? values.join(', ') : '';
        return values;
      }

      updateNumberStickerField() {
        const box = this.numberStickerBox;
        if (!box) return 0;

        const pack = this.getSelectedOptions().find((option) => /^pack/i.test(option.name))?.value || box.dataset.initialPack;
        const style = this.getSelectedOptions().find((option) => /^style$/i.test(option.name))?.value || '';
        const perPack = /^XL\b/.test(pack) ? 1 : /^L\b/.test(pack) ? 2 : /^M\b/.test(pack) ? 4 : 0;
        const count = /^custom/i.test(style) ? 0 : perPack;
        const input = box.querySelector('[data-number-sticker-value]');
        const container = box.querySelector('[data-number-sticker-selectors]');
        const visible = count > 0;

        box.hidden = !visible;
        if (input) input.disabled = !visible;

        if (visible) {
          this.renderNumberStickerSelectors(count);
        } else {
          container?.replaceChildren();
          if (container) container.dataset.count = '0';
          if (input) input.value = '';
        }

        const hint = box.querySelector('[data-number-sticker-hint]');
        if (hint) hint.textContent = box.dataset.hint.replace('[count]', count);
        return count;
      }

      validateNumberStickerField() {
        const count = this.updateNumberStickerField();
        if (!count) return true;

        const box = this.numberStickerBox;
        const selects = Array.from(box.querySelectorAll('[data-number-sticker-select]'));
        const message = box.dataset.error.replace('[count]', count);
        let firstMissing = null;

        selects.forEach((select) => {
          const valid = /^\d$/.test(select.value);
          select.setAttribute('aria-invalid', valid ? 'false' : 'true');
          select.setCustomValidity(valid ? '' : message);
          if (!valid && !firstMissing) firstMissing = select;
        });

        if (selects.length !== count || firstMissing) {
          this.handleErrorMessage(message);
          firstMissing?.reportValidity();
          firstMissing?.focus();
          return false;
        }

        this.syncNumberStickerValue();
        return true;
      }

      updateGreetingCardFields() {
        window.OPSGreetingCardStandard?.sync(this);
      }

      getSelectedOptions() {
        const sectionRoot =
          document.getElementById(`MainProduct-${this.dataset.sectionId}`) || this.closest('product-info') || document;
        const variantSelects =
          sectionRoot.querySelector(`#variant-selects-${this.dataset.sectionId}`) || sectionRoot.querySelector('variant-selects');
        if (!variantSelects) return [];

        const selected = [];
        const seen = new Set();
        const addOption = (name, value) => {
          const cleanName = String(name || '').replace(/:\s*$/, '').replace(/\s+/g, ' ').trim();
          const cleanValue = String(value || '').replace(/\s+/g, ' ').trim();
          if (!cleanName || !cleanValue || seen.has(cleanName.toLowerCase())) return;
          seen.add(cleanName.toLowerCase());
          selected.push({ name: cleanName, value: cleanValue });
        };

        variantSelects.querySelectorAll('select[name^="options["]').forEach((select) => {
          const match = select.name.match(/^options\[(.+)\]$/);
          addOption(match?.[1] || select.previousElementSibling?.textContent, select.value);
        });

        variantSelects.querySelectorAll('input[data-option-name]:checked').forEach((input) => {
          addOption(input.dataset.optionName, input.value);
        });

        return selected;
      }

      formatFileSize(bytes) {
        if (!Number.isFinite(bytes) || bytes <= 0) return '';
        if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
      }

      resetUploadedReferences() {
        if (this.uploadTokenInput) this.uploadTokenInput.value = '';
        if (this.uploadFilenameInput) this.uploadFilenameInput.value = '';
        if (this.uploadObjectKeyInput) this.uploadObjectKeyInput.value = '';
        if (this.uploadSessionIdInput) this.uploadSessionIdInput.value = '';
        if (this.uploadZipUrlInput) this.uploadZipUrlInput.value = '';
        if (this.uploadPreviewUrlInput) this.uploadPreviewUrlInput.value = '';
        this.previewUploadSignature = '';
        this.dieCutProcessedUploadSignature = '';
      }

      resetUploadFields() {
        this.resetUploadedReferences();
        this.selectedArtworkFiles = [];
        this.stickerSheetImages = [];
        this.stickerSheetOriginalImages = [];
        this.stickerSheetOffsetX = 0;
        this.stickerSheetOffsetY = 0;
        this.flagImageLoadId += 1;
        this.flagImage = null;
        this.flagFile = null;
        this.flagFiles = { front: null, reverse: null };
        this.flagImages = { front: null, reverse: null };
        this.flagSideStates = {
          front: { fit: 'cover', zoom: 100, x: 0, y: 0 },
          reverse: { fit: 'cover', zoom: 100, x: 0, y: 0 },
        };
        this.flagActiveSide = 'front';
        if (this.flagUseSameArtwork) this.flagUseSameArtwork.checked = true;
        this.flagOffsetX = 0;
        this.flagOffsetY = 0;
        this.flagZoomPercent = 100;
        if (this.flagFit) this.flagFit.value = 'cover';
        if (this.flagZoom) this.flagZoom.value = '50';
        if (this.flagZoomValue) this.flagZoomValue.textContent = '100%';
        this.dieCutMetrics = [];
        this.dieCutProcessedFile = null;
        this.dieCutPreparedSignature = '';
        this.dieCutProcessedUploadSignature = '';
        this.revokeDieCutProcessedObjectUrl();
        if (this.dieCutRemoveBackground) this.dieCutRemoveBackground.checked = false;
        if (this.dieCutToleranceRange) this.dieCutToleranceRange.value = '115';
        if (this.stickerSheetRemoveBackground) this.stickerSheetRemoveBackground.checked = false;
        if (this.stickerSheetToleranceRange) this.stickerSheetToleranceRange.value = '115';
        if (this.stickerSheetZoom) this.stickerSheetZoom.value = '100';
        if (this.uploadInput) this.uploadInput.value = '';
        if (this.flagReverseUploadInput) this.flagReverseUploadInput.value = '';
        if (this.uploadFileList) this.uploadFileList.innerHTML = '';
        if (this.artworkBuilderAfterUpload) this.artworkBuilderAfterUpload.hidden = true;
        if (this.clearArtworkButton) this.clearArtworkButton.hidden = true;
        this.clearArtworkPreview();
      }

      clearSelectedArtwork() {
        this.uploadGeneration += 1;
        this.isArtworkUploading = false;
        this.resetUploadFields();
        if (this.uploadStatus) this.uploadStatus.textContent = 'No file uploaded yet';
        this.handleErrorMessage();
      }

      clearArtworkPreview() {
        this.previewObjectUrls.forEach((url) => URL.revokeObjectURL(url));
        this.previewObjectUrls = [];

        if (this.artworkPreviewGrid) this.artworkPreviewGrid.innerHTML = '';
        if (this.artworkPreview) this.artworkPreview.hidden = true;
        if (this.stickerSheetMaker) this.stickerSheetMaker.hidden = true;
        if (this.flagMaker) this.flagMaker.hidden = true;
        this.flagImageLoadId += 1;
        this.flagImage = null;
        this.flagFile = null;
        this.flagDragState = null;
        this.flagLastRect = null;
        this.flagLastBox = null;
        this.flagFiles = { front: null, reverse: null };
        this.flagImages = { front: null, reverse: null };
        this.flagActiveSide = 'front';
        if (this.flagFileSummary) this.flagFileSummary.textContent = '';
        this.updateFlagSideControls();
        Object.values(this.flagProperties || {}).forEach((input) => {
          if (!input) return;
          input.value = '';
          input.disabled = true;
        });
        this.stickerSheetImages = [];
        this.stickerSheetOriginalImages = [];
        this.stickerSheetOffsetX = 0;
        this.stickerSheetOffsetY = 0;
        this.dieCutProcessingId += 1;
        this.dieCutProcessingPromise = null;
        this.dieCutMetrics = [];
        this.dieCutProcessedFile = null;
        this.dieCutPreparedSignature = '';
        this.revokeDieCutProcessedObjectUrl();
        this.updateStickerSheetProperties(this.getStickerSheetLayout());
        this.updateDieCutControls(false);
      }

      renderArtworkPreviews(files) {
        if (!this.artworkPreview) return;

        this.clearArtworkPreview();

        if (this.isStickerSheetPreview()) {
          if (this.stickerSheetMaker) this.stickerSheetMaker.hidden = false;
          this.artworkPreview.hidden = false;
          const imageLoadId = ++this.stickerSheetImageLoadId;
          this.updateStickerSheetPreview();

          Promise.all(files.map((file) => this.loadArtworkImage(file))).then((images) => {
            if (imageLoadId !== this.stickerSheetImageLoadId) return;
            this.stickerSheetOriginalImages = images;
            this.stickerSheetImages = images.slice();
            this.refreshStickerSheetArtworkProcessing();
          });
          return;
        }

        if (this.isFlagPreview()) {
          this.renderFlagPreview(files);
          return;
        }

        if (!this.artworkPreviewGrid) return;

        files.forEach((file) => {
          const item = document.createElement('figure');
          item.className = 'artwork-preview__item';

          const visual = document.createElement('div');
          visual.className = 'artwork-preview__visual';

          const isPreviewableImage = ['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'].includes(file.type);

          if (isPreviewableImage) {
            const objectUrl = URL.createObjectURL(file);
            this.previewObjectUrls.push(objectUrl);

            const image = document.createElement('img');
            image.className = 'artwork-preview__image';
            image.src = objectUrl;
            image.dataset.originalSrc = objectUrl;
            image.alt = `Preview of ${file.name}`;
            image.loading = 'eager';
            visual.appendChild(image);
          } else {
            const fileCard = document.createElement('div');
            fileCard.className = 'artwork-preview__file-card';
            fileCard.innerHTML = '<strong>PDF</strong><span>Artwork uploaded successfully</span>';
            visual.appendChild(fileCard);
          }

          const caption = document.createElement('figcaption');
          const name = document.createElement('span');
          name.textContent = file.name;
          const size = document.createElement('small');
          size.textContent = this.formatFileSize(file.size);
          caption.append(name, size);

          item.append(visual, caption);
          this.artworkPreviewGrid.appendChild(item);
        });

        this.artworkPreview.hidden = false;
        this.updateArtworkBorderPreview(false);
        if (this.isDieCutPreview()) this.refreshDieCutArtworkProcessing();
      }

      getStickerSheetImageBox(image, rectangle, fitMode = 'contain', padding = 0, options = {}) {
        if (!image?.naturalWidth || !image?.naturalHeight) return null;
        const availableWidth = Math.max(1, rectangle.width - padding * 2);
        const availableHeight = Math.max(1, rectangle.height - padding * 2);
        const containScale = Math.min(availableWidth / image.naturalWidth, availableHeight / image.naturalHeight);
        const coverScale = Math.max(availableWidth / image.naturalWidth, availableHeight / image.naturalHeight);
        const baseScale = fitMode === 'cover' ? coverScale : containScale;
        const zoom = this.clampNumber(options.zoom, 0.25, 2.5, 1);
        const drawWidth = image.naturalWidth * baseScale * zoom;
        const drawHeight = image.naturalHeight * baseScale * zoom;
        const offsetX = this.clampNumber(options.offsetX, -100, 100, 0);
        const offsetY = this.clampNumber(options.offsetY, -100, 100, 0);
        const x =
          rectangle.x +
          (rectangle.width - drawWidth) / 2 +
          (offsetX / 100) * (rectangle.width / 2);
        const y =
          rectangle.y +
          (rectangle.height - drawHeight) / 2 +
          (offsetY / 100) * (rectangle.height / 2);

        return { x, y, width: drawWidth, height: drawHeight };
      }

      drawStickerSheetAlphaGuide(context, image, box, radius = 4) {
        if (!image || !box?.width || !box?.height) return;
        const width = Math.max(1, Math.ceil(box.width));
        const height = Math.max(1, Math.ceil(box.height));
        const silhouette = document.createElement('canvas');
        silhouette.width = width;
        silhouette.height = height;
        const silhouetteContext = silhouette.getContext('2d');
        if (!silhouetteContext) return;

        silhouetteContext.drawImage(image, 0, 0, width, height);
        silhouetteContext.globalCompositeOperation = 'source-in';
        silhouetteContext.fillStyle = 'rgba(65, 65, 65, 0.82)';
        silhouetteContext.fillRect(0, 0, width, height);

        context.save();
        for (let step = 0; step < 20; step += 1) {
          const angle = (Math.PI * 2 * step) / 20;
          context.drawImage(
            silhouette,
            box.x + Math.cos(angle) * radius,
            box.y + Math.sin(angle) * radius,
            box.width,
            box.height
          );
        }
        context.restore();
      }

      drawImageFitted(context, image, rectangle, fitMode = 'contain', padding = 0, options = {}) {
        const box = this.getStickerSheetImageBox(image, rectangle, fitMode, padding, options);
        if (!box) return null;

        context.save();
        context.beginPath();
        context.rect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
        context.clip();

        if (options.guideMode === 'shape') {
          this.drawStickerSheetAlphaGuide(
            context,
            image,
            box,
            Math.max(2, Math.min(rectangle.width, rectangle.height) * 0.01)
          );
        }

        context.drawImage(image, box.x, box.y, box.width, box.height);
        context.restore();
        return box;
      }

      drawStickerSheetPlaceholder(context, rectangle, text = 'Preview unavailable') {
        context.save();
        context.fillStyle = '#F7F7F7';
        context.strokeStyle = '#9A9A9A';
        context.lineWidth = 2;
        context.setLineDash([10, 8]);
        context.fillRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
        context.strokeRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
        context.setLineDash([]);
        context.fillStyle = '#333333';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.font = `600 ${Math.max(18, Math.min(32, rectangle.width * 0.08))}px sans-serif`;
        context.fillText(text, rectangle.x + rectangle.width / 2, rectangle.y + rectangle.height / 2);
        context.restore();
      }

      getStickerSheetPanelRectangles(layout, safeArea, scale) {
        const gap = layout.panelGapMm * scale;
        const panelWidth = (safeArea.width - Math.max(0, layout.panelColumns - 1) * gap) / layout.panelColumns;
        const panelHeight = (safeArea.height - Math.max(0, layout.panelRows - 1) * gap) / layout.panelRows;
        const rectangles = [];

        for (let row = 0; row < layout.panelRows; row += 1) {
          for (let column = 0; column < layout.panelColumns; column += 1) {
            rectangles.push({
              x: safeArea.x + column * (panelWidth + gap),
              y: safeArea.y + row * (panelHeight + gap),
              width: panelWidth,
              height: panelHeight,
            });
          }
        }
        return rectangles.slice(0, layout.panelCount);
      }

      drawStickerSheetBoxGuide(context, rectangle, scale) {
        context.save();
        context.strokeStyle = '#777777';
        context.lineWidth = Math.max(1, scale * 0.35);
        context.setLineDash([Math.max(3, scale), Math.max(3, scale)]);
        const radius = Math.min(rectangle.width, rectangle.height) * 0.08;
        context.beginPath();
        if (typeof context.roundRect === 'function') {
          context.roundRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height, radius);
        } else {
          context.rect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
        }
        context.stroke();
        context.restore();
      }

      drawStickerSheetCanvas(canvas, images = this.stickerSheetImages) {
        if (!canvas) return this.getStickerSheetLayout();
        const context = canvas.getContext('2d');
        if (!context) return this.getStickerSheetLayout();

        const layout = this.getStickerSheetLayout();
        const scale = canvas.width / layout.sheetWidthMm;
        const margin = layout.safeMarginMm * scale;
        const usableWidth = canvas.width - margin * 2;
        const usableHeight = canvas.height - margin * 2;
        const safeArea = { x: margin, y: margin, width: usableWidth, height: usableHeight };

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.fillStyle = '#FFFFFF';
        context.fillRect(0, 0, canvas.width, canvas.height);

        context.save();
        context.strokeStyle = '#A9A9A9';
        context.lineWidth = 2;
        context.setLineDash([10, 8]);
        context.strokeRect(safeArea.x, safeArea.y, safeArea.width, safeArea.height);
        context.restore();

        const usableImages = images.filter((image) => image?.naturalWidth && image?.naturalHeight);
        const guideMode = this.stickerSheetGuideMode?.value || 'boxes';

        if (layout.mode === 'complete-sheet') {
          const panels = this.getStickerSheetPanelRectangles(layout, safeArea, scale);
          const image = usableImages[0];

          panels.forEach((panel, index) => {
            context.save();
            context.fillStyle = '#FFFFFF';
            context.fillRect(panel.x, panel.y, panel.width, panel.height);
            context.restore();

            if (image) {
              this.drawImageFitted(
                context,
                image,
                panel,
                this.stickerSheetFit?.value === 'cover' ? 'cover' : 'contain',
                Math.max(1, scale * 0.4),
                {
                  zoom: layout.zoomPercent / 100,
                  offsetX: layout.offsetXPercent,
                  offsetY: layout.offsetYPercent,
                  guideMode,
                }
              );
            } else {
              this.drawStickerSheetPlaceholder(context, panel, `Panel ${index + 1}`);
            }

            if (layout.panelCount > 1 || guideMode === 'boxes') {
              this.drawStickerSheetBoxGuide(context, panel, scale);
            }
          });
        } else {
          const cellSize = layout.stickerSizeMm * scale;
          const gap = layout.spacingMm * scale;
          const totalWidth = layout.columns * cellSize + Math.max(0, layout.columns - 1) * gap;
          const totalHeight = layout.rows * cellSize + Math.max(0, layout.rows - 1) * gap;
          const startX = margin + (usableWidth - totalWidth) / 2;
          const startY = margin + (usableHeight - totalHeight) / 2;
          const count = layout.columns * layout.rows;

          for (let index = 0; index < count; index += 1) {
            const column = index % layout.columns;
            const row = Math.floor(index / layout.columns);
            const rectangle = {
              x: startX + column * (cellSize + gap),
              y: startY + row * (cellSize + gap),
              width: cellSize,
              height: cellSize,
            };
            const image = usableImages.length ? usableImages[index % usableImages.length] : null;

            if (image) {
              this.drawImageFitted(
                context,
                image,
                rectangle,
                'contain',
                Math.max(1, cellSize * 0.035),
                { guideMode }
              );
            } else if (index === 0) {
              this.drawStickerSheetPlaceholder(context, rectangle, 'Artwork');
            }

            if (guideMode === 'boxes') {
              this.drawStickerSheetBoxGuide(context, rectangle, scale);
            }
          }
        }

        return layout;
      }

      updateStickerSheetBuilderStats(layout) {
        const hasArtwork = this.selectedArtworkFiles.length > 0;
        const roundedDpi = Number.isFinite(layout.estimatedDpi)
          ? Math.round(layout.estimatedDpi)
          : null;
        const vector =
          this.getPreviewArtworkFiles().length > 0 &&
          this.getPreviewArtworkFiles().every((file) => file?.type === 'image/svg+xml');

        if (this.stickerSheetLayoutValue) {
          this.stickerSheetLayoutValue.textContent =
            layout.mode === 'repeat'
              ? `${layout.stickerSizeMm} mm`
              : `${layout.panelCount} × ${layout.panelFormat}`;
        }

        if (this.stickerSheetCountValue) {
          this.stickerSheetCountValue.textContent =
            layout.mode === 'repeat'
              ? `${layout.columns} × ${layout.rows} · approximately ${layout.estimatedQuantity}`
              : `${layout.panelWidthMm} × ${layout.panelHeightMm} mm each`;
        }

        if (this.stickerSheetDpiValue) {
          this.stickerSheetDpiValue.textContent = vector
            ? 'Vector'
            : roundedDpi
              ? `${roundedDpi} DPI`
              : '—';
        }

        if (this.stickerSheetQualityValue) {
          if (!hasArtwork) {
            this.stickerSheetQualityValue.textContent = 'Upload artwork';
          } else if (layout.qualityLevel === 'excellent') {
            this.stickerSheetQualityValue.textContent = vector ? 'Scales cleanly' : 'Excellent';
          } else if (layout.qualityLevel === 'good') {
            this.stickerSheetQualityValue.textContent = 'Below recommended';
          } else if (layout.qualityLevel === 'fair') {
            this.stickerSheetQualityValue.textContent = 'Low resolution';
          } else if (layout.qualityLevel === 'low') {
            this.stickerSheetQualityValue.textContent = 'Very low resolution';
          } else {
            this.stickerSheetQualityValue.textContent = 'Manual check';
          }
        }

        if (this.stickerSheetBuilderStats) {
          this.stickerSheetBuilderStats.dataset.quality = hasArtwork ? layout.qualityLevel : 'empty';
        }

        if (
          this.stickerSheetDpiAlert &&
          this.stickerSheetDpiMessage &&
          this.stickerSheetDpiAction
        ) {
          this.stickerSheetDpiAlert.hidden = !hasArtwork;
          this.stickerSheetDpiAction.hidden = true;

          if (!hasArtwork) {
            this.stickerSheetDpiMessage.textContent = '';
          } else if (layout.qualityLevel === 'excellent') {
            this.stickerSheetDpiMessage.textContent = vector
              ? 'Vector artwork is suitable at this size.'
              : 'Ready at this size.';
          } else if (layout.mode === 'repeat') {
            const targetSize = this.calculateStickerSheetTargetSize(300);
            if (Number.isFinite(targetSize) && targetSize >= 20 && targetSize < layout.stickerSizeMm) {
              this.stickerSheetDpiMessage.textContent = 'Below 300 DPI at this size.';
              this.stickerSheetDpiAction.textContent = 'Set to 300 DPI';
              this.stickerSheetDpiAction.hidden = false;
            } else if (Number.isFinite(targetSize) && targetSize < 20) {
              this.stickerSheetDpiMessage.textContent =
                'Below 300 DPI even at 20 mm. Upload a larger image.';
            } else {
              this.stickerSheetDpiMessage.textContent =
                'Print resolution will be checked before production.';
            }
          } else if (Number.isFinite(layout.estimatedDpi)) {
            const targetZoom = Math.floor(layout.zoomPercent * (layout.estimatedDpi / 300));
            if (targetZoom >= 25 && targetZoom < layout.zoomPercent) {
              this.stickerSheetDpiMessage.textContent = 'Below 300 DPI at this scale.';
              this.stickerSheetDpiAction.textContent = 'Set to 300 DPI';
              this.stickerSheetDpiAction.hidden = false;
            } else {
              this.stickerSheetDpiMessage.textContent =
                'Upload a larger image or use a smaller panel scale.';
            }
          }
        }
      }

      updateStickerSheetPreview() {
        if (!this.isStickerSheetPreview()) return;
        const layout = this.drawStickerSheetCanvas(this.stickerSheetCanvas);
        this.updateStickerSheetProperties(layout);
        this.updateStickerSheetBackgroundControls();
        this.updateStickerSheetBuilderStats(layout);

        if (this.stickerSheetZoomValue) {
          this.stickerSheetZoomValue.textContent = `${layout.zoomPercent}%`;
        }

        if (this.stickerSheetCanvas) {
          this.stickerSheetCanvas.classList.toggle(
            'is-positionable',
            layout.mode === 'complete-sheet' && this.selectedArtworkFiles.length > 0
          );
        }

        if (this.stickerSheetStats) {
          if (!this.selectedArtworkFiles.length) {
            this.stickerSheetStats.textContent = 'Upload artwork to create your A4 sheet preview.';
          } else if (layout.mode === 'repeat') {
            this.stickerSheetStats.innerHTML = `
              <strong>${layout.estimatedQuantity} stickers per A4 sheet</strong>
              <span>${layout.columns} columns × ${layout.rows} rows · ${layout.stickerSizeMm} mm</span>
            `;
          } else {
            this.stickerSheetStats.innerHTML = `
              <strong>${layout.panelCount} × ${layout.panelFormat} panels on one A4 sheet</strong>
              <span>${layout.fitMode} · ${layout.zoomPercent}% scale</span>
            `;
          }
        }
      }

      validateArtworkFiles(files) {
        const maximumFileSize = 25 * 1024 * 1024;
        const maximumOriginalFiles = 9;
        const allowedExtensions = ['.png', '.jpg', '.jpeg', '.webp', '.pdf', '.svg'];

        if (files.length > maximumOriginalFiles) {
          return `Please upload no more than ${maximumOriginalFiles} files for one product.`;
        }

        for (const file of files) {
          const lowerName = file.name.toLowerCase();
          if (!allowedExtensions.some((extension) => lowerName.endsWith(extension))) {
            return `${file.name} is not a supported artwork file.`;
          }
          if (!file.size) return `${file.name} is empty.`;
          if (file.size > maximumFileSize) return `${file.name} is larger than the 25 MB limit.`;
        }

        return null;
      }

      getVariantTitle() {
        const options = this.getSelectedOptions();
        return options.map((option) => option.value).join(' / ') || this.variantIdInput?.value || '';
      }

      appendArtworkMetadata(formData) {
        const { enabled, colour } = this.getBorderSettings();
        const previewType = this.previewType || 'generic';
        const selectedOptions = this.getSelectedOptions();

        formData.append('productTitle', this.uploadBlock?.dataset.productTitle || '');
        formData.append('productHandle', this.uploadBlock?.dataset.productHandle || '');
        formData.append('variantTitle', this.getVariantTitle());
        formData.append('previewType', previewType);
        formData.append('selectedOptions', JSON.stringify(selectedOptions));

        if (previewType === 'die-cut') {
          const dieCutDetails = this.getDieCutDetails();
          formData.append('outerBorder', enabled ? 'Yes' : 'No');
          formData.append('borderColor', enabled ? colour : '');
          formData.append('dieCutDetails', JSON.stringify(dieCutDetails));
          formData.append('stickerSizeBand', dieCutDetails.sizeBand || '');
          formData.append('stickerLongestEdgeMm', String(dieCutDetails.longestEdgeMm || ''));
          formData.append('stickerWidthMm', dieCutDetails.finishedWidthMm === null ? '' : String(dieCutDetails.finishedWidthMm));
          formData.append('stickerHeightMm', dieCutDetails.finishedHeightMm === null ? '' : String(dieCutDetails.finishedHeightMm));
          formData.append('estimatedDpi', dieCutDetails.estimatedDpi === null ? '' : String(dieCutDetails.estimatedDpi));
          formData.append('backgroundRemoval', dieCutDetails.backgroundRemoval || 'No');
          formData.append(
            'backgroundTolerance',
            dieCutDetails.backgroundTolerance === null ? '' : String(dieCutDetails.backgroundTolerance)
          );
        }

        if (previewType === 'sticker-sheet') {
          formData.append('stickerSheetLayout', JSON.stringify(this.getStickerSheetLayout()));
        }

        if (previewType === 'flag') {
          formData.append('flagPreview', JSON.stringify(this.getFlagDetails()));
        }

        formData.append('artworkNotes', this.artworkNotes?.value || '');
      }

      async uploadSingleFile(file, sessionId, fileRole = 'original') {
        if (!(file instanceof Blob)) throw new Error('The artwork file is no longer available in this browser.');

        const fallbackNames = {
          original: 'customer-artwork.png',
          'customer-preview': 'customer-preview.png',
          'background-removed': 'background-removed.png',
          'sticker-sheet-output': 'sticker-sheet-output.png',
        };
        const normaliseType = (name, suppliedType) => {
          const type = String(suppliedType || '').toLowerCase();
          if (/^(image\/(png|jpeg|webp|svg\+xml)|application\/pdf)$/.test(type)) return type;
          const lowerName = String(name || '').toLowerCase();
          if (lowerName.endsWith('.svg')) return 'image/svg+xml';
          if (lowerName.endsWith('.webp')) return 'image/webp';
          if (lowerName.endsWith('.jpg') || lowerName.endsWith('.jpeg')) return 'image/jpeg';
          if (lowerName.endsWith('.pdf')) return 'application/pdf';
          return 'image/png';
        };
        const materialise = async () => {
          const rawName = String(file.name || fallbackNames[fileRole] || 'customer-artwork.png');
          const safeName = rawName
            .normalize('NFKD')
            .replace(/[^a-zA-Z0-9._-]/g, '_')
            .replace(/_+/g, '_')
            .replace(/^[_\.]+|[_\.]+$/g, '')
            .slice(0, 160) || fallbackNames[fileRole] || 'customer-artwork.png';
          const bytes = await file.arrayBuffer();
          return new File([bytes], safeName, {
            type: normaliseType(safeName, file.type),
            lastModified: Date.now(),
          });
        };
        const send = async () => {
          const uploadFile = await materialise();
          const formData = new FormData();
          formData.append('file', uploadFile, uploadFile.name);
          formData.append('sessionId', sessionId);
          formData.append('fileRole', fileRole);
          this.appendArtworkMetadata(formData);

          const response = await fetch('https://occult-print-upload.mwsb87.workers.dev/upload', {
            method: 'POST',
            body: formData,
          });
          const responseText = await response.text();
          let result = {};
          try {
            result = responseText ? JSON.parse(responseText) : {};
          } catch {
            result = { error: responseText || 'The artwork service returned an unreadable response.' };
          }
          if (!response.ok || !result.ok) throw new Error(result.error || `Upload failed with status ${response.status}.`);
          return result;
        };

        // Mobile Safari/Chrome can occasionally truncate multipart bodies made
        // from picker or IndexedDB-backed files. Rebuilding the File and body
        // once is safe because the Worker stores this upload in the same session.
        try {
          return await send();
        } catch (firstError) {
          await new Promise((resolve) => setTimeout(resolve, 120));
          try {
            return await send();
          } catch (secondError) {
            throw new Error(secondError?.message || firstError?.message || 'Upload failed. Please try again.');
          }
        }
      }

      updateSwingTagArtworkState(sides = this.swingTagSidesProperty?.value) {
        if (!this.isSwingTagPreview()) return;
        const doubleSided = String(sides || '').toLowerCase() === 'double-sided';
        if (this.swingTagBackPanel) this.swingTagBackPanel.hidden = !doubleSided;
        if (this.uploadStatus && !this.swingTagFiles.front) {
          this.uploadStatus.textContent = doubleSided
            ? 'Choose a front design and a separate back design.'
            : 'Choose a front design to personalise your tags.';
        } else if (this.uploadStatus && doubleSided && !this.swingTagFiles.back) {
          this.uploadStatus.textContent = 'Front artwork selected. Choose a separate back design for double-sided printing.';
        }
      }

      updateSwingTagArtworkPreview(side, file = this.swingTagFiles[side]) {
        const preview = this.swingTagPreviews?.[side];
        if (!preview) return;
        if (this.swingTagPreviewUrls[side]) {
          URL.revokeObjectURL(this.swingTagPreviewUrls[side]);
          this.swingTagPreviewUrls[side] = '';
        }
        if (preview.image) {
          preview.image.removeAttribute('src');
          preview.image.hidden = true;
        }
        if (preview.fallback) preview.fallback.hidden = true;
        if (!file) {
          if (preview.container) preview.container.hidden = true;
          return;
        }
        if (preview.container) preview.container.hidden = false;

        const extension = String(file.name || '').split('.').pop().toUpperCase().slice(0, 6) || 'FILE';
        const canPreviewImage = String(file.type || '').toLowerCase().startsWith('image/') || /\.(png|jpe?g|webp|svg|gif)$/i.test(String(file.name || ''));
        if (canPreviewImage && preview.image && typeof URL.createObjectURL === 'function') {
          try {
            const url = URL.createObjectURL(file);
            this.swingTagPreviewUrls[side] = url;
            preview.image.src = url;
            preview.image.alt = (side === 'back' ? 'Back' : 'Front') + ' artwork thumbnail';
            preview.image.hidden = false;
            return;
          } catch (error) {
            // Keep the file attached and show the file-type fallback if a thumbnail cannot be created.
          }
        }
        if (preview.type) preview.type.textContent = extension;
        if (preview.fallback) preview.fallback.hidden = false;
      }

      updateSwingTagArtworkLabels() {
        ['front', 'back'].forEach((side) => {
          const file = this.swingTagFiles[side];
          const label = this.swingTagFileNames[side];
          const clear = this.swingTagClearButtons.find((button) => button.dataset.stgClearSide === side);
          this.updateSwingTagArtworkPreview(side, file);
          if (label) label.textContent = file ? `${file.name} · ${this.formatFileSize(file.size)}` : `No ${side} artwork selected`;
          if (clear) clear.hidden = !file;
          const fileProperty = this.swingTagProperties.file[side];
          if (fileProperty) fileProperty.value = file ? file.name : '';
        });
      }

      clearSwingTagArtwork(side) {
        this.uploadGeneration += 1;
        const requestedSide = side === 'back' ? 'back' : 'front';
        const input = requestedSide === 'back' ? this.swingTagBackUploadInput : this.uploadInput;
        if (input) {
          input.value = '';
          delete input.dataset.opsArtworkId;
        }
        this.swingTagFiles[requestedSide] = null;
        this.swingTagArtworkIds[requestedSide] = '';
        this.swingTagUploadSignature = '';
        this.resetUploadedReferences();
        Object.values(this.swingTagProperties.file).forEach((property) => { if (property) property.value = ''; });
        Object.values(this.swingTagProperties.token).forEach((property) => { if (property) property.value = ''; });
        Object.values(this.swingTagProperties.key).forEach((property) => { if (property) property.value = ''; });
        this.selectedArtworkFiles = ['front', 'back'].map((key) => this.swingTagFiles[key]).filter(Boolean);
        this.updateSwingTagArtworkLabels();
        if (this.artworkBuilderAfterUpload) this.artworkBuilderAfterUpload.hidden = this.selectedArtworkFiles.length === 0;
        if (this.artworkPreview) this.artworkPreview.hidden = true;
        this.updateSwingTagArtworkState();
      }

      async onSwingTagFileChange(evt) {
        this.uploadGeneration += 1;
        const side = evt.target.dataset.stgSide === 'back' ? 'back' : 'front';
        const file = evt.target.files?.[0] || null;
        if (!file) return;
        if (evt.isTrusted) delete evt.target.dataset.opsArtworkId;
        const validationError = this.validateArtworkFiles([file]);
        if (validationError) {
          evt.target.value = '';
          delete evt.target.dataset.opsArtworkId;
          this.handleErrorMessage(validationError);
          if (this.uploadStatus) this.uploadStatus.textContent = validationError;
          return;
        }
        this.handleErrorMessage();
        this.swingTagFiles[side] = file;
        this.swingTagArtworkIds[side] = String(evt.target.dataset.opsArtworkId || '');
        this.swingTagUploadSignature = '';
        this.resetUploadedReferences();
        Object.values(this.swingTagProperties.token).forEach((property) => { if (property) property.value = ''; });
        Object.values(this.swingTagProperties.key).forEach((property) => { if (property) property.value = ''; });
        this.selectedArtworkFiles = ['front', 'back'].map((key) => this.swingTagFiles[key]).filter(Boolean);
        this.updateSwingTagArtworkLabels();
        if (this.artworkBuilderAfterUpload) this.artworkBuilderAfterUpload.hidden = false;
        if (this.artworkPreview) this.artworkPreview.hidden = true;
        const doubleSided = String(this.swingTagSidesProperty?.value || '').toLowerCase() === 'double-sided';
        if (this.uploadStatus) {
          this.uploadStatus.textContent = doubleSided && !this.swingTagFiles.back
            ? 'Front artwork selected. Choose a separate back design for double-sided printing.'
            : 'Artwork selected. It will be attached to your order when you add the tags to your basket.';
        }
      }

      async uploadSwingTagArtwork() {
        const doubleSided = String(this.swingTagSidesProperty?.value || '').toLowerCase() === 'double-sided';
        if (!this.swingTagFiles.front) throw new Error('Choose front artwork from My Artwork or upload a file from your device.');
        if (doubleSided && !this.swingTagFiles.back) throw new Error('Choose separate front and back artwork for double-sided printing.');
        const selected = [{ side: 'front', file: this.swingTagFiles.front }];
        if (doubleSided) selected.push({ side: 'back', file: this.swingTagFiles.back });
        const validationError = this.validateArtworkFiles(selected.map((item) => item.file));
        if (validationError) throw new Error(validationError);
        const signature = selected.map((item) => `${item.side}:${this.swingTagArtworkIds[item.side]}:${item.file.name}:${item.file.size}:${item.file.lastModified}`).join('|');
        const frontToken = this.swingTagProperties.token.front?.value || '';
        const backToken = this.swingTagProperties.token.back?.value || '';
        if (signature === this.swingTagUploadSignature && frontToken && (!doubleSided || backToken)) return;

        const uploadGeneration = ++this.uploadGeneration;
        const sessionId = this.generateSessionId();
        this.isArtworkUploading = true;
        this.swingTagFileInputs.forEach((input) => { input.disabled = true; });
        this.swingTagClearButtons.forEach((button) => { button.disabled = true; });
        this.swingTagMyArtworkButtons.forEach((button) => { button.disabled = true; });
        if (this.uploadStatus) this.uploadStatus.textContent = doubleSided ? 'Saving front and back artwork…' : 'Saving front artwork…';
        this.resetUploadedReferences();
        try {
          const results = [];
          for (const item of selected) {
            const role = item.side === 'front' ? 'front-original' : 'reverse-original';
            results.push({ side: item.side, file: item.file, result: await this.uploadSingleFile(item.file, sessionId, role) });
          }
          if (uploadGeneration !== this.uploadGeneration) throw new Error('The artwork selection changed while it was being saved. Please check the artwork and try again.');
          if ((String(this.swingTagSidesProperty?.value || '').toLowerCase() === 'double-sided') !== doubleSided) throw new Error('The print-side selection changed while artwork was being saved. Please add the tags to your basket again.');
          if (results.some((entry) => !entry.result?.token)) throw new Error('The artwork upload did not return a saved reference. Please try again.');
          const tokens = results.map((entry) => entry.result.token || '');
          const filenames = results.map((entry) => entry.result.filename || entry.file?.name || entry.side);
          const objectKeys = results.map((entry) => entry.result.objectKey || '');
          results.forEach(({ side, result }) => {
            if (this.swingTagProperties.token[side]) this.swingTagProperties.token[side].value = result.token || '';
            if (this.swingTagProperties.key[side]) this.swingTagProperties.key[side].value = result.objectKey || '';
            if (this.swingTagProperties.file[side]) this.swingTagProperties.file[side].value = result.filename || this.swingTagFiles[side]?.name || '';
          });
          if (this.uploadTokenInput) this.uploadTokenInput.value = tokens.join(', ');
          if (this.uploadFilenameInput) this.uploadFilenameInput.value = filenames.join(', ');
          if (this.uploadObjectKeyInput) this.uploadObjectKeyInput.value = objectKeys.filter(Boolean).join(', ');
          if (this.uploadSessionIdInput) this.uploadSessionIdInput.value = sessionId;
          if (this.uploadZipUrlInput) this.uploadZipUrlInput.value = results.at(-1)?.result?.zipUrl || results[0]?.result?.zipUrl || '';
          if (!doubleSided) {
            if (this.swingTagProperties.token.back) this.swingTagProperties.token.back.value = '';
            if (this.swingTagProperties.key.back) this.swingTagProperties.key.back.value = '';
            if (this.swingTagProperties.file.back) this.swingTagProperties.file.back.value = '';
          }
          this.swingTagUploadSignature = signature;
          if (this.uploadStatus) this.uploadStatus.textContent = doubleSided ? 'Front and back artwork saved with this order.' : 'Front artwork saved with this order.';
        } catch (error) {
          if (uploadGeneration === this.uploadGeneration) {
            this.resetUploadedReferences();
            Object.values(this.swingTagProperties.token).forEach((property) => { if (property) property.value = ''; });
            Object.values(this.swingTagProperties.key).forEach((property) => { if (property) property.value = ''; });
          }
          if (this.uploadStatus) this.uploadStatus.textContent = error.message || 'Artwork could not be saved. Please try again.';
          throw error;
        } finally {
          this.isArtworkUploading = false;
          if (!this.swingTagControlsLocked) {
            this.swingTagFileInputs.forEach((input) => { input.disabled = false; });
            this.swingTagClearButtons.forEach((button) => { button.disabled = false; });
            this.swingTagMyArtworkButtons.forEach((button) => { button.disabled = false; });
          }
        }
      }

      async onFileChange(evt) {
        if (this.isSwingTagPreview()) return this.onSwingTagFileChange(evt);
        if (this.isFlagPreview()) return this.onFlagFileChange(evt);
        const uploadGeneration = ++this.uploadGeneration;
        const files = evt.target.files ? Array.from(evt.target.files) : [];
        if (!files.length) {
          this.resetUploadFields();
          this.uploadStatus.textContent = 'No file uploaded yet';
          return;
        }

        const validationError = this.validateArtworkFiles(files);
        if (validationError) {
          this.resetUploadFields();
          this.uploadStatus.textContent = validationError;
          this.handleErrorMessage(validationError);
          return;
        }

        this.handleErrorMessage();
        this.resetUploadedReferences();
        this.selectedArtworkFiles = files;
        this.dieCutPreparedSignature = '';
        this.dieCutProcessedUploadSignature = '';
        if (this.artworkBuilderAfterUpload) this.artworkBuilderAfterUpload.hidden = false;
        if (this.clearArtworkButton) this.clearArtworkButton.hidden = false;

        if (this.uploadFileList) {
          this.uploadFileList.innerHTML = '';
          files.forEach((file) => {
            const item = document.createElement('div');
            item.textContent = `${file.name} · ${this.formatFileSize(file.size)}`;
            this.uploadFileList.appendChild(item);
          });
        }

        this.renderArtworkPreviews(files);
        this.isArtworkUploading = true;
        this.uploadStatus.textContent = files.length === 1 ? 'Uploading artwork...' : `Uploading ${files.length} files...`;

        try {
          const results = [];
          const sessionId = this.generateSessionId();
          for (const file of files) results.push(await this.uploadSingleFile(file, sessionId, 'original'));
          const tokens = results.map((result) => result.token || '').filter(Boolean);
          const filenames = results.map((result) => result.filename || '').filter(Boolean);
          const objectKeys = results.map((result) => result.objectKey || '').filter(Boolean);
          const zipUrl = results[0]?.zipUrl || '';

          if (uploadGeneration !== this.uploadGeneration) return;

          if (this.uploadTokenInput) this.uploadTokenInput.value = tokens.join(', ');
          if (this.uploadFilenameInput) this.uploadFilenameInput.value = filenames.join(', ');
          if (this.uploadObjectKeyInput) this.uploadObjectKeyInput.value = objectKeys.join(', ');
          if (this.uploadSessionIdInput) this.uploadSessionIdInput.value = sessionId;
          if (this.uploadZipUrlInput) this.uploadZipUrlInput.value = zipUrl;
          this.uploadStatus.textContent =
            files.length === 1 ? `Artwork ready: ${filenames[0]}` : `${files.length} artwork files ready`;
        } catch (error) {
          if (uploadGeneration !== this.uploadGeneration) return;
          console.error(error);
          this.resetUploadedReferences();
          this.uploadStatus.textContent = error.message || 'Upload failed. Please try again.';
          this.handleErrorMessage(this.uploadStatus.textContent);
        } finally {
          if (uploadGeneration === this.uploadGeneration) this.isArtworkUploading = false;
        }
      }

      getPreviewCanvasConfig() {
        const type = this.uploadBlock?.dataset.previewType || 'generic';
        if (type === 'die-cut') return { width: 900, height: 900, background: 'checkerboard' };
        if (type === 'sticker-sheet') return { width: 840, height: 1188, background: 'sheet' };
        if (type === 'flag') return { width: 1200, height: 750, background: 'plain' };
        if (type === 'mug') return { width: 1200, height: 600, background: 'plain' };
        return { width: 1200, height: 800, background: 'checkerboard' };
      }

      drawCheckerboard(context, width, height) {
        const size = 28;
        context.fillStyle = '#F4F4F4';
        context.fillRect(0, 0, width, height);
        context.fillStyle = '#E2E2E2';
        for (let y = 0; y < height; y += size) {
          for (let x = 0; x < width; x += size) {
            if ((x / size + y / size) % 2 === 0) context.fillRect(x, y, size, size);
          }
        }
      }

      drawPreviewBackground(context, config) {
        if (config.background === 'checkerboard') {
          this.drawCheckerboard(context, config.width, config.height);
          return;
        }

        context.fillStyle = '#ECECEC';
        context.fillRect(0, 0, config.width, config.height);
        context.fillStyle = '#FFFFFF';
        const inset = Math.round(Math.min(config.width, config.height) * 0.055);
        context.fillRect(inset, inset, config.width - inset * 2, config.height - inset * 2);
      }

      loadArtworkImage(file) {
        return new Promise((resolve) => {
          if (!['image/png', 'image/jpeg', 'image/webp', 'image/svg+xml'].includes(file.type)) {
            resolve(null);
            return;
          }

          const objectUrl = URL.createObjectURL(file);
          const image = new Image();
          image.onload = () => {
            URL.revokeObjectURL(objectUrl);
            resolve(image);
          };
          image.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            resolve(null);
          };
          image.src = objectUrl;
        });
      }

      getPreviewCells(count, width, height) {
        const safeCount = Math.max(1, Math.min(count, 9));
        const columns = safeCount === 1 ? 1 : safeCount <= 4 ? 2 : 3;
        const rows = Math.ceil(safeCount / columns);
        const outerPadding = Math.round(Math.min(width, height) * 0.07);
        const gap = Math.round(Math.min(width, height) * 0.035);
        const cellWidth = (width - outerPadding * 2 - gap * (columns - 1)) / columns;
        const cellHeight = (height - outerPadding * 2 - gap * (rows - 1)) / rows;
        const cells = [];

        for (let index = 0; index < safeCount; index += 1) {
          const column = index % columns;
          const row = Math.floor(index / columns);
          cells.push({
            x: outerPadding + column * (cellWidth + gap),
            y: outerPadding + row * (cellHeight + gap),
            width: cellWidth,
            height: cellHeight,
          });
        }
        return cells;
      }

      drawImageContained(context, image, cell, addBorder, borderColour) {
        const padding = Math.min(cell.width, cell.height) * 0.08;
        const availableWidth = Math.max(1, cell.width - padding * 2);
        const availableHeight = Math.max(1, cell.height - padding * 2);
        const scale = Math.min(availableWidth / image.naturalWidth, availableHeight / image.naturalHeight);
        const drawWidth = image.naturalWidth * scale;
        const drawHeight = image.naturalHeight * scale;
        const x = cell.x + (cell.width - drawWidth) / 2;
        const y = cell.y + (cell.height - drawHeight) / 2;

        if (addBorder) {
          const silhouette = document.createElement('canvas');
          silhouette.width = Math.max(1, Math.ceil(drawWidth));
          silhouette.height = Math.max(1, Math.ceil(drawHeight));
          const silhouetteContext = silhouette.getContext('2d');
          if (silhouetteContext) {
            silhouetteContext.drawImage(image, 0, 0, silhouette.width, silhouette.height);
            silhouetteContext.globalCompositeOperation = 'source-in';
            silhouetteContext.fillStyle = borderColour;
            silhouetteContext.fillRect(0, 0, silhouette.width, silhouette.height);

            const radius = Math.max(5, Math.round(Math.min(cell.width, cell.height) * 0.018));
            for (let step = 0; step < 24; step += 1) {
              const angle = (Math.PI * 2 * step) / 24;
              context.drawImage(
                silhouette,
                x + Math.cos(angle) * radius,
                y + Math.sin(angle) * radius,
                drawWidth,
                drawHeight
              );
            }
          }
        }

        context.drawImage(image, x, y, drawWidth, drawHeight);
      }

      drawFilePlaceholder(context, file, cell) {
        context.save();
        context.fillStyle = '#FFFFFF';
        context.strokeStyle = '#666666';
        context.lineWidth = 3;
        context.fillRect(cell.x + 16, cell.y + 16, cell.width - 32, cell.height - 32);
        context.strokeRect(cell.x + 16, cell.y + 16, cell.width - 32, cell.height - 32);
        context.fillStyle = '#111111';
        context.textAlign = 'center';
        context.font = `700 ${Math.max(28, Math.round(cell.height * 0.14))}px sans-serif`;
        context.fillText(file.type === 'application/pdf' ? 'PDF' : 'FILE', cell.x + cell.width / 2, cell.y + cell.height * 0.47);
        context.font = `400 ${Math.max(16, Math.round(cell.height * 0.055))}px sans-serif`;
        const filename = file.name.length > 34 ? `${file.name.slice(0, 31)}...` : file.name;
        context.fillText(filename, cell.x + cell.width / 2, cell.y + cell.height * 0.62);
        context.restore();
      }

      canvasToBlob(canvas) {
        return new Promise((resolve, reject) => {
          try {
            canvas.toBlob((blob) => {
              if (blob) resolve(blob);
              else reject(new Error('Could not create the artwork preview.'));
            }, 'image/png');
          } catch (error) {
            reject(error);
          }
        });
      }

      copyFlagPreviewCanvas() {
        if (!this.flagCanvas) return null;
        const copy = document.createElement('canvas');
        copy.width = this.flagCanvas.width;
        copy.height = this.flagCanvas.height;
        const context = copy.getContext('2d');
        if (!context) return null;
        context.drawImage(this.flagCanvas, 0, 0);
        return copy;
      }

      createFlagSidePreviewCanvas(side = 'front') {
        if (!this.flagCanvas) return null;
        const previousSide = this.flagActiveSide;
        if (this.flagActiveSide !== side) this.setFlagActiveSide(side);
        const copy = this.copyFlagPreviewCanvas();
        if (this.flagActiveSide !== previousSide) this.setFlagActiveSide(previousSide);
        return copy;
      }

      createFlagCustomerPreviewCanvas() {
        if (!this.flagCanvas) return null;
        const front = this.createFlagSidePreviewCanvas('front');
        if (!this.isFlagDoubleSided()) return front;
        const reverse = this.createFlagSidePreviewCanvas('reverse');
        if (!front || !reverse) return front || reverse;

        const margin = 20;
        const labelHeight = 72;
        const gap = 20;
        const canvas = document.createElement('canvas');
        canvas.width = margin * 2 + front.width * 2 + gap;
        canvas.height = margin * 2 + labelHeight + front.height;
        const context = canvas.getContext('2d');
        if (!context) return front;
        context.fillStyle = '#F2F2F2';
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.fillStyle = '#111111';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.font = '700 34px sans-serif';
        context.fillText('FRONT', margin + front.width / 2, margin + labelHeight / 2);
        const reverseLabel = this.flagUseSameArtwork?.checked ? 'REVERSE · SAME ARTWORK' : 'REVERSE';
        context.fillText(reverseLabel, margin + front.width + gap + reverse.width / 2, margin + labelHeight / 2);
        context.drawImage(front, margin, margin + labelHeight);
        context.drawImage(reverse, margin + front.width + gap, margin + labelHeight);
        context.strokeStyle = 'rgba(17,17,17,0.25)';
        context.lineWidth = 2;
        context.beginPath();
        context.moveTo(margin + front.width + gap / 2, margin);
        context.lineTo(margin + front.width + gap / 2, canvas.height - margin);
        context.stroke();
        return canvas;
      }

      async createArtworkPreviewBlob() {
        const files = this.getPreviewArtworkFiles().slice(0, 9);
        const config = this.getPreviewCanvasConfig();
        const canvas = document.createElement('canvas');
        canvas.width = config.width;
        canvas.height = config.height;
        const context = canvas.getContext('2d');
        if (!context) throw new Error('Your browser could not create the artwork preview.');

        const images = await Promise.all(files.map((file) => this.loadArtworkImage(file)));

        if (this.isStickerSheetPreview()) {
          this.drawStickerSheetCanvas(canvas, images);
          return this.canvasToBlob(canvas);
        }

        if (this.isFlagPreview() && this.flagCanvas) {
          const flagCanvas = this.createFlagCustomerPreviewCanvas();
          if (!flagCanvas) throw new Error('Your browser could not create the flag preview.');
          return this.canvasToBlob(flagCanvas);
        }

        this.drawPreviewBackground(context, config);
        const cells = this.getPreviewCells(files.length, config.width, config.height);
        const border = this.getBorderSettings();
        const useBorder = border.enabled && this.previewType === 'die-cut';

        files.forEach((file, index) => {
          const image = images[index];
          if (image) this.drawImageContained(context, image, cells[index], useBorder, border.colour);
          else this.drawFilePlaceholder(context, file, cells[index]);
        });

        return this.canvasToBlob(canvas);
      }

      getPreviewSignature() {
        const border = this.getBorderSettings();
        return JSON.stringify({
          files: this.selectedArtworkFiles.map((file) => [file.name, file.size, file.lastModified]),
          border: this.previewType === 'die-cut' ? border : null,
          notes: this.artworkNotes?.value || '',
          variant: this.getVariantTitle(),
          selectedOptions: this.getSelectedOptions(),
          previewType: this.previewType,
          stickerSheet: this.isStickerSheetPreview() ? this.getStickerSheetLayout() : null,
          dieCut: this.isDieCutPreview() ? this.getDieCutDetails() : null,
          flag: this.isFlagPreview() ? this.getFlagDetails() : null,
          processedArtwork:
            this.isDieCutPreview() || this.isStickerSheetPreview()
              ? this.dieCutProcessedFile
                ? [this.dieCutProcessedFile.name, this.dieCutProcessedFile.size, this.dieCutProcessedFile.lastModified]
                : null
              : null,
        });
      }

      async ensureArtworkPreviewUploaded() {
        if (!this.uploadInput || !this.selectedArtworkFiles.length) return;
        const sessionId = this.uploadSessionIdInput?.value;
        if (!sessionId) throw new Error('Please wait for your artwork to finish uploading.');

        if (this.isDieCutPreview()) {
          await this.ensureDieCutArtworkPrepared();
          await this.ensureDieCutProcessedArtworkUploaded(sessionId);
        }

        if (this.isStickerSheetPreview()) {
          await this.ensureStickerSheetArtworkPrepared();
          await this.ensureStickerSheetProcessedArtworkUploaded(sessionId);
        }

        const signature = this.getPreviewSignature();
        if (this.previewUploadSignature === signature && this.uploadPreviewUrlInput?.value) return;

        this.uploadStatus.textContent = 'Preparing your order preview...';
        if (this.isFlagPreview() && this.isFlagDoubleSided()) {
          const frontCanvas = this.createFlagSidePreviewCanvas('front');
          const reverseCanvas = this.createFlagSidePreviewCanvas('reverse');
          if (!frontCanvas || !reverseCanvas) throw new Error('Your browser could not create both flag-side previews.');
          const frontBlob = await this.canvasToBlob(frontCanvas);
          const reverseBlob = await this.canvasToBlob(reverseCanvas);
          await this.uploadSingleFile(
            new File([frontBlob], 'customer-preview-front.png', { type: 'image/png' }),
            sessionId,
            'customer-preview'
          );
          await this.uploadSingleFile(
            new File([reverseBlob], 'customer-preview-reverse.png', { type: 'image/png' }),
            sessionId,
            'customer-preview'
          );
        }
        const previewBlob = await this.createArtworkPreviewBlob();
        const previewFile = new File([previewBlob], 'customer-preview.png', { type: 'image/png' });
        const result = await this.uploadSingleFile(previewFile, sessionId, 'customer-preview');

        if (this.uploadPreviewUrlInput) this.uploadPreviewUrlInput.value = result.previewUrl || '';
        if (this.uploadZipUrlInput && result.zipUrl) this.uploadZipUrlInput.value = result.zipUrl;
        this.previewUploadSignature = signature;
        this.uploadStatus.textContent =
          this.selectedArtworkFiles.length === 1
            ? `Artwork ready: ${this.selectedArtworkFiles[0].name}`
            : `${this.selectedArtworkFiles.length} artwork files ready`;
      }

      lockSwingTagControls(locked) {
        if (!this.isSwingTagPreview()) return;
        const root = this.closest('product-info') || this.productSectionRoot || document;
        if (locked) {
          if (this.swingTagControlsLocked) return;
          this.swingTagControlsLocked = true;
          const controls = Array.from(root.querySelectorAll([
            'variant-selects input:not([type="hidden"])',
            'variant-selects select',
            '[data-ops-swing-tag-configurator] button',
            '[data-ops-swing-tag-configurator] input:not([type="hidden"])',
            '[data-ops-swing-tag-configurator] select',
            '[data-ops-swing-tag-configurator] textarea',
            '.custom-upload-block[data-preview-type="swing-tag"] button',
            '.custom-upload-block[data-preview-type="swing-tag"] input:not([type="hidden"])',
            '.custom-upload-block[data-preview-type="swing-tag"] select',
            '.custom-upload-block[data-preview-type="swing-tag"] textarea',
            'quantity-input input:not([type="hidden"])',
            '.quantity__input:not([type="hidden"])',
            'input[name="quantity"]:not([type="hidden"])'
          ].join(', ')));
          const uniqueControls = Array.from(new Set(controls));
          this.swingTagControlRestoreState = uniqueControls.map((control) => ({
            control,
            disabled: control.disabled,
            readOnly: 'readOnly' in control ? control.readOnly : undefined
          }));
          uniqueControls.forEach((control) => {
            if (control.tagName === 'TEXTAREA') {
              control.readOnly = true;
            } else {
              control.disabled = true;
            }
          });
          root.setAttribute('aria-busy', 'true');
          root.classList.add('ops-swing-tag-order-pending');
          return;
        }

        if (!this.swingTagControlsLocked) return;
        (this.swingTagControlRestoreState || []).forEach(({ control, disabled, readOnly }) => {
          if (!control.isConnected) return;
          if (readOnly !== undefined) control.readOnly = readOnly;
          control.disabled = disabled;
        });
        this.swingTagControlRestoreState = [];
        this.swingTagControlsLocked = false;
        root.removeAttribute('aria-busy');
        root.classList.remove('ops-swing-tag-order-pending');
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.querySelector('[data-card-standard-v2]')) {
          if (!window.OPSGreetingCardStandardV2 || !window.OPSGreetingCardStandardV2.validate(this)) return;
        }

        if (!this.validateNumberStickerField()) return;
        if (this.querySelector('[data-card-standard]')) {
          if (!window.OPSGreetingCardStandard) {
            this.handleErrorMessage('Please wait for the card options to load, then try again.');
            return;
          }
          if (!window.OPSGreetingCardStandard.validate(this)) return;
        }

        if (this.isSwingTagPreview()) {
          const doubleSided = String(this.swingTagSidesProperty?.value || '').toLowerCase() === 'double-sided';
          if (!this.swingTagFiles.front) {
            this.handleErrorMessage('Choose front artwork before adding the tags to your basket.');
            this.uploadStatus.textContent = 'Choose a front design from My Artwork or upload one from your device.';
            this.querySelector('[data-stg-my-artwork="front"]')?.focus();
            return;
          }
          if (doubleSided && !this.swingTagFiles.back) {
            this.handleErrorMessage('Choose separate front and back artwork for double-sided printing.');
            this.uploadStatus.textContent = 'A back design is required when double-sided printing is selected.';
            this.querySelector('[data-stg-my-artwork="back"]')?.focus();
            return;
          }
        }

        if (this.uploadInput && this.isArtworkUploading) {
          this.handleErrorMessage('Please wait for your artwork to finish uploading.');
          return;
        }

        if (!this.isSwingTagPreview() && this.uploadInput && this.uploadTokenInput && !this.uploadTokenInput.value) {
          this.handleErrorMessage('Please upload your artwork before adding to cart.');
          return;
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        if (this.isSwingTagPreview()) this.lockSwingTagControls(true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        let mugProductionProperties = null;
        try {
          if (this.isSwingTagPreview()) {
            await this.uploadSwingTagArtwork();
          } else if (this.uploadBlock?.dataset.productHandle === 'custom-printed-mug' && this.previewType === 'mug' && this.getVariantTitle() === 'Full Wrap') {
            if (!window.OPSMugProduction) throw new Error('The mug artwork tools have not loaded. Please refresh and try again.');
            mugProductionProperties = await window.OPSMugProduction.prepare(this);
          } else {
            await this.ensureArtworkPreviewUploaded();
          }
        } catch (error) {
          console.error(error);
          const message = error?.message || 'We could not save the artwork preview. Please try again.';
          this.handleErrorMessage(message);
          if (this.uploadStatus) this.uploadStatus.textContent = message;
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          this.lockSwingTagControls(false);
          return;
        }

        if (this.isFlagPreview() && this.flagPackageData?.packageEnabled) {
          await this.addFlagPackageToCart(evt);
          return;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        if (mugProductionProperties) {
          Object.entries(mugProductionProperties).forEach(([name, value]) => formData.set(name, value));
        }

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            if (this.uploadInput) this.clearSelectedArtwork();
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.lockSwingTagControls(false);
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEventForItems(items) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent || !Array.isArray(items) || !items.length) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: items.map((item) => ({ merchandiseId: item.id, quantity: item.quantity })),
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise =
          typeof CartItems !== 'undefined'
            ? CartItems.fetchCartData()
            : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

